(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kFnom", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $f0b9c827aaaa0993$export$6503ec6e8aabbaf; }, function (v) { return $f0b9c827aaaa0993$export$6503ec6e8aabbaf = v; });
var $f0b9c827aaaa0993$export$6503ec6e8aabbaf;
var $f0b9c827aaaa0993$export$f7ad0328861e2f03;
"use strict";
var $f0b9c827aaaa0993$var$mapping = new Map();
function $f0b9c827aaaa0993$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f0b9c827aaaa0993$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f0b9c827aaaa0993$var$resolve(id) {
    var resolved = $f0b9c827aaaa0993$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f0b9c827aaaa0993$export$6503ec6e8aabbaf = $f0b9c827aaaa0993$var$register;
$f0b9c827aaaa0993$export$f7ad0328861e2f03 = $f0b9c827aaaa0993$var$resolve;

});

parcelRegister("izFpB", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $d85b9e6cda9774e5$export$bdfd709ae4826697; }, function (v) { return $d85b9e6cda9774e5$export$bdfd709ae4826697 = v; });
var $d85b9e6cda9774e5$export$bdfd709ae4826697;
var $d85b9e6cda9774e5$export$c9e73fbda7da57b6;
var $d85b9e6cda9774e5$export$5a759dc7a1cfb72a;
"use strict";
var $d85b9e6cda9774e5$var$bundleURL = {};
function $d85b9e6cda9774e5$var$getBundleURLCached(id) {
    var value = $d85b9e6cda9774e5$var$bundleURL[id];
    if (!value) {
        value = $d85b9e6cda9774e5$var$getBundleURL();
        $d85b9e6cda9774e5$var$bundleURL[id] = value;
    }
    return value;
}
function $d85b9e6cda9774e5$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $d85b9e6cda9774e5$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $d85b9e6cda9774e5$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $d85b9e6cda9774e5$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$d85b9e6cda9774e5$export$bdfd709ae4826697 = $d85b9e6cda9774e5$var$getBundleURLCached;
$d85b9e6cda9774e5$export$c9e73fbda7da57b6 = $d85b9e6cda9774e5$var$getBaseURL;
$d85b9e6cda9774e5$export$5a759dc7a1cfb72a = $d85b9e6cda9774e5$var$getOrigin;

});

var $b91c709560b8e00a$exports = {};


(parcelRequire("kFnom")).register((parcelRequire("izFpB")).getBundleURL('hXipH'), JSON.parse("[\"hXipH\",\"index.98467fd8.js\",\"3L7HZ\",\"../img/marker.cf2a53b0.webp\",\"dXgDO\",\"../img/marker.cd558e3c.png\",\"fkhEC\",\"../img/marker.b594a3a6.avif\",\"eh4iY\",\"../img/marker.fba501e5.png\",\"gocRD\",\"../img/marker.a1ecd672.avif\",\"aAjjY\",\"../img/marker.1c0d9437.webp\",\"lMeK1\",\"../img/marker.67b1ebb5.png\",\"9EttW\",\"../img/marker.d042c242.avif\",\"dcnRe\",\"../img/marker.b6ee239b.webp\",\"2QU2s\",\"../img/Agate_Fossil_beds_01b.2a368bd1.avif\",\"wpUHC\",\"../img/Agate_Fossil_beds_01b.62b60192.avif\",\"cb5Fn\",\"../img/Agate_Fossil_beds_01b.84bc5fba.avif\",\"h9sCH\",\"../img/Agate_Fossil_beds_01b.fa7f8253.avif\",\"cjsRZ\",\"../img/Agate_Fossil_beds_01b.85de55d5.webp\",\"4s7hb\",\"../img/Agate_Fossil_beds_01b.ebcfc278.webp\",\"92yAU\",\"../img/Agate_Fossil_beds_01b.a8ae072c.webp\",\"cBOSL\",\"../img/Agate_Fossil_beds_01b.077bc87e.webp\",\"5HjX8\",\"../img/Agate_Fossil_beds_01b.ba77ee9c.png\",\"fblga\",\"../img/Agate_Fossil_beds_01b.cb1220a7.png\",\"vlQCB\",\"../img/Agate_Fossil_beds_01b.ef11c4f2.png\",\"7TEHN\",\"../img/Agate_Fossil_beds_01b.214492eb.png\",\"9GfhN\",\"../img/Djadochta_formation_01.a11e78aa.avif\",\"cGshL\",\"../img/Djadochta_formation_01.dfde4ac3.avif\",\"iYYLp\",\"../img/Djadochta_formation_01.b9c59303.avif\",\"f8ktl\",\"../img/Djadochta_formation_01.6d34be60.avif\",\"7hB54\",\"../img/Djadochta_formation_01.a341fa00.webp\",\"2ubpb\",\"../img/Djadochta_formation_01.326eec2c.webp\",\"76M9e\",\"../img/Djadochta_formation_01.feed5014.webp\",\"eE1Or\",\"../img/Djadochta_formation_01.b808b07b.webp\",\"e3ICG\",\"../img/Djadochta_formation_01.3a39004e.png\",\"cQXru\",\"../img/Djadochta_formation_01.63079736.png\",\"gJzNS\",\"../img/Djadochta_formation_01.39915091.png\",\"ilTCV\",\"../img/Djadochta_formation_01.95975e57.png\",\"lkakW\",\"../img/Elliot_Formatio_02.92cf9934.avif\",\"a0Rfm\",\"../img/Elliot_Formatio_02.046a05d3.avif\",\"aAI6S\",\"../img/Elliot_Formatio_02.6a943fb8.avif\",\"3hkag\",\"../img/Elliot_Formatio_02.de525876.avif\",\"dr7CK\",\"../img/Elliot_Formatio_02.2e7bc9de.webp\",\"4eM9S\",\"../img/Elliot_Formatio_02.15335951.webp\",\"fJ7da\",\"../img/Elliot_Formatio_02.f1ef09d2.webp\",\"iHc4T\",\"../img/Elliot_Formatio_02.8dc88401.webp\",\"izdw0\",\"../img/Elliot_Formatio_02.08dad79e.png\",\"4Msr3\",\"../img/Elliot_Formatio_02.5925a654.png\",\"c5x0E\",\"../img/Elliot_Formatio_02.a1e30bb4.png\",\"lOv5T\",\"../img/Gargano_01b.0fa11609.png\",\"9m4zu\",\"../img/Gargano_01b.25aa4be3.avif\",\"lNfzH\",\"../img/Gargano_01b.4a392f9a.avif\",\"fgsw2\",\"../img/Gargano_01b.0b666e7b.avif\",\"14spZ\",\"../img/Gargano_01b.acfdfd51.avif\",\"gv2qr\",\"../img/Gargano_01b.7304aacb.webp\",\"1V200\",\"../img/Gargano_01b.2af70c43.webp\",\"g0TUY\",\"../img/Gargano_01b.f2f26d44.webp\",\"i8JvL\",\"../img/Gargano_01b.27e26f1d.webp\",\"k8nAU\",\"../img/Gargano_01b.4e3cf911.png\",\"8HcXB\",\"../img/Gargano_01b.2ecc1208.png\",\"loR9l\",\"../img/Gargano_01b.fd33f908.png\",\"hgMiA\",\"../img/Gogo_formation.830adbbd.avif\",\"ieHcV\",\"../img/Gogo_formation.8a5b41ee.avif\",\"4sJLQ\",\"../img/Gogo_formation.4f758cb6.avif\",\"1gRy9\",\"../img/Gogo_formation.aec9f5ed.avif\",\"2pMH1\",\"../img/Gogo_formation.776b12bd.webp\",\"4hhWS\",\"../img/Gogo_formation.66d618e3.webp\",\"kaGm6\",\"../img/Gogo_formation.8ff02e83.webp\",\"6rfmp\",\"../img/Gogo_formation.1226e976.webp\",\"gHCIu\",\"../img/Gogo_formation.d05b598b.png\",\"78HrP\",\"../img/Gogo_formation.2ce69a5e.png\",\"igRoY\",\"../img/Gogo_formation.29fc1d8e.png\",\"4RmWe\",\"../img/Gogo_formation.ff128506.png\",\"i4GnY\",\"../img/Hammerschmiede_b.b7b205ba.avif\",\"dwB2v\",\"../img/Hammerschmiede_b.b1908e9e.avif\",\"etuxi\",\"../img/Hammerschmiede_b.bfeb288f.avif\",\"loa8o\",\"../img/Hammerschmiede_b.aef696fb.avif\",\"hkgLD\",\"../img/Hammerschmiede_b.e51c8ef4.webp\",\"lbYm9\",\"../img/Hammerschmiede_b.15588104.webp\",\"3Y7ml\",\"../img/Hammerschmiede_b.3df6b768.webp\",\"fydHe\",\"../img/Hammerschmiede_b.96a4048f.webp\",\"emnVC\",\"../img/Hammerschmiede_b.202bf1e1.png\",\"bcA3V\",\"../img/Hammerschmiede_b.1dd73a96.png\",\"XSYSK\",\"../img/Hammerschmiede_b.2769224e.png\",\"2gZIs\",\"../img/Hammerschmiede_b.dd87f709.png\",\"6NYdj\",\"../img/Hornerstown_formation_01.128d3941.avif\",\"413Ua\",\"../img/Hornerstown_formation_01.db90702c.avif\",\"8MoZP\",\"../img/Hornerstown_formation_01.6c180373.avif\",\"53Yyc\",\"../img/Hornerstown_formation_01.8d59f03a.avif\",\"lOaza\",\"../img/Hornerstown_formation_01.0eeb7864.webp\",\"1oLtc\",\"../img/Hornerstown_formation_01.992bf6ab.webp\",\"fvUjB\",\"../img/Hornerstown_formation_01.9b995da4.webp\",\"aUFAY\",\"../img/Hornerstown_formation_01.a8094cee.webp\",\"hniJf\",\"../img/Hornerstown_formation_01.2ddf926a.png\",\"af5nR\",\"../img/Hornerstown_formation_01.eed26b11.png\",\"3Ly0J\",\"../img/Hornerstown_formation_01.e329aea3.png\",\"gSYYb\",\"../img/Hornerstown_formation_01.cffc7a6d.png\",\"hph0c\",\"../img/irdin_manha_formation_01.05bfb005.avif\",\"JTaIW\",\"../img/irdin_manha_formation_01.368c3e7e.avif\",\"2phTg\",\"../img/irdin_manha_formation_01.14115579.avif\",\"l2r7m\",\"../img/irdin_manha_formation_01.01b36026.avif\",\"aMnne\",\"../img/irdin_manha_formation_01.44590001.webp\",\"4WuCV\",\"../img/irdin_manha_formation_01.bb75fe94.webp\",\"5LvHl\",\"../img/irdin_manha_formation_01.433874d3.webp\",\"eumwP\",\"../img/irdin_manha_formation_01.17b35bbf.webp\",\"j76Ru\",\"../img/irdin_manha_formation_01.214903c9.png\",\"gBwTf\",\"../img/irdin_manha_formation_01.c035481f.png\",\"v0RXC\",\"../img/irdin_manha_formation_01.8d1c1b62.png\",\"huR4J\",\"../img/Ischigualasto.2456f746.avif\",\"iR86K\",\"../img/Ischigualasto.62f270b5.avif\",\"2ZXYX\",\"../img/Ischigualasto.ccb22290.avif\",\"bxM8A\",\"../img/Ischigualasto.bae88197.avif\",\"3z1v4\",\"../img/Ischigualasto.081a62d1.webp\",\"gPkyF\",\"../img/Ischigualasto.c314e52f.webp\",\"foFAp\",\"../img/Ischigualasto.7db768f8.webp\",\"bVnch\",\"../img/Ischigualasto.8e5900d8.webp\",\"u4iMH\",\"../img/Ischigualasto.3543d72e.png\",\"b3WQP\",\"../img/Ischigualasto.bf55734a.png\",\"3GoSP\",\"../img/Ischigualasto.43422761.png\",\"f0pEy\",\"../img/Ischigualasto.a9e75792.png\",\"61QyX\",\"../img/Jialingjiang_Formation.d82a6854.avif\",\"dXzQ0\",\"../img/Jialingjiang_Formation.0f3c6ddd.avif\",\"2INgj\",\"../img/Jialingjiang_Formation.d706b65b.avif\",\"8gWZi\",\"../img/Jialingjiang_Formation.0c75dcd7.avif\",\"jW7hz\",\"../img/Jialingjiang_Formation.deb1b3bc.webp\",\"6TQbj\",\"../img/Jialingjiang_Formation.be85255b.webp\",\"7fWq2\",\"../img/Jialingjiang_Formation.68a9fc83.webp\",\"lGx5E\",\"../img/Jialingjiang_Formation.cdd75a8d.webp\",\"hwB9G\",\"../img/Jialingjiang_Formation.b5b2ef08.png\",\"7zMwu\",\"../img/Jialingjiang_Formation.d4516710.png\",\"fdpUI\",\"../img/Jialingjiang_Formation.2db37eb6.png\",\"7WLd7\",\"../img/Jialingjiang_Formation.dbd498ba.png\",\"jBG7K\",\"../img/Joggins_Formation_01b.32da46a4.avif\",\"2lnIu\",\"../img/Joggins_Formation_01b.29a83ace.avif\",\"dGqGR\",\"../img/Joggins_Formation_01b.a8188233.avif\",\"eTVwY\",\"../img/Joggins_Formation_01b.bb53b5e7.avif\",\"4S9kJ\",\"../img/Joggins_Formation_01b.b86d5b89.webp\",\"7u74n\",\"../img/Joggins_Formation_01b.4e29b56b.webp\",\"bbTVi\",\"../img/Joggins_Formation_01b.6e01b071.webp\",\"9MRLP\",\"../img/Joggins_Formation_01b.e2f19722.webp\",\"fw9d5\",\"../img/Joggins_Formation_01b.2856361a.png\",\"hkmf8\",\"../img/Joggins_Formation_01b.db292f46.png\",\"4dGIg\",\"../img/Joggins_Formation_01b.a9e766fe.png\",\"bi9d0\",\"../img/Judith_River.4f78f278.avif\",\"2Snx6\",\"../img/Judith_River.ba6fc33e.avif\",\"i5t6E\",\"../img/Judith_River.fe9a0006.avif\",\"BYR6Y\",\"../img/Judith_River.b77b765a.avif\",\"3Wq39\",\"../img/Judith_River.c32cc4b0.webp\",\"3fKej\",\"../img/Judith_River.99dae702.webp\",\"2Nlbk\",\"../img/Judith_River.4575579b.webp\",\"cQTco\",\"../img/Judith_River.ea0c931f.webp\",\"besaL\",\"../img/Judith_River.b900e733.png\",\"jwL1S\",\"../img/Judith_River.5a5fb7dd.png\",\"dkDhB\",\"../img/Judith_River.8a0db008.png\",\"8qJNf\",\"../img/Judith_River.8cdb8504.png\",\"b1bh0\",\"../img/Kuanti_01b.dbd06260.avif\",\"4WDDc\",\"../img/Kuanti_01b.8f058e51.avif\",\"bb6Xy\",\"../img/Kuanti_01b.4eefc16b.avif\",\"itVUH\",\"../img/Kuanti_01b.2e8e96c5.avif\",\"1JTGR\",\"../img/Kuanti_01b.e2adac55.webp\",\"lTz8L\",\"../img/Kuanti_01b.7bf71fdc.webp\",\"f21da\",\"../img/Kuanti_01b.400ed4f0.webp\",\"1BSKW\",\"../img/Kuanti_01b.5341f79c.webp\",\"amQUz\",\"../img/Kuanti_01b.7a6f4d97.png\",\"frD7y\",\"../img/Kuanti_01b.06930e08.png\",\"hmZeU\",\"../img/Kuanti_01b.86a6afa8.png\",\"ky0YR\",\"../img/Kuanti_01b.40a11bfb.png\",\"83gWV\",\"../img/Mammoth_Site_01.42e4969f.avif\",\"bRTpB\",\"../img/Mammoth_Site_01.18113871.avif\",\"TH7mS\",\"../img/Mammoth_Site_01.3692bc1f.avif\",\"9b3sg\",\"../img/Mammoth_Site_01.55f388c2.avif\",\"86mTN\",\"../img/Mammoth_Site_01.047953dd.webp\",\"fgrF0\",\"../img/Mammoth_Site_01.53e49039.webp\",\"1Jbfl\",\"../img/Mammoth_Site_01.086b9568.webp\",\"gGsTT\",\"../img/Mammoth_Site_01.e21debea.webp\",\"hLWA0\",\"../img/Mammoth_Site_01.9c89b185.png\",\"idKbT\",\"../img/Mammoth_Site_01.60fb1a8d.png\",\"7PtYi\",\"../img/Mammoth_Site_01.70295183.png\",\"9SCY9\",\"../img/Mammoth_Site_01.b97cc2d1.png\",\"171Fk\",\"../img/Monte_Bolca_01.06928825.avif\",\"j7tpX\",\"../img/Monte_Bolca_01.be23ec6d.avif\",\"ckuiW\",\"../img/Monte_Bolca_01.11cbab11.avif\",\"cbVBT\",\"../img/Monte_Bolca_01.98dbd1c6.avif\",\"hfOIK\",\"../img/Monte_Bolca_01.bf4e6600.webp\",\"isqi9\",\"../img/Monte_Bolca_01.aeec9f70.webp\",\"1EBdW\",\"../img/Monte_Bolca_01.9168cd04.webp\",\"7kmAx\",\"../img/Monte_Bolca_01.6f0dee1e.webp\",\"g2pnp\",\"../img/Monte_Bolca_01.1e370a87.png\",\"9kbn1\",\"../img/Monte_Bolca_01.47f97fc7.png\",\"5RqtT\",\"../img/Monte_Bolca_01.87da5272.png\",\"aSbsm\",\"../img/Monte_Bolca_01.c32395ae.png\",\"iqV4H\",\"../img/MOTH_locality_01b.3fc33aff.avif\",\"45TBv\",\"../img/MOTH_locality_01b.e9e27789.avif\",\"eB8l7\",\"../img/MOTH_locality_01b.33a1f063.avif\",\"1dw3k\",\"../img/MOTH_locality_01b.02f74139.avif\",\"iQgsm\",\"../img/MOTH_locality_01b.bd405b29.webp\",\"iBFMm\",\"../img/MOTH_locality_01b.b2bf1573.webp\",\"lyVph\",\"../img/MOTH_locality_01b.364763e7.webp\",\"bistS\",\"../img/MOTH_locality_01b.45979b56.webp\",\"bc04L\",\"../img/MOTH_locality_01b.ed14829e.png\",\"6i5do\",\"../img/MOTH_locality_01b.d07bcdc0.png\",\"9eJV1\",\"../img/MOTH_locality_01b.37661166.png\",\"gV2rY\",\"../img/MOTH_locality_01b.58dc6175.png\",\"9NKKg\",\"../img/Ocher_Assamblage_01.8276380f.avif\",\"fLicT\",\"../img/Ocher_Assamblage_01.93858f39.avif\",\"2JaUA\",\"../img/Ocher_Assamblage_01.2c59156b.avif\",\"2xvcX\",\"../img/Ocher_Assamblage_01.ad22d375.avif\",\"gGVJj\",\"../img/Ocher_Assamblage_01.0846e5b0.webp\",\"dmVlY\",\"../img/Ocher_Assamblage_01.a05821f6.webp\",\"cESIR\",\"../img/Ocher_Assamblage_01.e999be8d.webp\",\"5h1MJ\",\"../img/Ocher_Assamblage_01.fb6f10a3.webp\",\"9dUbP\",\"../img/Ocher_Assamblage_01.1d83c51c.png\",\"9M5qO\",\"../img/Ocher_Assamblage_01.dade2eaf.png\",\"ln8I7\",\"../img/Ocher_Assamblage_01.87e61964.png\",\"iSpAi\",\"../img/Ocher_Assamblage_01.b6e28fce.png\",\"4r1vt\",\"../img/Patrick_Burn_formation_01.93d6a89f.avif\",\"gtPju\",\"../img/Patrick_Burn_formation_01.0e2f94ff.avif\",\"5rh2w\",\"../img/Patrick_Burn_formation_01.ce6be306.avif\",\"5HSeP\",\"../img/Patrick_Burn_formation_01.a740e600.avif\",\"hYQa6\",\"../img/Patrick_Burn_formation_01.7afb985f.webp\",\"1AmTe\",\"../img/Patrick_Burn_formation_01.cb294334.webp\",\"fwxbi\",\"../img/Patrick_Burn_formation_01.d58e05a0.webp\",\"5qyV6\",\"../img/Patrick_Burn_formation_01.806315f3.webp\",\"gQCCM\",\"../img/Patrick_Burn_formation_01.00d4af51.png\",\"2PYnj\",\"../img/Patrick_Burn_formation_01.d78d5992.png\",\"gYHbK\",\"../img/Patrick_Burn_formation_01.96a9bcb2.png\",\"4UUcL\",\"../img/Patrick_Burn_formation_01.19921d92.png\",\"5dn39\",\"../img/Rhynie_Chert.812ddf72.avif\",\"ayptu\",\"../img/Rhynie_Chert.4a62ee86.avif\",\"aXswP\",\"../img/Rhynie_Chert.995fee08.avif\",\"fqzic\",\"../img/Rhynie_Chert.040e69ae.avif\",\"7MQyj\",\"../img/Rhynie_Chert.43e6c4d4.webp\",\"dQKmE\",\"../img/Rhynie_Chert.c8aa8fd6.webp\",\"tuKfy\",\"../img/Rhynie_Chert.9d366dbd.webp\",\"3DmPR\",\"../img/Rhynie_Chert.dc2aa9c5.webp\",\"44Ik3\",\"../img/Rhynie_Chert.e35faaf4.png\",\"1fGjQ\",\"../img/Rhynie_Chert.1a770c4f.png\",\"edy9p\",\"../img/Rhynie_Chert.80061bce.png\",\"4EAeI\",\"../img/Rhynie_Chert.c7500e7e.png\",\"1PEGT\",\"../img/Seaham_formation.38a59f36.avif\",\"4tpOb\",\"../img/Seaham_formation.725940fb.avif\",\"gr2VQ\",\"../img/Seaham_formation.98047e16.avif\",\"2LnMt\",\"../img/Seaham_formation.076d8041.avif\",\"10ajY\",\"../img/Seaham_formation.e21e350b.webp\",\"knaAC\",\"../img/Seaham_formation.d39e5804.webp\",\"bFQQA\",\"../img/Seaham_formation.8164508d.webp\",\"i8p81\",\"../img/Seaham_formation.ee1af9d4.webp\",\"8pV2D\",\"../img/Seaham_formation.3598c542.png\",\"apOCl\",\"../img/Seaham_formation.8b31048f.png\",\"2a8uz\",\"../img/Seaham_formation.4b4abef2.png\",\"bN1CQ\",\"../img/Seaham_formation.e7e07db4.png\",\"27XAj\",\"../img/Sirius_Passet.e177e970.avif\",\"eHG9c\",\"../img/Sirius_Passet.69f1a7bf.avif\",\"kL6Wm\",\"../img/Sirius_Passet.15a72588.avif\",\"kAIQL\",\"../img/Sirius_Passet.7fd19a20.avif\",\"dBQcs\",\"../img/Sirius_Passet.c61686cf.webp\",\"4CjKL\",\"../img/Sirius_Passet.d0aa58d1.webp\",\"cTYdq\",\"../img/Sirius_Passet.e1481e66.webp\",\"6ZP17\",\"../img/Sirius_Passet.c58e88b9.webp\",\"2SRe7\",\"../img/Sirius_Passet.226a2fea.png\",\"4TaIu\",\"../img/Sirius_Passet.388961ab.png\",\"cYQHZ\",\"../img/Sirius_Passet.ac5eaeff.png\",\"2pvfo\",\"../img/Sirius_Passet.f351eef5.png\",\"e3qxV\",\"../img/Solnhofen_01.8fec2171.avif\",\"piKsA\",\"../img/Solnhofen_01.cb11b656.avif\",\"cFcQY\",\"../img/Solnhofen_01.4108ff4f.avif\",\"cKUi8\",\"../img/Solnhofen_01.3a36cc59.avif\",\"bHc4O\",\"../img/Solnhofen_01.3994654a.webp\",\"c9QXg\",\"../img/Solnhofen_01.304440c1.webp\",\"jnyoV\",\"../img/Solnhofen_01.29f8f004.webp\",\"i6ZBT\",\"../img/Solnhofen_01.d4b43208.webp\",\"bnuml\",\"../img/Solnhofen_01.ae914e31.png\",\"9UxVC\",\"../img/Solnhofen_01.91cb535f.png\",\"cFdJj\",\"../img/Solnhofen_01.86d2b18f.png\",\"cFTeh\",\"../img/Solnhofen_01.7b3a6aef.png\",\"9glNG\",\"../img/Talara_Tar_Seeps_06.4ac651ba.avif\",\"iOvXr\",\"../img/Talara_Tar_Seeps_06.cac5ed3e.avif\",\"az2lp\",\"../img/Talara_Tar_Seeps_06.a63343e9.avif\",\"32LSi\",\"../img/Talara_Tar_Seeps_06.d2b53527.avif\",\"gCM90\",\"../img/Talara_Tar_Seeps_06.2d9b10bb.webp\",\"3BuJu\",\"../img/Talara_Tar_Seeps_06.b6b384f5.webp\",\"9UIJv\",\"../img/Talara_Tar_Seeps_06.4b30eea4.webp\",\"eM7oE\",\"../img/Talara_Tar_Seeps_06.a906b950.webp\",\"if8Y2\",\"../img/Talara_Tar_Seeps_06.bb463991.png\",\"3XV8w\",\"../img/Talara_Tar_Seeps_06.ca8ed729.png\",\"eLmG9\",\"../img/Talara_Tar_Seeps_06.f9f974bd.png\",\"e77EV\",\"../img/Talara_Tar_Seeps_06.4d42c08d.png\",\"gQec9\",\"../img/Wadi_al_Hitan_01.7f507714.avif\",\"gjeJb\",\"../img/Wadi_al_Hitan_01.fb4dab1d.avif\",\"c8owp\",\"../img/Wadi_al_Hitan_01.dab1ebe9.avif\",\"l9QZ5\",\"../img/Wadi_al_Hitan_01.e01795ac.avif\",\"bTV3C\",\"../img/Wadi_al_Hitan_01.fc437fde.webp\",\"1zu3T\",\"../img/Wadi_al_Hitan_01.ea91e470.webp\",\"bHPn8\",\"../img/Wadi_al_Hitan_01.2d54fa3d.webp\",\"gGAYv\",\"../img/Wadi_al_Hitan_01.418348be.webp\",\"kOFIk\",\"../img/Wadi_al_Hitan_01.775ce006.png\",\"794K2\",\"../img/Wadi_al_Hitan_01.1ceec059.png\",\"bL8Iw\",\"../img/Wadi_al_Hitan_01.ef9ea8ce.png\",\"egDB6\",\"../img/Wadi_al_Hitan_01.eb36679b.png\",\"Ybkmy\",\"../img/ArcherCity.52bef8fe.avif\",\"fw2No\",\"../img/ArcherCity.dba77c07.avif\",\"hyVcZ\",\"../img/ArcherCity.6b94cc49.avif\",\"dUz2t\",\"../img/ArcherCity.eab20a68.avif\",\"lxs82\",\"../img/ArcherCity.2daa8c61.webp\",\"2QCXS\",\"../img/ArcherCity.98a0a467.webp\",\"60kZf\",\"../img/ArcherCity.b4774797.webp\",\"fMWoB\",\"../img/ArcherCity.dbbeb0d5.webp\",\"by0jg\",\"../img/ArcherCity.55c7f1bd.png\",\"dcjLX\",\"../img/ArcherCity.c05857d8.png\",\"4Ikxi\",\"../img/ArcherCity.142851e8.png\",\"28v8J\",\"../img/ArcherCity.b0b7f23f.png\",\"2ld2D\",\"../img/Bahariya_formation_01.e745975d.avif\",\"9RXtK\",\"../img/Bahariya_formation_01.38b349cb.avif\",\"iFYD7\",\"../img/Bahariya_formation_01.519b2f4e.avif\",\"2vu4D\",\"../img/Bahariya_formation_01.47a3b425.avif\",\"1WhTI\",\"../img/Bahariya_formation_01.4c8596e3.webp\",\"a5QOl\",\"../img/Bahariya_formation_01.71bce768.webp\",\"cff6B\",\"../img/Bahariya_formation_01.8635874c.webp\",\"ah2P2\",\"../img/Bahariya_formation_01.8a80235a.webp\",\"hL7VN\",\"../img/Bahariya_formation_01.98d4a3d4.png\",\"7Pmwj\",\"../img/Bahariya_formation_01.3d34aa71.png\",\"h4zdr\",\"../img/Bahariya_formation_01.427e56fe.png\",\"j79UE\",\"../img/Bahariya_formation_01.9b0c603b.png\",\"fsfsH\",\"../img/Ballagan formation.cfb46951.avif\",\"wDEUr\",\"../img/Ballagan formation.9e2ef90b.avif\",\"hcfj0\",\"../img/Ballagan formation.596c65f4.avif\",\"k8iQb\",\"../img/Ballagan formation.3ca35208.avif\",\"59MVa\",\"../img/Ballagan formation.d94fc1b7.webp\",\"3QCy2\",\"../img/Ballagan formation.426ca300.webp\",\"hlAIw\",\"../img/Ballagan formation.4a51bfc0.webp\",\"B1ixR\",\"../img/Ballagan formation.cd8863e4.webp\",\"2OBeP\",\"../img/Ballagan formation.ca1a906d.png\",\"aJSt0\",\"../img/Ballagan formation.9c8afcda.png\",\"jf9wc\",\"../img/Ballagan formation.95355722.png\",\"eaqEd\",\"../img/Ballagan formation.0b599147.png\",\"6EEaW\",\"../img/St_Bathans_Fauna.0e763547.avif\",\"4jWrR\",\"../img/St_Bathans_Fauna.f75ecede.avif\",\"e4Q99\",\"../img/St_Bathans_Fauna.b35f3bbe.avif\",\"hpleQ\",\"../img/St_Bathans_Fauna.05764656.avif\",\"dSFdc\",\"../img/St_Bathans_Fauna.40d3c4ef.webp\",\"8pDcz\",\"../img/St_Bathans_Fauna.dcaebcdc.webp\",\"27gRv\",\"../img/St_Bathans_Fauna.491dfe69.webp\",\"dzBNl\",\"../img/St_Bathans_Fauna.7b92f71d.webp\",\"dOi5N\",\"../img/St_Bathans_Fauna.ffec2614.png\",\"lwuJM\",\"../img/St_Bathans_Fauna.5625396d.png\",\"fGO4e\",\"../img/St_Bathans_Fauna.d809a3ec.png\",\"8F1I3\",\"../img/St_Bathans_Fauna.f2c5813a.png\",\"l9y3h\",\"../img/Besano_Formatio_beta.2a4b1eb6.avif\",\"i7VGD\",\"../img/Besano_Formatio_beta.c72c17ef.avif\",\"jxT3y\",\"../img/Besano_Formatio_beta.88afc411.avif\",\"gwdLj\",\"../img/Besano_Formatio_beta.f549a67b.avif\",\"DDZXV\",\"../img/Besano_Formatio_beta.c95e9b88.webp\",\"gv7bU\",\"../img/Besano_Formatio_beta.a5f734b9.webp\",\"461wf\",\"../img/Besano_Formatio_beta.c7020de1.webp\",\"38BHl\",\"../img/Besano_Formatio_beta.988f7c2c.webp\",\"h9nA5\",\"../img/Besano_Formatio_beta.5fab62d6.png\",\"lkRQK\",\"../img/Besano_Formatio_beta.fb7e0ae8.png\",\"cH5uW\",\"../img/Besano_Formatio_beta.25c2a31a.png\",\"8mwef\",\"../img/Besano_Formatio_beta.d8f224bb.png\",\"6auQx\",\"../img/LaBrea_1.038dfd81.avif\",\"kDpVk\",\"../img/LaBrea_1.d34d1c14.avif\",\"hZRI6\",\"../img/LaBrea_1.5093870c.avif\",\"h2WQh\",\"../img/LaBrea_1.21d81fa1.avif\",\"eBboe\",\"../img/LaBrea_1.fbd6d4e1.webp\",\"lpqxM\",\"../img/LaBrea_1.386d2868.webp\",\"jKieH\",\"../img/LaBrea_1.c6bc659d.webp\",\"eBQCf\",\"../img/LaBrea_1.2a170019.webp\",\"ljEBb\",\"../img/LaBrea_1.d2ed33cd.png\",\"UBOxw\",\"../img/LaBrea_1.c91648e7.png\",\"cNA8B\",\"../img/LaBrea_1.d53dff75.png\",\"1B6n0\",\"../img/LaBrea_1.ed7c7c6f.png\",\"31qwR\",\"../img/Bromacker.e49fd163.avif\",\"5qipx\",\"../img/Bromacker.6b80e327.avif\",\"eY5jX\",\"../img/Bromacker.f0118df7.avif\",\"8HzNP\",\"../img/Bromacker.e42882c1.avif\",\"7vF1n\",\"../img/Bromacker.ae4e7b26.webp\",\"lvJvl\",\"../img/Bromacker.5a8d3a28.webp\",\"3kTfb\",\"../img/Bromacker.00a45173.webp\",\"fKl1A\",\"../img/Bromacker.1fe6d485.webp\",\"aqUrR\",\"../img/Bromacker.c523729f.png\",\"1TP9G\",\"../img/Bromacker.75b79516.png\",\"ddRWz\",\"../img/Bromacker.0ce9ce90.png\",\"aTzH0\",\"../img/Bromacker.603fb494.png\",\"1ZuDo\",\"../img/Bugti_hills.5d853a89.avif\",\"1UiFN\",\"../img/Bugti_hills.b3d1c867.avif\",\"61ix0\",\"../img/Bugti_hills.4b2ac151.avif\",\"gQnqb\",\"../img/Bugti_hills.3f1acc83.avif\",\"8j3FY\",\"../img/Bugti_hills.eaa62d03.webp\",\"iJsd5\",\"../img/Bugti_hills.fac21f76.webp\",\"1ikCL\",\"../img/Bugti_hills.30440305.webp\",\"amXpv\",\"../img/Bugti_hills.a7ff8ff3.webp\",\"4sg4A\",\"../img/Bugti_hills.1ce73032.png\",\"gfdjY\",\"../img/Bugti_hills.a29fbcbf.png\",\"aYncg\",\"../img/Bugti_hills.081d23c0.png\",\"aP8mf\",\"../img/Bugti_hills.e52a63aa.png\",\"5Lqh4\",\"../img/Burgess_Shale_b.24b113f3.avif\",\"4d9SR\",\"../img/Burgess_Shale_b.ebb59b8d.avif\",\"4zY6S\",\"../img/Burgess_Shale_b.b71047e0.avif\",\"2XJFU\",\"../img/Burgess_Shale_b.9fb8d4c3.avif\",\"fMTPQ\",\"../img/Burgess_Shale_b.1bd4c9e2.webp\",\"4Wipx\",\"../img/Burgess_Shale_b.e4e5184f.webp\",\"8ZBtL\",\"../img/Burgess_Shale_b.1a400ab5.webp\",\"emZTk\",\"../img/Burgess_Shale_b.dbc4a816.webp\",\"29iKJ\",\"../img/Burgess_Shale_b.e92f2858.png\",\"fX6kf\",\"../img/Burgess_Shale_b.222d4cad.png\",\"6isVq\",\"../img/Burgess_Shale_b.5057fa20.png\",\"3a36O\",\"../img/Burgess_Shale_b.2df4e9d8.png\",\"6ILD2\",\"../img/Cabrieres.ad6ce181.avif\",\"6bOmT\",\"../img/Cabrieres.d28bff60.avif\",\"dBjbY\",\"../img/Cabrieres.d665e2be.avif\",\"kdPzq\",\"../img/Cabrieres.7bc97cf1.avif\",\"7ob2k\",\"../img/Cabrieres.46fa24df.webp\",\"9CuMI\",\"../img/Cabrieres.e38f3d2b.webp\",\"40p52\",\"../img/Cabrieres.433446b2.webp\",\"dbCLE\",\"../img/Cabrieres.ab4ef87d.webp\",\"iTpMA\",\"../img/Cabrieres.4713781c.png\",\"i2kiK\",\"../img/Cabrieres.7a93f235.png\",\"8zEwb\",\"../img/Cabrieres.dae2c2ca.png\",\"2deaQ\",\"../img/Cabrieres.72045f7e.png\",\"c8Yx5\",\"../img/Candeleros.25bc9f19.avif\",\"2h4j6\",\"../img/Candeleros.1bc371fe.avif\",\"lIt7z\",\"../img/Candeleros.66b0c843.avif\",\"wGwMb\",\"../img/Candeleros.53c83e6e.avif\",\"jYyvH\",\"../img/Candeleros.5df22a7d.webp\",\"w6j5q\",\"../img/Candeleros.603a3e42.webp\",\"8i8j8\",\"../img/Candeleros.098f5515.webp\",\"k4qOG\",\"../img/Candeleros.498c7bf9.webp\",\"c9gzD\",\"../img/Candeleros.b793ae70.png\",\"goubw\",\"../img/Candeleros.b51c296d.png\",\"a0Kpu\",\"../img/Candeleros.6a79f057.png\",\"eQX9n\",\"../img/Candeleros.96dabce6.png\",\"eM5Hu\",\"../img/chanares formation.5cac3b16.avif\",\"jfuxK\",\"../img/chanares formation.b7615e8b.avif\",\"4XBuf\",\"../img/chanares formation.3b62d17c.avif\",\"d2SkQ\",\"../img/chanares formation.7a85c7d9.avif\",\"1eSX6\",\"../img/chanares formation.bfbac417.webp\",\"gAbRh\",\"../img/chanares formation.0ef4473d.webp\",\"j8xPa\",\"../img/chanares formation.8d43023b.webp\",\"j4iWZ\",\"../img/chanares formation.9d6c3503.webp\",\"lt4kS\",\"../img/chanares formation.66681e64.png\",\"8pGp4\",\"../img/chanares formation.b7b3ee3e.png\",\"eZM0S\",\"../img/chanares formation.f406043a.png\",\"jCd4n\",\"../img/chanares formation.336f7a71.png\",\"bz60u\",\"../img/Chemnitz.698554a2.avif\",\"dqzvQ\",\"../img/Chemnitz.f39e31b6.avif\",\"d9iPp\",\"../img/Chemnitz.05cba09f.avif\",\"hxAi9\",\"../img/Chemnitz.cc97dbb0.avif\",\"jt87P\",\"../img/Chemnitz.6112ec21.webp\",\"6roHP\",\"../img/Chemnitz.5243ca59.webp\",\"l1JH9\",\"../img/Chemnitz.920e4527.webp\",\"1oGhL\",\"../img/Chemnitz.1c43a6c2.webp\",\"cVK2Q\",\"../img/Chemnitz.27ccc5cc.png\",\"iJ5IW\",\"../img/Chemnitz.93e8c13d.png\",\"jP0ZX\",\"../img/Chemnitz.22557802.png\",\"1fV52\",\"../img/Chemnitz.1d0d263b.png\",\"faQag\",\"../img/Cleveland_Shale_01.e3abbc84.avif\",\"bAVrs\",\"../img/Cleveland_Shale_01.b2690b61.avif\",\"bYyBL\",\"../img/Cleveland_Shale_01.3cea9339.avif\",\"v3HiM\",\"../img/Cleveland_Shale_01.1d68ee8a.avif\",\"aL8Te\",\"../img/Cleveland_Shale_01.de6f5e4f.webp\",\"keb75\",\"../img/Cleveland_Shale_01.093f9d07.webp\",\"3DcXF\",\"../img/Cleveland_Shale_01.13cdd65b.webp\",\"2coUZ\",\"../img/Cleveland_Shale_01.aa0f6db7.webp\",\"ctyxH\",\"../img/Cleveland_Shale_01.5098d6b7.png\",\"1CLxj\",\"../img/Cleveland_Shale_01.34d261c0.png\",\"4ek2B\",\"../img/Cleveland_Shale_01.4057bea5.png\",\"iSvD7\",\"../img/Cleveland_Shale_01.a44d40a1.png\",\"i98XA\",\"../img/Consthum_Quarry.558831ed.avif\",\"dZ8yY\",\"../img/Consthum_Quarry.4b72952c.avif\",\"eyDJ7\",\"../img/Consthum_Quarry.39eaf966.avif\",\"efeXK\",\"../img/Consthum_Quarry.94d4248f.avif\",\"esX8v\",\"../img/Consthum_Quarry.ebb129b6.webp\",\"bCPnN\",\"../img/Consthum_Quarry.01c7a696.webp\",\"b0Tr7\",\"../img/Consthum_Quarry.ec62962c.webp\",\"gbgaV\",\"../img/Consthum_Quarry.4e9f7956.webp\",\"2zAp9\",\"../img/Consthum_Quarry.90fdcb84.png\",\"6T0xq\",\"../img/Consthum_Quarry.05f4931c.png\",\"2lxxx\",\"../img/Consthum_Quarry.8056b7da.png\",\"9qe5k\",\"../img/Consthum_Quarry.d4e018df.png\",\"gp5qA\",\"../img/Crato_1.6ece631c.avif\",\"bwnLi\",\"../img/Crato_1.ef9f7c61.avif\",\"foWhr\",\"../img/Crato_1.830b47d9.avif\",\"3ITJr\",\"../img/Crato_1.edfbf2ba.avif\",\"dPtES\",\"../img/Crato_1.1dd59220.webp\",\"atXwh\",\"../img/Crato_1.1472219d.webp\",\"icK6b\",\"../img/Crato_1.311c6a92.webp\",\"lN1AJ\",\"../img/Crato_1.398b50f1.webp\",\"a97TH\",\"../img/Crato_1.116bef2c.png\",\"bDhuP\",\"../img/Crato_1.614555a5.png\",\"lBTma\",\"../img/Crato_1.fd126535.png\",\"9gB2N\",\"../img/Crato_1.69fce5a7.png\",\"4DI8t\",\"../img/Corral_bluffs.951bc913.avif\",\"4AJqr\",\"../img/Corral_bluffs.beab9b80.avif\",\"5WDos\",\"../img/Corral_bluffs.a34a2af5.avif\",\"AoFnV\",\"../img/Corral_bluffs.85482b34.avif\",\"9j4Hu\",\"../img/Corral_bluffs.8190017d.webp\",\"ibvaF\",\"../img/Corral_bluffs.0d9dd65f.webp\",\"iqcZH\",\"../img/Corral_bluffs.43e25c0d.webp\",\"d3TqC\",\"../img/Corral_bluffs.c5b6ca4a.webp\",\"5xamF\",\"../img/Corral_bluffs.66ac70bc.png\",\"idxk2\",\"../img/Corral_bluffs.2af5a939.png\",\"3KWYH\",\"../img/Corral_bluffs.35e5066d.png\",\"8o6vm\",\"../img/Corral_bluffs.ce06d5c2.png\",\"a3VUr\",\"../img/Dinosaur_Park.29a37606.avif\",\"f2Pny\",\"../img/Dinosaur_Park.4437249a.avif\",\"1m289\",\"../img/Dinosaur_Park.3361f9c3.avif\",\"inGXt\",\"../img/Dinosaur_Park.58e1fb56.avif\",\"8lSwT\",\"../img/Dinosaur_Park.d10dc005.webp\",\"69YLz\",\"../img/Dinosaur_Park.ecbcd0ed.webp\",\"bB6Jf\",\"../img/Dinosaur_Park.29a4e2d0.webp\",\"dTsmG\",\"../img/Dinosaur_Park.8839b674.webp\",\"ebUZH\",\"../img/Dinosaur_Park.2a6716c3.png\",\"1vBVA\",\"../img/Dinosaur_Park.1a147f91.png\",\"2mibO\",\"../img/Dinosaur_Park.9e65dd66.png\",\"c9D46\",\"../img/Dinosaur_Park.7793d673.png\",\"dy7ox\",\"../img/Ein_Yabrud_01.d902139e.avif\",\"i10xD\",\"../img/Ein_Yabrud_01.136dba77.avif\",\"285by\",\"../img/Ein_Yabrud_01.575d65cc.avif\",\"bDTYU\",\"../img/Ein_Yabrud_01.ebede1b0.avif\",\"eEUMf\",\"../img/Ein_Yabrud_01.c055c28e.webp\",\"2D884\",\"../img/Ein_Yabrud_01.7dd0795e.webp\",\"fgqmj\",\"../img/Ein_Yabrud_01.3a491cd4.webp\",\"kDeJ3\",\"../img/Ein_Yabrud_01.4b86e788.webp\",\"ahfvg\",\"../img/Ein_Yabrud_01.2f16fd5b.png\",\"b7QaG\",\"../img/Ein_Yabrud_01.36b5f929.png\",\"fjL60\",\"../img/Ein_Yabrud_01.d97f0260.png\",\"kAGmx\",\"../img/Ein_Yabrud_01.b25a6c52.png\",\"eofov\",\"../img/Elmo_01.39e115e3.avif\",\"fYQu1\",\"../img/Elmo_01.3db18bca.avif\",\"ekiyB\",\"../img/Elmo_01.a8d22df7.avif\",\"aKE6f\",\"../img/Elmo_01.859685eb.avif\",\"3FY0R\",\"../img/Elmo_01.faa80997.webp\",\"jhLe9\",\"../img/Elmo_01.3f128618.webp\",\"75nj8\",\"../img/Elmo_01.1ffa7d2b.webp\",\"3cTPF\",\"../img/Elmo_01.6c315d64.webp\",\"bkGVW\",\"../img/Elmo_01.91b26926.png\",\"79wgv\",\"../img/Elmo_01.2ebb3d66.png\",\"7su3w\",\"../img/Elmo_01.57aed099.png\",\"9sJtn\",\"../img/Elmo_01.280731f1.png\",\"l5gLq\",\"../img/Emu_bay_Shale.ce2d5922.avif\",\"kQ2Ta\",\"../img/Emu_bay_Shale.6c8f45fd.avif\",\"6j8jR\",\"../img/Emu_bay_Shale.1543a14a.avif\",\"84T6x\",\"../img/Emu_bay_Shale.b5f4222b.avif\",\"jO7om\",\"../img/Emu_bay_Shale.07cb14ff.webp\",\"3phDQ\",\"../img/Emu_bay_Shale.6a7e757b.webp\",\"gQ7zV\",\"../img/Emu_bay_Shale.6815ceaf.webp\",\"ktppu\",\"../img/Emu_bay_Shale.71bf0592.webp\",\"h0ZyW\",\"../img/Emu_bay_Shale.3f07c8d9.png\",\"2yqL5\",\"../img/Emu_bay_Shale.0b232aff.png\",\"aLkbP\",\"../img/Emu_bay_Shale.d944adb3.png\",\"kiB5W\",\"../img/Emu_bay_Shale.76c70c1a.png\",\"cPsN1\",\"../img/Ermaying_Formation_01.1520ba50.avif\",\"4m9Wj\",\"../img/Ermaying_Formation_01.2785337e.avif\",\"kXka3\",\"../img/Ermaying_Formation_01.fc20c31a.avif\",\"1UjoX\",\"../img/Ermaying_Formation_01.ca872586.avif\",\"8bU37\",\"../img/Ermaying_Formation_01.63636b02.webp\",\"ktkB6\",\"../img/Ermaying_Formation_01.5db4c9b8.webp\",\"cY4Ww\",\"../img/Ermaying_Formation_01.d53022ca.webp\",\"lnE6A\",\"../img/Ermaying_Formation_01.96ff80cc.webp\",\"fduqr\",\"../img/Ermaying_Formation_01.a4e4d1dd.png\",\"9BSYt\",\"../img/Ermaying_Formation_01.5fa2a3a8.png\",\"MaMxA\",\"../img/Ermaying_Formation_01.cf5113ff.png\",\"lJots\",\"../img/Ermaying_Formation_01.0248b78c.png\",\"ff29S\",\"../img/Escuminac_01.a98fd573.avif\",\"2jEWS\",\"../img/Escuminac_01.e2e11b94.avif\",\"90Jrg\",\"../img/Escuminac_01.57305f2a.avif\",\"aagfF\",\"../img/Escuminac_01.6cc4e407.avif\",\"lQloI\",\"../img/Escuminac_01.c7d1f776.webp\",\"6Own5\",\"../img/Escuminac_01.65e6665f.webp\",\"7QUoP\",\"../img/Escuminac_01.df55b5cd.webp\",\"eyneq\",\"../img/Escuminac_01.241a7351.webp\",\"2Zk29\",\"../img/Escuminac_01.5f3ff3c8.png\",\"6rBEo\",\"../img/Escuminac_01.8766435e.png\",\"2Mi9X\",\"../img/Escuminac_01.70188f4c.png\",\"6KRPc\",\"../img/Escuminac_01.dc937d0a.png\",\"ilhz0\",\"../img/Fezouata.941f888c.avif\",\"dtvH2\",\"../img/Fezouata.700df8d7.avif\",\"lE1Jt\",\"../img/Fezouata.12de0b6d.avif\",\"dJ9UD\",\"../img/Fezouata.5ef143e1.avif\",\"dA9bx\",\"../img/Fezouata.a61c2ac1.webp\",\"ln5dw\",\"../img/Fezouata.cab7e110.webp\",\"ap0Pq\",\"../img/Fezouata.635da728.webp\",\"h2oAV\",\"../img/Fezouata.3757c568.webp\",\"7ScrF\",\"../img/Fezouata.dfc778c5.png\",\"r2KIr\",\"../img/Flores.d1d199f8.avif\",\"7ofe0\",\"../img/Flores.129462ee.avif\",\"er9VF\",\"../img/Flores.33232b87.avif\",\"jnwxD\",\"../img/Flores.b2af7ca2.avif\",\"8QUxx\",\"../img/Flores.aa8fc8d3.webp\",\"8CerR\",\"../img/Flores.f1edadaf.webp\",\"7Kzu4\",\"../img/Flores.6780cd94.webp\",\"xlUpx\",\"../img/Flores.41107fa2.webp\",\"ejAFR\",\"../img/Flores.33813946.png\",\"kUp5D\",\"../img/Flores.98b67cdc.png\",\"4Ol36\",\"../img/Flores.20ecc7a7.png\",\"35Ci2\",\"../img/Flores.2d5278d5.png\",\"kccg5\",\"../img/Koobi_Fora_01.6942ff45.avif\",\"jsRLz\",\"../img/Koobi_Fora_01.78a0baea.avif\",\"gP6lQ\",\"../img/Koobi_Fora_01.779f14b0.avif\",\"8cLUU\",\"../img/Koobi_Fora_01.b389b8c4.avif\",\"3H5nu\",\"../img/Koobi_Fora_01.f44e20f4.webp\",\"hjtu8\",\"../img/Koobi_Fora_01.b7caa9dd.webp\",\"2UCOX\",\"../img/Koobi_Fora_01.3365e34f.webp\",\"52ptA\",\"../img/Koobi_Fora_01.477eeb38.webp\",\"51NZo\",\"../img/Koobi_Fora_01.8a6b041c.png\",\"hyGGr\",\"../img/Koobi_Fora_01.7325c70d.png\",\"2WMn1\",\"../img/Koobi_Fora_01.8c3c1b2c.png\",\"9ECPB\",\"../img/Koobi_Fora_01.65f01d17.png\",\"gmK0V\",\"../img/Giganothopithecus_Fauna.0c205094.avif\",\"dnP9R\",\"../img/Giganothopithecus_Fauna.62e2e748.avif\",\"16F4R\",\"../img/Giganothopithecus_Fauna.ad339dbf.avif\",\"8mVt4\",\"../img/Giganothopithecus_Fauna.d387c821.avif\",\"lQ8Oh\",\"../img/Giganothopithecus_Fauna.2bb54c49.webp\",\"4kMW8\",\"../img/Giganothopithecus_Fauna.31381389.webp\",\"bkriO\",\"../img/Giganothopithecus_Fauna.ba19bffe.webp\",\"6HRuw\",\"../img/Giganothopithecus_Fauna.f76ae15c.webp\",\"5BggH\",\"../img/Giganothopithecus_Fauna.f092b414.png\",\"lmuuZ\",\"../img/Giganothopithecus_Fauna.ba6a08bb.png\",\"1Kscq\",\"../img/Giganothopithecus_Fauna.fbde27fa.png\",\"7mTmI\",\"../img/Giganothopithecus_Fauna.594e5a9d.png\",\"5E3rf\",\"../img/Fossil_Butte.16076dd4.avif\",\"841F3\",\"../img/Fossil_Butte.291b239b.avif\",\"d7PVM\",\"../img/Fossil_Butte.369c15b7.avif\",\"fmSaK\",\"../img/Fossil_Butte.bd2ef29b.avif\",\"epCnU\",\"../img/Fossil_Butte.285174da.webp\",\"4IfOQ\",\"../img/Fossil_Butte.cc88de27.webp\",\"cf6ac\",\"../img/Fossil_Butte.29847d7c.webp\",\"aOx07\",\"../img/Fossil_Butte.a05aa363.webp\",\"gTdrT\",\"../img/Fossil_Butte.7c4a2224.png\",\"kPjsi\",\"../img/Fossil_Butte.6bf8b15c.png\",\"aorgt\",\"../img/Fossil_Butte.aaea4659.png\",\"eI55X\",\"../img/Fossil_Butte.c250b917.png\",\"4legS\",\"../img/Guimarota formation.e81248d1.avif\",\"70tJ1\",\"../img/Guimarota formation.e7e20274.avif\",\"jHMB6\",\"../img/Guimarota formation.7f156727.avif\",\"c847U\",\"../img/Guimarota formation.2a4a43e9.avif\",\"eMplN\",\"../img/Guimarota formation.05c12e01.webp\",\"6khkl\",\"../img/Guimarota formation.d5b2896e.webp\",\"2VItK\",\"../img/Guimarota formation.2c042233.webp\",\"1l3nY\",\"../img/Guimarota formation.3dace783.webp\",\"a6h7r\",\"../img/Guimarota formation.18e9865e.png\",\"j1N2p\",\"../img/Guimarota formation.e6ce809f.png\",\"01kmW\",\"../img/Guimarota formation.7c4def02.png\",\"23Pln\",\"../img/Guimarota formation.6a2cbb4e.png\",\"ldnlW\",\"../img/Bear_Gulch.7332e5ad.avif\",\"d86YD\",\"../img/Bear_Gulch.56066456.avif\",\"6kBQE\",\"../img/Bear_Gulch.1f1f869a.avif\",\"frSYY\",\"../img/Bear_Gulch.56087a9d.avif\",\"k7pSO\",\"../img/Bear_Gulch.585f716e.webp\",\"1lcz8\",\"../img/Bear_Gulch.eeacb384.webp\",\"6k18S\",\"../img/Bear_Gulch.786ecdf3.webp\",\"7B8Yg\",\"../img/Bear_Gulch.098026a5.webp\",\"9jTSv\",\"../img/Bear_Gulch.bc9934e1.png\",\"dsdT7\",\"../img/Bear_Gulch.fcdfeaca.png\",\"8q5xk\",\"../img/Bear_Gulch.3590cafe.png\",\"5uAE1\",\"../img/Bear_Gulch.77162e2a.png\",\"iI99O\",\"../img/Hanson formation.cdf62a6b.avif\",\"6whTP\",\"../img/Hanson formation.264d4111.avif\",\"69NhY\",\"../img/Hanson formation.141f35de.avif\",\"gNHQW\",\"../img/Hanson formation.d7ad7d71.avif\",\"1wUqM\",\"../img/Hanson formation.623b68bb.webp\",\"20lGj\",\"../img/Hanson formation.7e181536.webp\",\"iucuc\",\"../img/Hanson formation.a3c226bc.webp\",\"bjsVc\",\"../img/Hanson formation.cefd6f9d.webp\",\"bC67j\",\"../img/Hanson formation.901ba7c8.png\",\"9oXAr\",\"../img/Hanson formation.a407948b.png\",\"gaBCx\",\"../img/Hanson formation.4f433f63.png\",\"iAEc2\",\"../img/Hanson formation.fe5442fd.png\",\"3STGR\",\"../img/Hell_Creek_01.19ffd5be.avif\",\"kN19d\",\"../img/Hell_Creek_01.c761e70c.avif\",\"7tMsb\",\"../img/Hell_Creek_01.943e4cfc.avif\",\"2tuLE\",\"../img/Hell_Creek_01.39a487db.avif\",\"d9l1F\",\"../img/Hell_Creek_01.22de7f6f.webp\",\"3Qcsv\",\"../img/Hell_Creek_01.5d9d33b6.webp\",\"71EX9\",\"../img/Hell_Creek_01.28c3e6b3.webp\",\"iM9PO\",\"../img/Hell_Creek_01.1e3f434b.webp\",\"3th00\",\"../img/Hell_Creek_01.f8d24d38.png\",\"hMx1g\",\"../img/Hell_Creek_01.23dcaed8.png\",\"eBnKO\",\"../img/Hell_Creek_01.d83e6c15.png\",\"lET2K\",\"../img/Hell_Creek_01.437786ed.png\",\"cXCAF\",\"../img/Holocene_New_Zealand_01.86e4ad09.avif\",\"h5Dqp\",\"../img/Holocene_New_Zealand_01.e1319fc7.avif\",\"dLETk\",\"../img/Holocene_New_Zealand_01.651b0bae.avif\",\"gZj7Y\",\"../img/Holocene_New_Zealand_01.6e6e46ca.avif\",\"gyNm7\",\"../img/Holocene_New_Zealand_01.af1bab05.webp\",\"dMNkj\",\"../img/Holocene_New_Zealand_01.3cb37b24.webp\",\"1ZYoK\",\"../img/Holocene_New_Zealand_01.a09043d0.webp\",\"c3tvb\",\"../img/Holocene_New_Zealand_01.cc0ce9d2.webp\",\"9HMvR\",\"../img/Holocene_New_Zealand_01.80347e9b.png\",\"ayWy2\",\"../img/Holocene_New_Zealand_01.e0d13d88.png\",\"i0Atg\",\"../img/Holocene_New_Zealand_01.3bbdeba3.png\",\"jEiGJ\",\"../img/Holocene_New_Zealand_01.b70cd07e.png\",\"ghAPT\",\"../img/Hunsruck_slate1.ee3c3d43.avif\",\"2ECuJ\",\"../img/Hunsruck_slate1.25ad1d83.avif\",\"9oeQn\",\"../img/Hunsruck_slate1.03522a5d.avif\",\"cyG8e\",\"../img/Hunsruck_slate1.bf2c1e34.avif\",\"i8fQs\",\"../img/Hunsruck_slate1.1f18f965.webp\",\"5Debw\",\"../img/Hunsruck_slate1.4c1d242a.webp\",\"hXbUq\",\"../img/Hunsruck_slate1.6e1b67a6.webp\",\"27EIl\",\"../img/Hunsruck_slate1.a3b7dc1c.webp\",\"kJtNh\",\"../img/Hunsruck_slate1.83853af2.png\",\"2J0Mo\",\"../img/Hunsruck_slate1.37d266c3.png\",\"BbwrH\",\"../img/Hunsruck_slate1.62c45eec.png\",\"b9rUC\",\"../img/Hunsruck_slate1.1e89be8e.png\",\"9pEgH\",\"../img/Jebel_Qatrani.28ffec0b.avif\",\"lxOVh\",\"../img/Jebel_Qatrani.bbd5edfc.avif\",\"4AENp\",\"../img/Jebel_Qatrani.b4c00b44.avif\",\"1W1sm\",\"../img/Jebel_Qatrani.6a87deef.avif\",\"5UnMc\",\"../img/Jebel_Qatrani.3875a8b4.webp\",\"likvD\",\"../img/Jebel_Qatrani.dc13520b.webp\",\"dAxYc\",\"../img/Jebel_Qatrani.768a7dca.webp\",\"9RBb0\",\"../img/Jebel_Qatrani.83f7e58c.webp\",\"jGpDv\",\"../img/Jebel_Qatrani.5a529c4c.png\",\"9wCL0\",\"../img/Jebel_Qatrani.7c50c82f.png\",\"fbIHP\",\"../img/Jebel_Qatrani.4554ee2c.png\",\"11DbF\",\"../img/Jebel_Qatrani.26c4ff52.png\",\"6k6zR\",\"../img/Kimmeridge Clay.bac388b0.avif\",\"91fPt\",\"../img/Kimmeridge Clay.921bb01a.avif\",\"701Qy\",\"../img/Kimmeridge Clay.2f9995c0.avif\",\"9ioI0\",\"../img/Kimmeridge Clay.547d8ee1.avif\",\"3GzOh\",\"../img/Kimmeridge Clay.0dd0510d.webp\",\"3bwME\",\"../img/Kimmeridge Clay.d8d6e88a.webp\",\"33LzE\",\"../img/Kimmeridge Clay.f2ae700c.webp\",\"5EmL5\",\"../img/Kimmeridge Clay.7d92e0ef.webp\",\"9ouGR\",\"../img/Kimmeridge Clay.5f308bb8.png\",\"1jG6v\",\"../img/Kimmeridge Clay.a3a5669f.png\",\"lOH14\",\"../img/Kimmeridge Clay.0201a6b0.png\",\"eJ4R7\",\"../img/Kimmeridge Clay.2e0c6ef1.png\",\"cBiVO\",\"../img/Kuldana_formation_01.115d6f97.avif\",\"jZWXd\",\"../img/Kuldana_formation_01.ce51d522.avif\",\"5IWLR\",\"../img/Kuldana_formation_01.56b87b42.avif\",\"7fLRM\",\"../img/Kuldana_formation_01.5d1821d4.avif\",\"c4ZcY\",\"../img/Kuldana_formation_01.059f6c13.webp\",\"8zTEb\",\"../img/Kuldana_formation_01.6309852c.webp\",\"hyPMk\",\"../img/Kuldana_formation_01.de52847b.webp\",\"hBscF\",\"../img/Kuldana_formation_01.fc35a1a6.webp\",\"aadAh\",\"../img/Kuldana_formation_01.93757cd6.png\",\"85SPJ\",\"../img/Kuldana_formation_01.5b23fb78.png\",\"sNGPR\",\"../img/Kuldana_formation_01.359592fd.png\",\"5mPH3\",\"../img/Kuldana_formation_01.4641609c.png\",\"6j5CV\",\"../img/Las_Hoyas.c560e92d.avif\",\"jhjv0\",\"../img/Las_Hoyas.55e94e67.avif\",\"b1sA8\",\"../img/Las_Hoyas.06ef35f6.avif\",\"e0ATf\",\"../img/Las_Hoyas.6c74b53a.avif\",\"5vfPW\",\"../img/Las_Hoyas.62ada985.webp\",\"8KyOE\",\"../img/Las_Hoyas.d8c90908.webp\",\"3WMMR\",\"../img/Las_Hoyas.bc8832be.webp\",\"b6364\",\"../img/Las_Hoyas.af774caa.webp\",\"5yayv\",\"../img/Las_Hoyas.7aece5e9.png\",\"9dvva\",\"../img/Las_Hoyas.3d0a5a82.png\",\"01wuL\",\"../img/Las_Hoyas.491b9090.png\",\"1w0Vr\",\"../img/Las_Hoyas.8d2e3857.png\",\"3fUIL\",\"../img/Madagascar_piece.2f197fe4.avif\",\"iSs0D\",\"../img/Madagascar_piece.68734b3b.avif\",\"1bPnU\",\"../img/Madagascar_piece.8eda616c.avif\",\"9R92E\",\"../img/Madagascar_piece.63aada0b.avif\",\"ggzqd\",\"../img/Madagascar_piece.403c44e2.webp\",\"hTcie\",\"../img/Madagascar_piece.ad4e20fe.webp\",\"aEIfv\",\"../img/Madagascar_piece.861123df.webp\",\"i2BmO\",\"../img/Madagascar_piece.1a27c671.webp\",\"9awsD\",\"../img/Madagascar_piece.42790132.png\",\"jjhKE\",\"../img/Madagascar_piece.e55b7bdd.png\",\"hf40E\",\"../img/Madagascar_piece.107721d7.png\",\"a6qYQ\",\"../img/Madagascar_piece.d523944e.png\",\"7iB7N\",\"../img/Madygen_Formation.2276e135.avif\",\"cT1Tp\",\"../img/Madygen_Formation.4b503e58.avif\",\"lBLOG\",\"../img/Madygen_Formation.42183ce6.avif\",\"lMDJw\",\"../img/Madygen_Formation.1e2f9306.avif\",\"1pITQ\",\"../img/Madygen_Formation.3a9a3625.webp\",\"gZpie\",\"../img/Madygen_Formation.0625fe37.webp\",\"cOr3I\",\"../img/Madygen_Formation.b444727b.webp\",\"eWt3B\",\"../img/Madygen_Formation.631d779c.webp\",\"jXVA9\",\"../img/Madygen_Formation.879eb7db.png\",\"8qMkI\",\"../img/Madygen_Formation.a623b660.png\",\"efTwF\",\"../img/Madygen_Formation.6a456dba.png\",\"c4vKz\",\"../img/Madygen_Formation.3a84860d.png\",\"iXxiZ\",\"../img/Maevarano.d6bf305f.avif\",\"tvTjX\",\"../img/Maevarano.81c52790.avif\",\"ghOMp\",\"../img/Maevarano.875a2e9a.avif\",\"fy2ki\",\"../img/Maevarano.04708ede.avif\",\"49gPr\",\"../img/Maevarano.f703800d.webp\",\"jdnLd\",\"../img/Maevarano.b633c628.webp\",\"7sXIp\",\"../img/Maevarano.5ef3178b.webp\",\"dtH5n\",\"../img/Maevarano.fce9c01c.webp\",\"iVUdO\",\"../img/Maevarano.ddf35e30.png\",\"cUKgY\",\"../img/Maevarano.77d1ad21.png\",\"juXPr\",\"../img/Maevarano.2a559ac3.png\",\"5K6dh\",\"../img/Maevarano.1728da1b.png\",\"kYIf6\",\"../img/MazonCreek.bd8de089.avif\",\"k6Ecj\",\"../img/MazonCreek.39eafbae.avif\",\"k62P1\",\"../img/MazonCreek.0345c275.avif\",\"9GPKR\",\"../img/MazonCreek.8f92b66e.avif\",\"4mftZ\",\"../img/MazonCreek.0529a016.webp\",\"d6Wov\",\"../img/MazonCreek.682b0a14.webp\",\"eKoe9\",\"../img/MazonCreek.0ccca7ce.webp\",\"ggIIC\",\"../img/MazonCreek.e72d2c29.webp\",\"cEMSJ\",\"../img/MazonCreek.e6ece5b5.png\",\"iBgLI\",\"../img/MazonCreek.7374d837.png\",\"jMtuH\",\"../img/MazonCreek.78c939e4.png\",\"1dWZZ\",\"../img/MazonCreek.97689c83.png\",\"3b5Bq\",\"../img/Morrison_Formation.f079a1b1.avif\",\"gJRDJ\",\"../img/Morrison_Formation.69fa9927.avif\",\"fxOMy\",\"../img/Morrison_Formation.40e00ed3.avif\",\"exb1t\",\"../img/Morrison_Formation.47cc2bee.avif\",\"j8OZl\",\"../img/Morrison_Formation.bb1d9e4b.webp\",\"5OqPg\",\"../img/Morrison_Formation.88de6fbc.webp\",\"f5RyR\",\"../img/Morrison_Formation.b68d1b2a.webp\",\"3oEGw\",\"../img/Morrison_Formation.de6d6897.webp\",\"gs3vK\",\"../img/Morrison_Formation.2cd8addc.png\",\"ifWIb\",\"../img/Morrison_Formation.28dfa679.png\",\"7c0Xn\",\"../img/Morrison_Formation.9a64c4d5.png\",\"gYtnd\",\"../img/Morrison_Formation.ce00b7f0.png\",\"14jzC\",\"../img/Naracoorte_01.99c7a228.avif\",\"7nlwk\",\"../img/Naracoorte_01.bc97c9a6.avif\",\"j6VMs\",\"../img/Naracoorte_01.1f8818c7.avif\",\"7QEte\",\"../img/Naracoorte_01.dc62229f.avif\",\"6rMXD\",\"../img/Naracoorte_01.6f980fa9.webp\",\"fXMP9\",\"../img/Naracoorte_01.44003fea.webp\",\"495Wr\",\"../img/Naracoorte_01.389d1b72.webp\",\"9BYWz\",\"../img/Naracoorte_01.de2e5587.webp\",\"8M3Dn\",\"../img/Naracoorte_01.010cab09.png\",\"6M8KQ\",\"../img/Naracoorte_01.7b68030d.png\",\"Gqk1V\",\"../img/Naracoorte_01.61bfa23a.png\",\"eGRz2\",\"../img/Naracoorte_01.21ee2de8.png\",\"6AHiT\",\"../img/Ngorora_formation_01.a6dbff07.avif\",\"3PgYl\",\"../img/Ngorora_formation_01.6b4a01e8.avif\",\"8lVxd\",\"../img/Ngorora_formation_01.8d2b1efa.avif\",\"cfJMQ\",\"../img/Ngorora_formation_01.05582db4.avif\",\"YLxUK\",\"../img/Ngorora_formation_01.bc93206f.webp\",\"8WiCF\",\"../img/Ngorora_formation_01.3c0fd791.webp\",\"fmTfA\",\"../img/Ngorora_formation_01.8ef23b05.webp\",\"1Uvvm\",\"../img/Ngorora_formation_01.2043083f.webp\",\"av7zt\",\"../img/Ngorora_formation_01.e6a86e7d.png\",\"7YCc9\",\"../img/Ngorora_formation_01.db762c3c.png\",\"cEkar\",\"../img/Ngorora_formation_01.836a4f61.png\",\"a0azK\",\"../img/Ngorora_formation_01.76f9bd57.png\",\"cEUsb\",\"../img/Niobrara.de12d4db.avif\",\"1e8Kq\",\"../img/Niobrara.11eaa8d2.avif\",\"jkvAz\",\"../img/Niobrara.e6b4961d.avif\",\"3TeSP\",\"../img/Niobrara.534f9e61.avif\",\"7MFjW\",\"../img/Niobrara.f8984e35.webp\",\"03K7s\",\"../img/Niobrara.0334d294.webp\",\"j6eqQ\",\"../img/Niobrara.522cf227.webp\",\"54sf9\",\"../img/Niobrara.44a6a593.webp\",\"1Ws5k\",\"../img/Niobrara.46cdc617.png\",\"eBf9p\",\"../img/Niobrara.932543d5.png\",\"2FEqL\",\"../img/Niobrara.5189b94e.png\",\"eRRO9\",\"../img/Niobrara.1449851a.png\",\"8JMqM\",\"../img/Paja_formation.04dd08b3.avif\",\"fpO3O\",\"../img/Paja_formation.eaaf6918.avif\",\"6QZHk\",\"../img/Paja_formation.38d7b366.avif\",\"5kC0I\",\"../img/Paja_formation.0b3855e3.avif\",\"dd4Nu\",\"../img/Paja_formation.e9a9b83b.webp\",\"16RXn\",\"../img/Paja_formation.9934e245.webp\",\"dhqnU\",\"../img/Paja_formation.8f582cce.webp\",\"b7BTB\",\"../img/Paja_formation.9282ee8b.webp\",\"bPB9J\",\"../img/Paja_formation.f5067786.png\",\"jEHhw\",\"../img/Paja_formation.3294b5c0.png\",\"hmW8E\",\"../img/Paja_formation.9cb2b984.png\",\"b1a20\",\"../img/Paja_formation.fb3f5bdf.png\",\"cIyP1\",\"../img/Paratethys.7820c9af.avif\",\"e8xDI\",\"../img/Paratethys.d0a8e774.avif\",\"9Yjkh\",\"../img/Paratethys.c9a81415.avif\",\"8Ldcl\",\"../img/Paratethys.5ad74021.avif\",\"UYdEn\",\"../img/Paratethys.a7574870.webp\",\"gcNqm\",\"../img/Paratethys.c5e4859a.webp\",\"4ZIRA\",\"../img/Paratethys.f8f0c66a.webp\",\"7WZwj\",\"../img/Paratethys.33512fa7.webp\",\"8EQmh\",\"../img/Paratethys.09dfd86c.png\",\"2q7GX\",\"../img/Paratethys.8f431bf0.png\",\"fYf7G\",\"../img/Paratethys.51529efa.png\",\"7MLHD\",\"../img/Paratethys.a95a74d1.png\",\"edLd3\",\"../img/Pebas_Formatio.87c72ca9.avif\",\"4mZzu\",\"../img/Pebas_Formatio.dcc9ac4c.avif\",\"3ecS0\",\"../img/Pebas_Formatio.1304d7f2.avif\",\"fhvnH\",\"../img/Pebas_Formatio.e7bbe6ee.avif\",\"h33bP\",\"../img/Pebas_Formatio.245ff255.webp\",\"3rpfW\",\"../img/Pebas_Formatio.00256bc6.webp\",\"dofU5\",\"../img/Pebas_Formatio.81678bd7.webp\",\"hwI1P\",\"../img/Pebas_Formatio.e41aaa76.webp\",\"4KGja\",\"../img/Pebas_Formatio.0f327935.png\",\"dfD9d\",\"../img/Pebas_Formatio.6c288840.png\",\"aOqXF\",\"../img/Pebas_Formatio.a02c97ea.png\",\"82A7t\",\"../img/Pebas_Formatio.3d777358.png\",\"VGD7c\",\"../img/Pierre_Shale_1.23e85f96.avif\",\"cw7v0\",\"../img/Pierre_Shale_1.a3a2a926.avif\",\"l6jEW\",\"../img/Pierre_Shale_1.fdb22ae8.avif\",\"b7RUI\",\"../img/Pierre_Shale_1.3eb7ea5e.avif\",\"3Ylpn\",\"../img/Pierre_Shale_1.c81bc6c9.webp\",\"9FBUg\",\"../img/Pierre_Shale_1.ed8c9256.webp\",\"fumgG\",\"../img/Pierre_Shale_1.4bbdb11f.webp\",\"iI16Y\",\"../img/Pierre_Shale_1.75a52309.webp\",\"kZWMF\",\"../img/Pierre_Shale_1.58b05543.png\",\"htW1O\",\"../img/Pierre_Shale_1.b682304d.png\",\"kixnd\",\"../img/Pierre_Shale_1.0e0d2342.png\",\"9Rz3T\",\"../img/Pierre_Shale_1.0ae0c298.png\",\"4atg8\",\"../img/Pisco_01.b3fd270b.avif\",\"g2gCE\",\"../img/Pisco_01.9e36c05f.avif\",\"hNJn1\",\"../img/Pisco_01.c500d991.avif\",\"huina\",\"../img/Pisco_01.4a6a482d.avif\",\"igPGP\",\"../img/Pisco_01.a1581071.webp\",\"8ky0v\",\"../img/Pisco_01.8ffd2ab0.webp\",\"ensVl\",\"../img/Pisco_01.2e98601a.webp\",\"l4DaP\",\"../img/Pisco_01.759343c1.webp\",\"Lc9zR\",\"../img/Pisco_01.a0b16a79.png\",\"ejvZv\",\"../img/Pisco_01.aabf2b11.png\",\"4Gxcu\",\"../img/Pisco_01.1389cf56.png\",\"cwlIm\",\"../img/Pisco_01.6637f1bb.png\",\"9vD2Q\",\"../img/Cuba_Pleistocen.4e729ce2.avif\",\"eMS6b\",\"../img/Cuba_Pleistocen.798654c2.avif\",\"2DM0Q\",\"../img/Cuba_Pleistocen.0826f226.avif\",\"gkzjP\",\"../img/Cuba_Pleistocen.0af771f2.avif\",\"gVQln\",\"../img/Cuba_Pleistocen.84b38c13.webp\",\"7cGWI\",\"../img/Cuba_Pleistocen.d903029c.webp\",\"fqzvP\",\"../img/Cuba_Pleistocen.cb5338bb.webp\",\"bIxc7\",\"../img/Cuba_Pleistocen.9b8d4f8e.webp\",\"205VU\",\"../img/Cuba_Pleistocen.b90ea9b2.png\",\"qDHOq\",\"../img/Cuba_Pleistocen.a437092d.png\",\"g1Y9l\",\"../img/Cuba_Pleistocen.09b639d6.png\",\"1mOkE\",\"../img/Cuba_Pleistocen.874c3255.png\",\"eGPT7\",\"../img/Cerro_del_pueblo_c.edd0e314.avif\",\"86Qrs\",\"../img/Cerro_del_pueblo_c.fa4a50cd.avif\",\"fStDn\",\"../img/Cerro_del_pueblo_c.2d0e1629.avif\",\"28DG7\",\"../img/Cerro_del_pueblo_c.d5810bc6.avif\",\"emJjy\",\"../img/Cerro_del_pueblo_c.d0a81f11.webp\",\"b9mMQ\",\"../img/Cerro_del_pueblo_c.fc684f54.webp\",\"dfbpD\",\"../img/Cerro_del_pueblo_c.debd77c4.webp\",\"1I2mg\",\"../img/Cerro_del_pueblo_c.1cc801dc.webp\",\"bvpWP\",\"../img/Cerro_del_pueblo_c.aba25346.png\",\"9K8qb\",\"../img/Cerro_del_pueblo_c.85082593.png\",\"7Hy3s\",\"../img/Cerro_del_pueblo_c.e9419bc7.png\",\"j0l1N\",\"../img/Cerro_del_pueblo_c.055c6568.png\",\"2mSPv\",\"../img/Remigiusberg.cb3128e0.avif\",\"9vx09\",\"../img/Remigiusberg.1e0a8007.avif\",\"icyaA\",\"../img/Remigiusberg.abeeb722.avif\",\"aRLzW\",\"../img/Remigiusberg.b57411d3.avif\",\"gLOd5\",\"../img/Remigiusberg.b80bcd82.webp\",\"9kvCs\",\"../img/Remigiusberg.58df0d60.webp\",\"fX9dH\",\"../img/Remigiusberg.6a447196.webp\",\"4AChi\",\"../img/Remigiusberg.ce57e3f7.webp\",\"e2nzZ\",\"../img/Remigiusberg.1f140d02.png\",\"3zApA\",\"../img/Remigiusberg.dcdf9162.png\",\"02bAf\",\"../img/Remigiusberg.764ea4e4.png\",\"bO7uy\",\"../img/Remigiusberg.40b2164b.png\",\"3qPVj\",\"../img/Rio_do_Rasto_Formation.6ff04a99.avif\",\"emZ0h\",\"../img/Rio_do_Rasto_Formation.02ddb25f.avif\",\"2a3dA\",\"../img/Rio_do_Rasto_Formation.f0fa59ec.avif\",\"frdlv\",\"../img/Rio_do_Rasto_Formation.56c0ae7b.avif\",\"aApP7\",\"../img/Rio_do_Rasto_Formation.b445e376.webp\",\"61FTf\",\"../img/Rio_do_Rasto_Formation.052e7c25.webp\",\"5gZL4\",\"../img/Rio_do_Rasto_Formation.5bab64fb.webp\",\"1eqmO\",\"../img/Rio_do_Rasto_Formation.68108442.webp\",\"a7Ohv\",\"../img/Rio_do_Rasto_Formation.6506d7ef.png\",\"Hdlgu\",\"../img/Rio_do_Rasto_Formation.9c1fbe1a.png\",\"bpwMk\",\"../img/Rio_do_Rasto_Formation.e4c87aab.png\",\"7ebzk\",\"../img/Rio_do_Rasto_Formation.d97de1fe.png\",\"m5A3r\",\"../img/Riversleigh.d801624d.avif\",\"9e8s2\",\"../img/Riversleigh.249a208f.avif\",\"a7VM4\",\"../img/Riversleigh.d49beaaf.avif\",\"gei86\",\"../img/Riversleigh.151bed42.avif\",\"3RNxF\",\"../img/Riversleigh.3e49102c.webp\",\"hmgQV\",\"../img/Riversleigh.1dd2e2a7.webp\",\"32Fp4\",\"../img/Riversleigh.ed031cb2.webp\",\"g9AEe\",\"../img/Riversleigh.a4b395c0.webp\",\"hOTmi\",\"../img/Riversleigh.ec0a7d99.png\",\"bRgJL\",\"../img/Riversleigh.3e32dc37.png\",\"cku3y\",\"../img/Riversleigh.68194f7f.png\",\"aojU5\",\"../img/Riversleigh.bee950b1.png\",\"5zrT1\",\"../img/Libanon_Mural3.77e1ff63.avif\",\"2SfNg\",\"../img/Libanon_Mural3.eac203dd.avif\",\"iIdFH\",\"../img/Libanon_Mural3.dae8e20f.avif\",\"56gRz\",\"../img/Libanon_Mural3.4c9af0f7.avif\",\"6nTEI\",\"../img/Libanon_Mural3.f1e24f7e.webp\",\"k6TSu\",\"../img/Libanon_Mural3.9deaf633.webp\",\"1Sp5e\",\"../img/Libanon_Mural3.8573a75d.webp\",\"6mN4E\",\"../img/Libanon_Mural3.3fe7ed13.webp\",\"ePTAi\",\"../img/Libanon_Mural3.8d008b30.png\",\"4wTP8\",\"../img/Libanon_Mural3.aca93555.png\",\"8dhDe\",\"../img/Libanon_Mural3.ec6b17be.png\",\"iKpif\",\"../img/Libanon_Mural3.320e39ac.png\",\"fRuDf\",\"../img/Shanwang.3884097a.avif\",\"7w5be\",\"../img/Shanwang.5d414ee3.avif\",\"4FYs5\",\"../img/Shanwang.08822ae5.avif\",\"8BM1s\",\"../img/Shanwang.d0482205.avif\",\"iWsFJ\",\"../img/Shanwang.4010c8fd.webp\",\"dJYas\",\"../img/Shanwang.3c42b659.webp\",\"8zQKH\",\"../img/Shanwang.57226c45.webp\",\"j8mJg\",\"../img/Shanwang.07c0bd2d.webp\",\"kNScc\",\"../img/Shanwang.6932f647.png\",\"gM5UG\",\"../img/Shanwang.49200edd.png\",\"6ftmW\",\"../img/Shanwang.e0492653.png\",\"iN5mb\",\"../img/Shanwang.b9abdc18.png\",\"1jSB6\",\"../img/Pleistocene_Sicily.ca843091.avif\",\"5gK4B\",\"../img/Pleistocene_Sicily.68c4fb4e.avif\",\"jEo3G\",\"../img/Pleistocene_Sicily.d85f8871.avif\",\"6J0d0\",\"../img/Pleistocene_Sicily.7da963b3.avif\",\"8EExO\",\"../img/Pleistocene_Sicily.8b4b857d.webp\",\"5rnyA\",\"../img/Pleistocene_Sicily.981db6e5.webp\",\"cOcCq\",\"../img/Pleistocene_Sicily.83622a64.webp\",\"bb2XB\",\"../img/Pleistocene_Sicily.90d722af.webp\",\"iwj44\",\"../img/Pleistocene_Sicily.f677199e.png\",\"5b5Tr\",\"../img/Pleistocene_Sicily.5632d331.png\",\"luLRd\",\"../img/Pleistocene_Sicily.67a87be5.png\",\"cLNbe\",\"../img/Pleistocene_Sicily.b05574cd.png\",\"g3iOr\",\"../img/Soom_Shale.84ae17ca.avif\",\"1f3ZU\",\"../img/Soom_Shale.b9e042b2.avif\",\"5gpKR\",\"../img/Soom_Shale.48fc0c99.avif\",\"iDeot\",\"../img/Soom_Shale.0ac1d464.avif\",\"Z2Mj2\",\"../img/Soom_Shale.fb992787.webp\",\"2org2\",\"../img/Soom_Shale.afea8227.webp\",\"gizOI\",\"../img/Soom_Shale.bbe428cd.webp\",\"41bu0\",\"../img/Soom_Shale.2f8123bd.webp\",\"aYdIk\",\"../img/Soom_Shale.79aeb269.png\",\"l2sOg\",\"../img/Soom_Shale.9ca72732.png\",\"dr2l5\",\"../img/Soom_Shale.8f3784a9.png\",\"k2Z3T\",\"../img/Soom_Shale.2b07e019.png\",\"43ZjK\",\"../img/Sulphur_Mountain_b.1680a4fd.avif\",\"lBmZW\",\"../img/Sulphur_Mountain_b.53665a81.avif\",\"6mMmP\",\"../img/Sulphur_Mountain_b.077fa3bd.avif\",\"gUUMJ\",\"../img/Sulphur_Mountain_b.1837e79c.avif\",\"cRCv2\",\"../img/Sulphur_Mountain_b.ee0efb4e.webp\",\"cYJQI\",\"../img/Sulphur_Mountain_b.04830731.webp\",\"lXDeA\",\"../img/Sulphur_Mountain_b.02b7f708.webp\",\"jOGwB\",\"../img/Sulphur_Mountain_b.16fbfdb3.webp\",\"fzBiz\",\"../img/Sulphur_Mountain_b.44f04fd0.png\",\"8Dlrf\",\"../img/Sulphur_Mountain_b.8afb68fc.png\",\"birQF\",\"../img/Sulphur_Mountain_b.a713683d.png\",\"5P9yd\",\"../img/Sulphur_Mountain_b.ab9a9785.png\",\"7PO3z\",\"../img/Tapinocephalus_Ass2.a66126aa.avif\",\"b8eLV\",\"../img/Tapinocephalus_Ass2.5e6015b2.avif\",\"efayK\",\"../img/Tapinocephalus_Ass2.297ee745.avif\",\"8S4nt\",\"../img/Tapinocephalus_Ass2.f436640d.avif\",\"bofme\",\"../img/Tapinocephalus_Ass2.58ded1f7.webp\",\"jVgEM\",\"../img/Tapinocephalus_Ass2.897d880f.webp\",\"9Xtjn\",\"../img/Tapinocephalus_Ass2.38e55091.webp\",\"5ytPv\",\"../img/Tapinocephalus_Ass2.d650b3bb.webp\",\"lQxre\",\"../img/Tapinocephalus_Ass2.e54539b5.png\",\"c2vtb\",\"../img/Tapinocephalus_Ass2.0be932fd.png\",\"fwgCT\",\"../img/Tapinocephalus_Ass2.ea0a6129.png\",\"3hTV4\",\"../img/Tapinocephalus_Ass2.016e526d.png\",\"cBkWw\",\"../img/Tiki_formation_01.b438a86b.avif\",\"6Nu7D\",\"../img/Tiki_formation_01.a6cef7c7.avif\",\"7CjNP\",\"../img/Tiki_formation_01.7be24ce0.avif\",\"jrg50\",\"../img/Tiki_formation_01.41d69a71.avif\",\"1BQVw\",\"../img/Tiki_formation_01.57e9ae44.webp\",\"f2zkf\",\"../img/Tiki_formation_01.189ccd3e.webp\",\"8NwqF\",\"../img/Tiki_formation_01.47e4d124.webp\",\"12DXq\",\"../img/Tiki_formation_01.bf38fc07.webp\",\"a1EML\",\"../img/Tiki_formation_01.10e80ae6.png\",\"7agSO\",\"../img/Tiki_formation_01.57a7fe7c.png\",\"66P2S\",\"../img/Tiki_formation_01.3292c3f3.png\",\"igdUq\",\"../img/Tiki_formation_01.62b61328.png\",\"9ppjf\",\"../img/Toolebuc_formation.f7ec1a51.avif\",\"1C8Ju\",\"../img/Toolebuc_formation.9f7293d2.avif\",\"hfLve\",\"../img/Toolebuc_formation.caa725d8.avif\",\"2yfcm\",\"../img/Toolebuc_formation.df136d31.avif\",\"64EBe\",\"../img/Toolebuc_formation.f7125d81.webp\",\"jZmC5\",\"../img/Toolebuc_formation.efb66834.webp\",\"hTkZt\",\"../img/Toolebuc_formation.e273e611.webp\",\"8Iq31\",\"../img/Toolebuc_formation.9aad1000.webp\",\"gfslO\",\"../img/Toolebuc_formation.6034e1a7.png\",\"lPGpX\",\"../img/Toolebuc_formation.bef38c4f.png\",\"a3t1r\",\"../img/Toolebuc_formation.44e53077.png\",\"k2Bsy\",\"../img/Toolebuc_formation.d6ddf313.png\",\"aGBka\",\"../img/Winton formation.d98033da.avif\",\"l9UjP\",\"../img/Winton formation.276da833.avif\",\"iCYAk\",\"../img/Winton formation.6de2c767.avif\",\"8mkBL\",\"../img/Winton formation.efa085c2.avif\",\"kOS9V\",\"../img/Winton formation.2116cdcb.webp\",\"5en0u\",\"../img/Winton formation.963ea02f.webp\",\"336ud\",\"../img/Winton formation.bd9db068.webp\",\"3TJvS\",\"../img/Winton formation.262767d7.webp\",\"hcgTt\",\"../img/Winton formation.d5331015.png\",\"jwllT\",\"../img/Winton formation.c68e2a49.png\",\"bwN2m\",\"../img/Winton formation.6207f308.png\",\"51lNJ\",\"../img/Winton formation.e089e101.png\",\"2X1VY\",\"../img/Whitewater_Formation_01.e8d2229c.avif\",\"jRYD0\",\"../img/Whitewater_Formation_01.f892ae5b.avif\",\"kGZry\",\"../img/Whitewater_Formation_01.8bcdae73.avif\",\"bqQWJ\",\"../img/Whitewater_Formation_01.000963e9.avif\",\"2uc85\",\"../img/Whitewater_Formation_01.8adaff7c.webp\",\"kBl6e\",\"../img/Whitewater_Formation_01.ef27343a.webp\",\"6HjGA\",\"../img/Whitewater_Formation_01.c891bea5.webp\",\"hBBH2\",\"../img/Whitewater_Formation_01.6438f612.webp\",\"7mbsY\",\"../img/Whitewater_Formation_01.43a70fc5.png\",\"7xn7O\",\"../img/Whitewater_Formation_01.81e158f5.png\",\"ieny7\",\"../img/Whitewater_Formation_01.69d08823.png\",\"4k6KP\",\"../img/Whitewater_Formation_01.f6be099d.png\",\"8KYXX\",\"../img/Yixian_formation.93c097dd.avif\",\"qHazf\",\"../img/Yixian_formation.e71fa9cc.avif\",\"3Mvi3\",\"../img/Yixian_formation.2595b959.avif\",\"dggTT\",\"../img/Yixian_formation.82232485.avif\",\"fCUTj\",\"../img/Yixian_formation.0ae2a36b.webp\",\"6NdjQ\",\"../img/Yixian_formation.ccead9ae.webp\",\"iMk09\",\"../img/Yixian_formation.6940b39d.webp\",\"hyIt7\",\"../img/Yixian_formation.22e638de.webp\",\"jAKTG\",\"../img/Yixian_formation.1fc4f0c9.png\",\"4azik\",\"../img/Yixian_formation.20068d64.png\",\"aZQwq\",\"../img/Yixian_formation.e96896ca.png\",\"k33ra\",\"../img/Yixian_formation.38368557.png\",\"VPRbG\",\"../img/Zechstein_v2.0312215e.avif\",\"iZqpo\",\"../img/Zechstein_v2.46772d0d.avif\",\"1XoC8\",\"../img/Zechstein_v2.750b3cf8.avif\",\"iu5Li\",\"../img/Zechstein_v2.825cb75d.avif\",\"9GFxL\",\"../img/Zechstein_v2.ad4b4c1e.webp\",\"lkWnY\",\"../img/Zechstein_v2.0448adf0.webp\",\"c96w4\",\"../img/Zechstein_v2.6ad1bdce.webp\",\"9MmGS\",\"../img/Zechstein_v2.1d919304.webp\",\"5i658\",\"../img/Zechstein_v2.e9d3af77.png\",\"f1aRa\",\"../img/Zechstein_v2.0b7a6b72.png\",\"5QZHQ\",\"../img/Zechstein_v2.05ce0aad.png\",\"iXdie\",\"../img/Zechstein_v2.422a4c4d.png\"]"));

var $4b5e7420e94bb43f$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($4b5e7420e94bb43f$exports);
})($4b5e7420e94bb43f$exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});


var $b8fd28e5626e013d$exports = {};
/*
 * Leaflet.markercluster 1.5.3+master.e5124b2,
 * Provides Beautiful Animated Marker Clustering functionality for Leaflet, a JS library for interactive maps.
 * https://github.com/Leaflet/Leaflet.markercluster
 * (c) 2012-2017, Dave Leaver, smartrak
 */ (function(global, factory) {
    factory($b8fd28e5626e013d$exports);
})($b8fd28e5626e013d$exports, function(exports1) {
    'use strict';
    /*
	 * L.MarkerClusterGroup extends L.FeatureGroup by clustering the markers contained within
	 */ var MarkerClusterGroup = L.MarkerClusterGroup = L.FeatureGroup.extend({
        options: {
            maxClusterRadius: 80,
            iconCreateFunction: null,
            clusterPane: L.Marker.prototype.options.pane,
            spiderfyOnEveryZoom: false,
            spiderfyOnMaxZoom: true,
            showCoverageOnHover: true,
            zoomToBoundsOnClick: true,
            singleMarkerMode: false,
            disableClusteringAtZoom: null,
            // Setting this to false prevents the removal of any clusters outside of the viewpoint, which
            // is the default behaviour for performance reasons.
            removeOutsideVisibleBounds: true,
            // Set to false to disable all animations (zoom and spiderfy).
            // If false, option animateAddingMarkers below has no effect.
            // If L.DomUtil.TRANSITION is falsy, this option has no effect.
            animate: true,
            //Whether to animate adding markers after adding the MarkerClusterGroup to the map
            // If you are adding individual markers set to true, if adding bulk markers leave false for massive performance gains.
            animateAddingMarkers: false,
            // Make it possible to provide custom function to calculate spiderfy shape positions
            spiderfyShapePositions: null,
            //Increase to increase the distance away that spiderfied markers appear from the center
            spiderfyDistanceMultiplier: 1,
            // Make it possible to specify a polyline options on a spider leg
            spiderLegPolylineOptions: {
                weight: 1.5,
                color: '#222',
                opacity: 0.5
            },
            // When bulk adding layers, adds markers in chunks. Means addLayers may not add all the layers in the call, others will be loaded during setTimeouts
            chunkedLoading: false,
            chunkInterval: 200,
            chunkDelay: 50,
            chunkProgress: null,
            //Options to pass to the L.Polygon constructor
            polygonOptions: {}
        },
        initialize: function(options) {
            L.Util.setOptions(this, options);
            if (!this.options.iconCreateFunction) this.options.iconCreateFunction = this._defaultIconCreateFunction;
            this._featureGroup = L.featureGroup();
            this._featureGroup.addEventParent(this);
            this._nonPointGroup = L.featureGroup();
            this._nonPointGroup.addEventParent(this);
            this._inZoomAnimation = 0;
            this._needsClustering = [];
            this._needsRemoving = []; //Markers removed while we aren't on the map need to be kept track of
            //The bounds of the currently shown area (from _getExpandedVisibleBounds) Updated on zoom/move
            this._currentShownBounds = null;
            this._queue = [];
            this._childMarkerEventHandlers = {
                'dragstart': this._childMarkerDragStart,
                'move': this._childMarkerMoved,
                'dragend': this._childMarkerDragEnd
            };
            // Hook the appropriate animation methods.
            var animate = L.DomUtil.TRANSITION && this.options.animate;
            L.extend(this, animate ? this._withAnimation : this._noAnimation);
            // Remember which MarkerCluster class to instantiate (animated or not).
            this._markerCluster = animate ? L.MarkerCluster : L.MarkerClusterNonAnimated;
        },
        addLayer: function(layer) {
            if (layer instanceof L.LayerGroup) return this.addLayers([
                layer
            ]);
            //Don't cluster non point data
            if (!layer.getLatLng) {
                this._nonPointGroup.addLayer(layer);
                this.fire('layeradd', {
                    layer: layer
                });
                return this;
            }
            if (!this._map) {
                this._needsClustering.push(layer);
                this.fire('layeradd', {
                    layer: layer
                });
                return this;
            }
            if (this.hasLayer(layer)) return this;
            //If we have already clustered we'll need to add this one to a cluster
            if (this._unspiderfy) this._unspiderfy();
            this._addLayer(layer, this._maxZoom);
            this.fire('layeradd', {
                layer: layer
            });
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            //Work out what is visible
            var visibleLayer = layer, currentZoom = this._zoom;
            if (layer.__parent) while(visibleLayer.__parent._zoom >= currentZoom)visibleLayer = visibleLayer.__parent;
            if (this._currentShownBounds.contains(visibleLayer.getLatLng())) {
                if (this.options.animateAddingMarkers) this._animationAddLayer(layer, visibleLayer);
                else this._animationAddLayerNonAnimated(layer, visibleLayer);
            }
            return this;
        },
        removeLayer: function(layer) {
            if (layer instanceof L.LayerGroup) return this.removeLayers([
                layer
            ]);
            //Non point layers
            if (!layer.getLatLng) {
                this._nonPointGroup.removeLayer(layer);
                this.fire('layerremove', {
                    layer: layer
                });
                return this;
            }
            if (!this._map) {
                if (!this._arraySplice(this._needsClustering, layer) && this.hasLayer(layer)) this._needsRemoving.push({
                    layer: layer,
                    latlng: layer._latlng
                });
                this.fire('layerremove', {
                    layer: layer
                });
                return this;
            }
            if (!layer.__parent) return this;
            if (this._unspiderfy) {
                this._unspiderfy();
                this._unspiderfyLayer(layer);
            }
            //Remove the marker from clusters
            this._removeLayer(layer, true);
            this.fire('layerremove', {
                layer: layer
            });
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            layer.off(this._childMarkerEventHandlers, this);
            if (this._featureGroup.hasLayer(layer)) {
                this._featureGroup.removeLayer(layer);
                if (layer.clusterShow) layer.clusterShow();
            }
            return this;
        },
        //Takes an array of markers and adds them in bulk
        addLayers: function(layersArray, skipLayerAddEvent) {
            if (!L.Util.isArray(layersArray)) return this.addLayer(layersArray);
            var fg = this._featureGroup, npg = this._nonPointGroup, chunked = this.options.chunkedLoading, chunkInterval = this.options.chunkInterval, chunkProgress = this.options.chunkProgress, l = layersArray.length, offset = 0, originalArray = true, m;
            if (this._map) {
                var started = new Date().getTime();
                var process = L.bind(function() {
                    var start = new Date().getTime();
                    // Make sure to unspiderfy before starting to add some layers
                    if (this._map && this._unspiderfy) this._unspiderfy();
                    for(; offset < l; offset++){
                        if (chunked && offset % 200 === 0) {
                            // every couple hundred markers, instrument the time elapsed since processing started:
                            var elapsed = new Date().getTime() - start;
                            if (elapsed > chunkInterval) break; // been working too hard, time to take a break :-)
                        }
                        m = layersArray[offset];
                        // Group of layers, append children to layersArray and skip.
                        // Side effects:
                        // - Total increases, so chunkProgress ratio jumps backward.
                        // - Groups are not included in this group, only their non-group child layers (hasLayer).
                        // Changing array length while looping does not affect performance in current browsers:
                        // http://jsperf.com/for-loop-changing-length/6
                        if (m instanceof L.LayerGroup) {
                            if (originalArray) {
                                layersArray = layersArray.slice();
                                originalArray = false;
                            }
                            this._extractNonGroupLayers(m, layersArray);
                            l = layersArray.length;
                            continue;
                        }
                        //Not point data, can't be clustered
                        if (!m.getLatLng) {
                            npg.addLayer(m);
                            if (!skipLayerAddEvent) this.fire('layeradd', {
                                layer: m
                            });
                            continue;
                        }
                        if (this.hasLayer(m)) continue;
                        this._addLayer(m, this._maxZoom);
                        if (!skipLayerAddEvent) this.fire('layeradd', {
                            layer: m
                        });
                        //If we just made a cluster of size 2 then we need to remove the other marker from the map (if it is) or we never will
                        if (m.__parent) {
                            if (m.__parent.getChildCount() === 2) {
                                var markers = m.__parent.getAllChildMarkers(), otherMarker = markers[0] === m ? markers[1] : markers[0];
                                fg.removeLayer(otherMarker);
                            }
                        }
                    }
                    if (chunkProgress) // report progress and time elapsed:
                    chunkProgress(offset, l, new Date().getTime() - started);
                    // Completed processing all markers.
                    if (offset === l) {
                        // Refresh bounds and weighted positions.
                        this._topClusterLevel._recalculateBounds();
                        this._refreshClustersIcons();
                        this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
                    } else setTimeout(process, this.options.chunkDelay);
                }, this);
                process();
            } else {
                var needsClustering = this._needsClustering;
                for(; offset < l; offset++){
                    m = layersArray[offset];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        if (originalArray) {
                            layersArray = layersArray.slice();
                            originalArray = false;
                        }
                        this._extractNonGroupLayers(m, layersArray);
                        l = layersArray.length;
                        continue;
                    }
                    //Not point data, can't be clustered
                    if (!m.getLatLng) {
                        npg.addLayer(m);
                        continue;
                    }
                    if (this.hasLayer(m)) continue;
                    needsClustering.push(m);
                }
            }
            return this;
        },
        //Takes an array of markers and removes them in bulk
        removeLayers: function(layersArray) {
            var i, m, l = layersArray.length, fg = this._featureGroup, npg = this._nonPointGroup, originalArray = true;
            if (!this._map) {
                for(i = 0; i < l; i++){
                    m = layersArray[i];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        if (originalArray) {
                            layersArray = layersArray.slice();
                            originalArray = false;
                        }
                        this._extractNonGroupLayers(m, layersArray);
                        l = layersArray.length;
                        continue;
                    }
                    this._arraySplice(this._needsClustering, m);
                    npg.removeLayer(m);
                    if (this.hasLayer(m)) this._needsRemoving.push({
                        layer: m,
                        latlng: m._latlng
                    });
                    this.fire('layerremove', {
                        layer: m
                    });
                }
                return this;
            }
            if (this._unspiderfy) {
                this._unspiderfy();
                // Work on a copy of the array, so that next loop is not affected.
                var layersArray2 = layersArray.slice(), l2 = l;
                for(i = 0; i < l2; i++){
                    m = layersArray2[i];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        this._extractNonGroupLayers(m, layersArray2);
                        l2 = layersArray2.length;
                        continue;
                    }
                    this._unspiderfyLayer(m);
                }
            }
            for(i = 0; i < l; i++){
                m = layersArray[i];
                // Group of layers, append children to layersArray and skip.
                if (m instanceof L.LayerGroup) {
                    if (originalArray) {
                        layersArray = layersArray.slice();
                        originalArray = false;
                    }
                    this._extractNonGroupLayers(m, layersArray);
                    l = layersArray.length;
                    continue;
                }
                if (!m.__parent) {
                    npg.removeLayer(m);
                    this.fire('layerremove', {
                        layer: m
                    });
                    continue;
                }
                this._removeLayer(m, true, true);
                this.fire('layerremove', {
                    layer: m
                });
                if (fg.hasLayer(m)) {
                    fg.removeLayer(m);
                    if (m.clusterShow) m.clusterShow();
                }
            }
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            //Fix up the clusters and markers on the map
            this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
            return this;
        },
        //Removes all layers from the MarkerClusterGroup
        clearLayers: function() {
            //Need our own special implementation as the LayerGroup one doesn't work for us
            //If we aren't on the map (yet), blow away the markers we know of
            if (!this._map) {
                this._needsClustering = [];
                this._needsRemoving = [];
                delete this._gridClusters;
                delete this._gridUnclustered;
            }
            if (this._noanimationUnspiderfy) this._noanimationUnspiderfy();
            //Remove all the visible layers
            this._featureGroup.clearLayers();
            this._nonPointGroup.clearLayers();
            this.eachLayer(function(marker) {
                marker.off(this._childMarkerEventHandlers, this);
                delete marker.__parent;
            }, this);
            if (this._map) //Reset _topClusterLevel and the DistanceGrids
            this._generateInitialClusters();
            return this;
        },
        //Override FeatureGroup.getBounds as it doesn't work
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            if (this._topClusterLevel) bounds.extend(this._topClusterLevel._bounds);
            for(var i = this._needsClustering.length - 1; i >= 0; i--)bounds.extend(this._needsClustering[i].getLatLng());
            bounds.extend(this._nonPointGroup.getBounds());
            return bounds;
        },
        //Overrides LayerGroup.eachLayer
        eachLayer: function(method, context) {
            var markers = this._needsClustering.slice(), needsRemoving = this._needsRemoving, thisNeedsRemoving, i, j;
            if (this._topClusterLevel) this._topClusterLevel.getAllChildMarkers(markers);
            for(i = markers.length - 1; i >= 0; i--){
                thisNeedsRemoving = true;
                for(j = needsRemoving.length - 1; j >= 0; j--)if (needsRemoving[j].layer === markers[i]) {
                    thisNeedsRemoving = false;
                    break;
                }
                if (thisNeedsRemoving) method.call(context, markers[i]);
            }
            this._nonPointGroup.eachLayer(method, context);
        },
        //Overrides LayerGroup.getLayers
        getLayers: function() {
            var layers = [];
            this.eachLayer(function(l) {
                layers.push(l);
            });
            return layers;
        },
        //Overrides LayerGroup.getLayer, WARNING: Really bad performance
        getLayer: function(id) {
            var result = null;
            id = parseInt(id, 10);
            this.eachLayer(function(l) {
                if (L.stamp(l) === id) result = l;
            });
            return result;
        },
        //Returns true if the given layer is in this MarkerClusterGroup
        hasLayer: function(layer) {
            if (!layer) return false;
            var i, anArray = this._needsClustering;
            for(i = anArray.length - 1; i >= 0; i--){
                if (anArray[i] === layer) return true;
            }
            anArray = this._needsRemoving;
            for(i = anArray.length - 1; i >= 0; i--){
                if (anArray[i].layer === layer) return false;
            }
            return !!(layer.__parent && layer.__parent._group === this) || this._nonPointGroup.hasLayer(layer);
        },
        //Zoom down to show the given layer (spiderfying if necessary) then calls the callback
        zoomToShowLayer: function(layer, callback) {
            var map = this._map;
            if (typeof callback !== 'function') callback = function() {};
            var showMarker = function() {
                // Assumes that map.hasLayer checks for direct appearance on map, not recursively calling
                // hasLayer on Layer Groups that are on map (typically not calling this MarkerClusterGroup.hasLayer, which would always return true)
                if ((map.hasLayer(layer) || map.hasLayer(layer.__parent)) && !this._inZoomAnimation) {
                    this._map.off('moveend', showMarker, this);
                    this.off('animationend', showMarker, this);
                    if (map.hasLayer(layer)) callback();
                    else if (layer.__parent._icon) {
                        this.once('spiderfied', callback, this);
                        layer.__parent.spiderfy();
                    }
                }
            };
            if (layer._icon && this._map.getBounds().contains(layer.getLatLng())) //Layer is visible ond on screen, immediate return
            callback();
            else if (layer.__parent._zoom < Math.round(this._map._zoom)) {
                //Layer should be visible at this zoom level. It must not be on screen so just pan over to it
                this._map.on('moveend', showMarker, this);
                this._map.panTo(layer.getLatLng());
            } else {
                this._map.on('moveend', showMarker, this);
                this.on('animationend', showMarker, this);
                layer.__parent.zoomToBounds();
            }
        },
        //Overrides FeatureGroup.onAdd
        onAdd: function(map) {
            this._map = map;
            var i, l, layer;
            if (!isFinite(this._map.getMaxZoom())) throw "Map has no maxZoom specified";
            this._featureGroup.addTo(map);
            this._nonPointGroup.addTo(map);
            if (!this._gridClusters) this._generateInitialClusters();
            this._maxLat = map.options.crs.projection.MAX_LATITUDE;
            //Restore all the positions as they are in the MCG before removing them
            for(i = 0, l = this._needsRemoving.length; i < l; i++){
                layer = this._needsRemoving[i];
                layer.newlatlng = layer.layer._latlng;
                layer.layer._latlng = layer.latlng;
            }
            //Remove them, then restore their new positions
            for(i = 0, l = this._needsRemoving.length; i < l; i++){
                layer = this._needsRemoving[i];
                this._removeLayer(layer.layer, true);
                layer.layer._latlng = layer.newlatlng;
            }
            this._needsRemoving = [];
            //Remember the current zoom level and bounds
            this._zoom = Math.round(this._map._zoom);
            this._currentShownBounds = this._getExpandedVisibleBounds();
            this._map.on('zoomend', this._zoomEnd, this);
            this._map.on('moveend', this._moveEnd, this);
            if (this._spiderfierOnAdd) this._spiderfierOnAdd();
            this._bindEvents();
            //Actually add our markers to the map:
            l = this._needsClustering;
            this._needsClustering = [];
            this.addLayers(l, true);
        },
        //Overrides FeatureGroup.onRemove
        onRemove: function(map) {
            map.off('zoomend', this._zoomEnd, this);
            map.off('moveend', this._moveEnd, this);
            this._unbindEvents();
            //In case we are in a cluster animation
            this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
            if (this._spiderfierOnRemove) this._spiderfierOnRemove();
            delete this._maxLat;
            //Clean up all the layers we added to the map
            this._hideCoverage();
            this._featureGroup.remove();
            this._nonPointGroup.remove();
            this._featureGroup.clearLayers();
            this._map = null;
        },
        getVisibleParent: function(marker) {
            var vMarker = marker;
            while(vMarker && !vMarker._icon)vMarker = vMarker.__parent;
            return vMarker || null;
        },
        //Remove the given object from the given array
        _arraySplice: function(anArray, obj) {
            for(var i = anArray.length - 1; i >= 0; i--)if (anArray[i] === obj) {
                anArray.splice(i, 1);
                return true;
            }
        },
        /**
		 * Removes a marker from all _gridUnclustered zoom levels, starting at the supplied zoom.
		 * @param marker to be removed from _gridUnclustered.
		 * @param z integer bottom start zoom level (included)
		 * @private
		 */ _removeFromGridUnclustered: function(marker, z) {
            var map = this._map, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom());
            for(; z >= minZoom; z--){
                if (!gridUnclustered[z].removeObject(marker, map.project(marker.getLatLng(), z))) break;
            }
        },
        _childMarkerDragStart: function(e) {
            e.target.__dragStart = e.target._latlng;
        },
        _childMarkerMoved: function(e) {
            if (!this._ignoreMove && !e.target.__dragStart) {
                var isPopupOpen = e.target._popup && e.target._popup.isOpen();
                this._moveChild(e.target, e.oldLatLng, e.latlng);
                if (isPopupOpen) e.target.openPopup();
            }
        },
        _moveChild: function(layer, from, to) {
            layer._latlng = from;
            this.removeLayer(layer);
            layer._latlng = to;
            this.addLayer(layer);
        },
        _childMarkerDragEnd: function(e) {
            var dragStart = e.target.__dragStart;
            delete e.target.__dragStart;
            if (dragStart) this._moveChild(e.target, dragStart, e.target._latlng);
        },
        //Internal function for removing a marker from everything.
        //dontUpdateMap: set to true if you will handle updating the map manually (for bulk functions)
        _removeLayer: function(marker, removeFromDistanceGrid, dontUpdateMap) {
            var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, fg = this._featureGroup, map = this._map, minZoom = Math.floor(this._map.getMinZoom());
            //Remove the marker from distance clusters it might be in
            if (removeFromDistanceGrid) this._removeFromGridUnclustered(marker, this._maxZoom);
            //Work our way up the clusters removing them as we go if required
            var cluster = marker.__parent, markers = cluster._markers, otherMarker;
            //Remove the marker from the immediate parents marker list
            this._arraySplice(markers, marker);
            while(cluster){
                cluster._childCount--;
                cluster._boundsNeedUpdate = true;
                if (cluster._zoom < minZoom) break;
                else if (removeFromDistanceGrid && cluster._childCount <= 1) {
                    //We need to push the other marker up to the parent
                    otherMarker = cluster._markers[0] === marker ? cluster._markers[1] : cluster._markers[0];
                    //Update distance grid
                    gridClusters[cluster._zoom].removeObject(cluster, map.project(cluster._cLatLng, cluster._zoom));
                    gridUnclustered[cluster._zoom].addObject(otherMarker, map.project(otherMarker.getLatLng(), cluster._zoom));
                    //Move otherMarker up to parent
                    this._arraySplice(cluster.__parent._childClusters, cluster);
                    cluster.__parent._markers.push(otherMarker);
                    otherMarker.__parent = cluster.__parent;
                    if (cluster._icon) {
                        //Cluster is currently on the map, need to put the marker on the map instead
                        fg.removeLayer(cluster);
                        if (!dontUpdateMap) fg.addLayer(otherMarker);
                    }
                } else cluster._iconNeedsUpdate = true;
                cluster = cluster.__parent;
            }
            delete marker.__parent;
        },
        _isOrIsParent: function(el, oel) {
            while(oel){
                if (el === oel) return true;
                oel = oel.parentNode;
            }
            return false;
        },
        //Override L.Evented.fire
        fire: function(type, data, propagate) {
            if (data && data.layer instanceof L.MarkerCluster) {
                //Prevent multiple clustermouseover/off events if the icon is made up of stacked divs (Doesn't work in ie <= 8, no relatedTarget)
                if (data.originalEvent && this._isOrIsParent(data.layer._icon, data.originalEvent.relatedTarget)) return;
                type = 'cluster' + type;
            }
            L.FeatureGroup.prototype.fire.call(this, type, data, propagate);
        },
        //Override L.Evented.listens
        listens: function(type, propagate) {
            return L.FeatureGroup.prototype.listens.call(this, type, propagate) || L.FeatureGroup.prototype.listens.call(this, 'cluster' + type, propagate);
        },
        //Default functionality
        _defaultIconCreateFunction: function(cluster) {
            var childCount = cluster.getChildCount();
            var c = ' marker-cluster-';
            if (childCount < 10) c += 'small';
            else if (childCount < 100) c += 'medium';
            else c += 'large';
            return new L.DivIcon({
                html: '<div><span>' + childCount + '</span></div>',
                className: 'marker-cluster' + c,
                iconSize: new L.Point(40, 40)
            });
        },
        _bindEvents: function() {
            var map = this._map, spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom;
            //Zoom on cluster click or spiderfy if we are at the lowest level
            if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) this.on('clusterclick clusterkeypress', this._zoomOrSpiderfy, this);
            //Show convex hull (boundary) polygon on mouse over
            if (showCoverageOnHover) {
                this.on('clustermouseover', this._showCoverage, this);
                this.on('clustermouseout', this._hideCoverage, this);
                map.on('zoomend', this._hideCoverage, this);
            }
        },
        _zoomOrSpiderfy: function(e) {
            var cluster = e.layer, bottomCluster = cluster;
            if (e.type === 'clusterkeypress' && e.originalEvent && e.originalEvent.keyCode !== 13) return;
            while(bottomCluster._childClusters.length === 1)bottomCluster = bottomCluster._childClusters[0];
            if (bottomCluster._zoom === this._maxZoom && bottomCluster._childCount === cluster._childCount && this.options.spiderfyOnMaxZoom) // All child markers are contained in a single cluster from this._maxZoom to this cluster.
            cluster.spiderfy();
            else if (this.options.zoomToBoundsOnClick) cluster.zoomToBounds();
            if (this.options.spiderfyOnEveryZoom) cluster.spiderfy();
            // Focus the map again for keyboard users.
            if (e.originalEvent && e.originalEvent.keyCode === 13) this._map._container.focus();
        },
        _showCoverage: function(e) {
            var map = this._map;
            if (this._inZoomAnimation) return;
            if (this._shownPolygon) map.removeLayer(this._shownPolygon);
            if (e.layer.getChildCount() > 2 && e.layer !== this._spiderfied) {
                this._shownPolygon = new L.Polygon(e.layer.getConvexHull(), this.options.polygonOptions);
                map.addLayer(this._shownPolygon);
            }
        },
        _hideCoverage: function() {
            if (this._shownPolygon) {
                this._map.removeLayer(this._shownPolygon);
                this._shownPolygon = null;
            }
        },
        _unbindEvents: function() {
            var spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom, map = this._map;
            if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) this.off('clusterclick clusterkeypress', this._zoomOrSpiderfy, this);
            if (showCoverageOnHover) {
                this.off('clustermouseover', this._showCoverage, this);
                this.off('clustermouseout', this._hideCoverage, this);
                map.off('zoomend', this._hideCoverage, this);
            }
        },
        _zoomEnd: function() {
            if (!this._map) return;
            this._mergeSplitClusters();
            this._zoom = Math.round(this._map._zoom);
            this._currentShownBounds = this._getExpandedVisibleBounds();
        },
        _moveEnd: function() {
            if (this._inZoomAnimation) return;
            var newBounds = this._getExpandedVisibleBounds();
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, newBounds);
            this._topClusterLevel._recursivelyAddChildrenToMap(null, Math.round(this._map._zoom), newBounds);
            this._currentShownBounds = newBounds;
            return;
        },
        _generateInitialClusters: function() {
            var maxZoom = Math.ceil(this._map.getMaxZoom()), minZoom = Math.floor(this._map.getMinZoom()), radius = this.options.maxClusterRadius, radiusFn = radius;
            //If we just set maxClusterRadius to a single number, we need to create
            //a simple function to return that number. Otherwise, we just have to
            //use the function we've passed in.
            if (typeof radius !== "function") radiusFn = function() {
                return radius;
            };
            if (this.options.disableClusteringAtZoom !== null) maxZoom = this.options.disableClusteringAtZoom - 1;
            this._maxZoom = maxZoom;
            this._gridClusters = {};
            this._gridUnclustered = {};
            //Set up DistanceGrids for each zoom
            for(var zoom = maxZoom; zoom >= minZoom; zoom--){
                this._gridClusters[zoom] = new L.DistanceGrid(radiusFn(zoom));
                this._gridUnclustered[zoom] = new L.DistanceGrid(radiusFn(zoom));
            }
            // Instantiate the appropriate L.MarkerCluster class (animated or not).
            this._topClusterLevel = new this._markerCluster(this, minZoom - 1);
        },
        //Zoom: Zoom to start adding at (Pass this._maxZoom to start at the bottom)
        _addLayer: function(layer, zoom) {
            var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom()), markerPoint, z;
            if (this.options.singleMarkerMode) this._overrideMarkerIcon(layer);
            layer.on(this._childMarkerEventHandlers, this);
            //Find the lowest zoom level to slot this one in
            for(; zoom >= minZoom; zoom--){
                markerPoint = this._map.project(layer.getLatLng(), zoom); // calculate pixel position
                //Try find a cluster close by
                var closest = gridClusters[zoom].getNearObject(markerPoint);
                if (closest) {
                    closest._addChild(layer);
                    layer.__parent = closest;
                    return;
                }
                //Try find a marker close by to form a new cluster with
                closest = gridUnclustered[zoom].getNearObject(markerPoint);
                if (closest) {
                    var parent = closest.__parent;
                    if (parent) this._removeLayer(closest, false);
                    //Create new cluster with these 2 in it
                    var newCluster = new this._markerCluster(this, zoom, closest, layer);
                    gridClusters[zoom].addObject(newCluster, this._map.project(newCluster._cLatLng, zoom));
                    closest.__parent = newCluster;
                    layer.__parent = newCluster;
                    //First create any new intermediate parent clusters that don't exist
                    var lastParent = newCluster;
                    for(z = zoom - 1; z > parent._zoom; z--){
                        lastParent = new this._markerCluster(this, z, lastParent);
                        gridClusters[z].addObject(lastParent, this._map.project(closest.getLatLng(), z));
                    }
                    parent._addChild(lastParent);
                    //Remove closest from this zoom level and any above that it is in, replace with newCluster
                    this._removeFromGridUnclustered(closest, zoom);
                    return;
                }
                //Didn't manage to cluster in at this zoom, record us as a marker here and continue upwards
                gridUnclustered[zoom].addObject(layer, markerPoint);
            }
            //Didn't get in anything, add us to the top
            this._topClusterLevel._addChild(layer);
            layer.__parent = this._topClusterLevel;
            return;
        },
        /**
		 * Refreshes the icon of all "dirty" visible clusters.
		 * Non-visible "dirty" clusters will be updated when they are added to the map.
		 * @private
		 */ _refreshClustersIcons: function() {
            this._featureGroup.eachLayer(function(c) {
                if (c instanceof L.MarkerCluster && c._iconNeedsUpdate) c._updateIcon();
            });
        },
        //Enqueue code to fire after the marker expand/contract has happened
        _enqueue: function(fn) {
            this._queue.push(fn);
            if (!this._queueTimeout) this._queueTimeout = setTimeout(L.bind(this._processQueue, this), 300);
        },
        _processQueue: function() {
            for(var i = 0; i < this._queue.length; i++)this._queue[i].call(this);
            this._queue.length = 0;
            clearTimeout(this._queueTimeout);
            this._queueTimeout = null;
        },
        //Merge and split any existing clusters that are too big or small
        _mergeSplitClusters: function() {
            var mapZoom = Math.round(this._map._zoom);
            //In case we are starting to split before the animation finished
            this._processQueue();
            if (this._zoom < mapZoom && this._currentShownBounds.intersects(this._getExpandedVisibleBounds())) {
                this._animationStart();
                //Remove clusters now off screen
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, this._getExpandedVisibleBounds());
                this._animationZoomIn(this._zoom, mapZoom);
            } else if (this._zoom > mapZoom) {
                this._animationStart();
                this._animationZoomOut(this._zoom, mapZoom);
            } else this._moveEnd();
        },
        //Gets the maps visible bounds expanded in each direction by the size of the screen (so the user cannot see an area we do not cover in one pan)
        _getExpandedVisibleBounds: function() {
            if (!this.options.removeOutsideVisibleBounds) return this._mapBoundsInfinite;
            else if (L.Browser.mobile) return this._checkBoundsMaxLat(this._map.getBounds());
            return this._checkBoundsMaxLat(this._map.getBounds().pad(1)); // Padding expands the bounds by its own dimensions but scaled with the given factor.
        },
        /**
		 * Expands the latitude to Infinity (or -Infinity) if the input bounds reach the map projection maximum defined latitude
		 * (in the case of Web/Spherical Mercator, it is 85.0511287798 / see https://en.wikipedia.org/wiki/Web_Mercator#Formulas).
		 * Otherwise, the removeOutsideVisibleBounds option will remove markers beyond that limit, whereas the same markers without
		 * this option (or outside MCG) will have their position floored (ceiled) by the projection and rendered at that limit,
		 * making the user think that MCG "eats" them and never displays them again.
		 * @param bounds L.LatLngBounds
		 * @returns {L.LatLngBounds}
		 * @private
		 */ _checkBoundsMaxLat: function(bounds) {
            var maxLat = this._maxLat;
            if (maxLat !== undefined) {
                if (bounds.getNorth() >= maxLat) bounds._northEast.lat = Infinity;
                if (bounds.getSouth() <= -maxLat) bounds._southWest.lat = -Infinity;
            }
            return bounds;
        },
        //Shared animation code
        _animationAddLayerNonAnimated: function(layer, newCluster) {
            if (newCluster === layer) this._featureGroup.addLayer(layer);
            else if (newCluster._childCount === 2) {
                newCluster._addToMap();
                var markers = newCluster.getAllChildMarkers();
                this._featureGroup.removeLayer(markers[0]);
                this._featureGroup.removeLayer(markers[1]);
            } else newCluster._updateIcon();
        },
        /**
		 * Extracts individual (i.e. non-group) layers from a Layer Group.
		 * @param group to extract layers from.
		 * @param output {Array} in which to store the extracted layers.
		 * @returns {*|Array}
		 * @private
		 */ _extractNonGroupLayers: function(group, output) {
            var layers = group.getLayers(), i = 0, layer;
            output = output || [];
            for(; i < layers.length; i++){
                layer = layers[i];
                if (layer instanceof L.LayerGroup) {
                    this._extractNonGroupLayers(layer, output);
                    continue;
                }
                output.push(layer);
            }
            return output;
        },
        /**
		 * Implements the singleMarkerMode option.
		 * @param layer Marker to re-style using the Clusters iconCreateFunction.
		 * @returns {L.Icon} The newly created icon.
		 * @private
		 */ _overrideMarkerIcon: function(layer) {
            var icon = layer.options.icon = this.options.iconCreateFunction({
                getChildCount: function() {
                    return 1;
                },
                getAllChildMarkers: function() {
                    return [
                        layer
                    ];
                }
            });
            return icon;
        }
    });
    // Constant bounds used in case option "removeOutsideVisibleBounds" is set to false.
    L.MarkerClusterGroup.include({
        _mapBoundsInfinite: new L.LatLngBounds(new L.LatLng(-Infinity, -Infinity), new L.LatLng(Infinity, Infinity))
    });
    L.MarkerClusterGroup.include({
        _noAnimation: {
            //Non Animated versions of everything
            _animationStart: function() {
            //Do nothing...
            },
            _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //We didn't actually animate, but we use this event to mean "clustering animations have finished"
                this.fire('animationend');
            },
            _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //We didn't actually animate, but we use this event to mean "clustering animations have finished"
                this.fire('animationend');
            },
            _animationAddLayer: function(layer, newCluster) {
                this._animationAddLayerNonAnimated(layer, newCluster);
            }
        },
        _withAnimation: {
            //Animated versions here
            _animationStart: function() {
                this._map._mapPane.className += ' leaflet-cluster-anim';
                this._inZoomAnimation++;
            },
            _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
                var bounds = this._getExpandedVisibleBounds(), fg = this._featureGroup, minZoom = Math.floor(this._map.getMinZoom()), i;
                this._ignoreMove = true;
                //Add all children of current clusters to map and remove those clusters from map
                this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                    var startPos = c._latlng, markers = c._markers, m;
                    if (!bounds.contains(startPos)) startPos = null;
                    if (c._isSingleParent() && previousZoomLevel + 1 === newZoomLevel) {
                        fg.removeLayer(c);
                        c._recursivelyAddChildrenToMap(null, newZoomLevel, bounds);
                    } else {
                        //Fade out old cluster
                        c.clusterHide();
                        c._recursivelyAddChildrenToMap(startPos, newZoomLevel, bounds);
                    }
                    //Remove all markers that aren't visible any more
                    //TODO: Do we actually need to do this on the higher levels too?
                    for(i = markers.length - 1; i >= 0; i--){
                        m = markers[i];
                        if (!bounds.contains(m._latlng)) fg.removeLayer(m);
                    }
                });
                this._forceLayout();
                //Update opacities
                this._topClusterLevel._recursivelyBecomeVisible(bounds, newZoomLevel);
                //TODO Maybe? Update markers in _recursivelyBecomeVisible
                fg.eachLayer(function(n) {
                    if (!(n instanceof L.MarkerCluster) && n._icon) n.clusterShow();
                });
                //update the positions of the just added clusters/markers
                this._topClusterLevel._recursively(bounds, previousZoomLevel, newZoomLevel, function(c) {
                    c._recursivelyRestoreChildPositions(newZoomLevel);
                });
                this._ignoreMove = false;
                //Remove the old clusters and close the zoom animation
                this._enqueue(function() {
                    //update the positions of the just added clusters/markers
                    this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                        fg.removeLayer(c);
                        c.clusterShow();
                    });
                    this._animationEnd();
                });
            },
            _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
                this._animationZoomOutSingle(this._topClusterLevel, previousZoomLevel - 1, newZoomLevel);
                //Need to add markers for those that weren't on the map before but are now
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //Remove markers that were on the map before but won't be now
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel, this._getExpandedVisibleBounds());
            },
            _animationAddLayer: function(layer, newCluster) {
                var me = this, fg = this._featureGroup;
                fg.addLayer(layer);
                if (newCluster !== layer) {
                    if (newCluster._childCount > 2) {
                        newCluster._updateIcon();
                        this._forceLayout();
                        this._animationStart();
                        layer._setPos(this._map.latLngToLayerPoint(newCluster.getLatLng()));
                        layer.clusterHide();
                        this._enqueue(function() {
                            fg.removeLayer(layer);
                            layer.clusterShow();
                            me._animationEnd();
                        });
                    } else {
                        this._forceLayout();
                        me._animationStart();
                        me._animationZoomOutSingle(newCluster, this._map.getMaxZoom(), this._zoom);
                    }
                }
            }
        },
        // Private methods for animated versions.
        _animationZoomOutSingle: function(cluster, previousZoomLevel, newZoomLevel) {
            var bounds = this._getExpandedVisibleBounds(), minZoom = Math.floor(this._map.getMinZoom());
            //Animate all of the markers in the clusters to move to their cluster center point
            cluster._recursivelyAnimateChildrenInAndAddSelfToMap(bounds, minZoom, previousZoomLevel + 1, newZoomLevel);
            var me = this;
            //Update the opacity (If we immediately set it they won't animate)
            this._forceLayout();
            cluster._recursivelyBecomeVisible(bounds, newZoomLevel);
            //TODO: Maybe use the transition timing stuff to make this more reliable
            //When the animations are done, tidy up
            this._enqueue(function() {
                //This cluster stopped being a cluster before the timeout fired
                if (cluster._childCount === 1) {
                    var m = cluster._markers[0];
                    //If we were in a cluster animation at the time then the opacity and position of our child could be wrong now, so fix it
                    this._ignoreMove = true;
                    m.setLatLng(m.getLatLng());
                    this._ignoreMove = false;
                    if (m.clusterShow) m.clusterShow();
                } else cluster._recursively(bounds, newZoomLevel, minZoom, function(c) {
                    c._recursivelyRemoveChildrenFromMap(bounds, minZoom, previousZoomLevel + 1);
                });
                me._animationEnd();
            });
        },
        _animationEnd: function() {
            if (this._map) this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
            this._inZoomAnimation--;
            this.fire('animationend');
        },
        //Force a browser layout of stuff in the map
        // Should apply the current opacity and location to all elements so we can update them again for an animation
        _forceLayout: function() {
            //In my testing this works, infact offsetWidth of any element seems to work.
            //Could loop all this._layers and do this for each _icon if it stops working
            L.Util.falseFn(document.body.offsetWidth);
        }
    });
    L.markerClusterGroup = function(options) {
        return new L.MarkerClusterGroup(options);
    };
    var MarkerCluster = L.MarkerCluster = L.Marker.extend({
        options: L.Icon.prototype.options,
        initialize: function(group, zoom, a, b) {
            L.Marker.prototype.initialize.call(this, a ? a._cLatLng || a.getLatLng() : new L.LatLng(0, 0), {
                icon: this,
                pane: group.options.clusterPane
            });
            this._group = group;
            this._zoom = zoom;
            this._markers = [];
            this._childClusters = [];
            this._childCount = 0;
            this._iconNeedsUpdate = true;
            this._boundsNeedUpdate = true;
            this._bounds = new L.LatLngBounds();
            if (a) this._addChild(a);
            if (b) this._addChild(b);
        },
        //Recursively retrieve all child markers of this cluster
        getAllChildMarkers: function(storageArray, ignoreDraggedMarker) {
            storageArray = storageArray || [];
            for(var i = this._childClusters.length - 1; i >= 0; i--)this._childClusters[i].getAllChildMarkers(storageArray, ignoreDraggedMarker);
            for(var j = this._markers.length - 1; j >= 0; j--){
                if (ignoreDraggedMarker && this._markers[j].__dragStart) continue;
                storageArray.push(this._markers[j]);
            }
            return storageArray;
        },
        //Returns the count of how many child markers we have
        getChildCount: function() {
            return this._childCount;
        },
        //Zoom to the minimum of showing all of the child markers, or the extents of this cluster
        zoomToBounds: function(fitBoundsOptions) {
            var childClusters = this._childClusters.slice(), map = this._group._map, boundsZoom = map.getBoundsZoom(this._bounds), zoom = this._zoom + 1, mapZoom = map.getZoom(), i;
            //calculate how far we need to zoom down to see all of the markers
            while(childClusters.length > 0 && boundsZoom > zoom){
                zoom++;
                var newClusters = [];
                for(i = 0; i < childClusters.length; i++)newClusters = newClusters.concat(childClusters[i]._childClusters);
                childClusters = newClusters;
            }
            if (boundsZoom > zoom) this._group._map.setView(this._latlng, zoom);
            else if (boundsZoom <= mapZoom) this._group._map.setView(this._latlng, mapZoom + 1);
            else this._group._map.fitBounds(this._bounds, fitBoundsOptions);
        },
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            bounds.extend(this._bounds);
            return bounds;
        },
        _updateIcon: function() {
            this._iconNeedsUpdate = true;
            if (this._icon) this.setIcon(this);
        },
        //Cludge for Icon, we pretend to be an icon for performance
        createIcon: function() {
            if (this._iconNeedsUpdate) {
                this._iconObj = this._group.options.iconCreateFunction(this);
                this._iconNeedsUpdate = false;
            }
            return this._iconObj.createIcon();
        },
        createShadow: function() {
            return this._iconObj.createShadow();
        },
        _addChild: function(new1, isNotificationFromChild) {
            this._iconNeedsUpdate = true;
            this._boundsNeedUpdate = true;
            this._setClusterCenter(new1);
            if (new1 instanceof L.MarkerCluster) {
                if (!isNotificationFromChild) {
                    this._childClusters.push(new1);
                    new1.__parent = this;
                }
                this._childCount += new1._childCount;
            } else {
                if (!isNotificationFromChild) this._markers.push(new1);
                this._childCount++;
            }
            if (this.__parent) this.__parent._addChild(new1, true);
        },
        /**
		 * Makes sure the cluster center is set. If not, uses the child center if it is a cluster, or the marker position.
		 * @param child L.MarkerCluster|L.Marker that will be used as cluster center if not defined yet.
		 * @private
		 */ _setClusterCenter: function(child) {
            if (!this._cLatLng) // when clustering, take position of the first point as the cluster center
            this._cLatLng = child._cLatLng || child._latlng;
        },
        /**
		 * Assigns impossible bounding values so that the next extend entirely determines the new bounds.
		 * This method avoids having to trash the previous L.LatLngBounds object and to create a new one, which is much slower for this class.
		 * As long as the bounds are not extended, most other methods would probably fail, as they would with bounds initialized but not extended.
		 * @private
		 */ _resetBounds: function() {
            var bounds = this._bounds;
            if (bounds._southWest) {
                bounds._southWest.lat = Infinity;
                bounds._southWest.lng = Infinity;
            }
            if (bounds._northEast) {
                bounds._northEast.lat = -Infinity;
                bounds._northEast.lng = -Infinity;
            }
        },
        _recalculateBounds: function() {
            var markers = this._markers, childClusters = this._childClusters, latSum = 0, lngSum = 0, totalCount = this._childCount, i, child, childLatLng, childCount;
            // Case where all markers are removed from the map and we are left with just an empty _topClusterLevel.
            if (totalCount === 0) return;
            // Reset rather than creating a new object, for performance.
            this._resetBounds();
            // Child markers.
            for(i = 0; i < markers.length; i++){
                childLatLng = markers[i]._latlng;
                this._bounds.extend(childLatLng);
                latSum += childLatLng.lat;
                lngSum += childLatLng.lng;
            }
            // Child clusters.
            for(i = 0; i < childClusters.length; i++){
                child = childClusters[i];
                // Re-compute child bounds and weighted position first if necessary.
                if (child._boundsNeedUpdate) child._recalculateBounds();
                this._bounds.extend(child._bounds);
                childLatLng = child._wLatLng;
                childCount = child._childCount;
                latSum += childLatLng.lat * childCount;
                lngSum += childLatLng.lng * childCount;
            }
            this._latlng = this._wLatLng = new L.LatLng(latSum / totalCount, lngSum / totalCount);
            // Reset dirty flag.
            this._boundsNeedUpdate = false;
        },
        //Set our markers position as given and add it to the map
        _addToMap: function(startPos) {
            if (startPos) {
                this._backupLatlng = this._latlng;
                this.setLatLng(startPos);
            }
            this._group._featureGroup.addLayer(this);
        },
        _recursivelyAnimateChildrenIn: function(bounds, center, maxZoom) {
            this._recursively(bounds, this._group._map.getMinZoom(), maxZoom - 1, function(c) {
                var markers = c._markers, i, m;
                for(i = markers.length - 1; i >= 0; i--){
                    m = markers[i];
                    //Only do it if the icon is still on the map
                    if (m._icon) {
                        m._setPos(center);
                        m.clusterHide();
                    }
                }
            }, function(c) {
                var childClusters = c._childClusters, j, cm;
                for(j = childClusters.length - 1; j >= 0; j--){
                    cm = childClusters[j];
                    if (cm._icon) {
                        cm._setPos(center);
                        cm.clusterHide();
                    }
                }
            });
        },
        _recursivelyAnimateChildrenInAndAddSelfToMap: function(bounds, mapMinZoom, previousZoomLevel, newZoomLevel) {
            this._recursively(bounds, newZoomLevel, mapMinZoom, function(c) {
                c._recursivelyAnimateChildrenIn(bounds, c._group._map.latLngToLayerPoint(c.getLatLng()).round(), previousZoomLevel);
                //TODO: depthToAnimateIn affects _isSingleParent, if there is a multizoom we may/may not be.
                //As a hack we only do a animation free zoom on a single level zoom, if someone does multiple levels then we always animate
                if (c._isSingleParent() && previousZoomLevel - 1 === newZoomLevel) {
                    c.clusterShow();
                    c._recursivelyRemoveChildrenFromMap(bounds, mapMinZoom, previousZoomLevel); //Immediately remove our children as we are replacing them. TODO previousBounds not bounds
                } else c.clusterHide();
                c._addToMap();
            });
        },
        _recursivelyBecomeVisible: function(bounds, zoomLevel) {
            this._recursively(bounds, this._group._map.getMinZoom(), zoomLevel, null, function(c) {
                c.clusterShow();
            });
        },
        _recursivelyAddChildrenToMap: function(startPos, zoomLevel, bounds) {
            this._recursively(bounds, this._group._map.getMinZoom() - 1, zoomLevel, function(c) {
                if (zoomLevel === c._zoom) return;
                //Add our child markers at startPos (so they can be animated out)
                for(var i = c._markers.length - 1; i >= 0; i--){
                    var nm = c._markers[i];
                    if (!bounds.contains(nm._latlng)) continue;
                    if (startPos) {
                        nm._backupLatlng = nm.getLatLng();
                        nm.setLatLng(startPos);
                        if (nm.clusterHide) nm.clusterHide();
                    }
                    c._group._featureGroup.addLayer(nm);
                }
            }, function(c) {
                c._addToMap(startPos);
            });
        },
        _recursivelyRestoreChildPositions: function(zoomLevel) {
            //Fix positions of child markers
            for(var i = this._markers.length - 1; i >= 0; i--){
                var nm = this._markers[i];
                if (nm._backupLatlng) {
                    nm.setLatLng(nm._backupLatlng);
                    delete nm._backupLatlng;
                }
            }
            if (zoomLevel - 1 === this._zoom) //Reposition child clusters
            for(var j = this._childClusters.length - 1; j >= 0; j--)this._childClusters[j]._restorePosition();
            else for(var k = this._childClusters.length - 1; k >= 0; k--)this._childClusters[k]._recursivelyRestoreChildPositions(zoomLevel);
        },
        _restorePosition: function() {
            if (this._backupLatlng) {
                this.setLatLng(this._backupLatlng);
                delete this._backupLatlng;
            }
        },
        //exceptBounds: If set, don't remove any markers/clusters in it
        _recursivelyRemoveChildrenFromMap: function(previousBounds, mapMinZoom, zoomLevel, exceptBounds) {
            var m, i;
            this._recursively(previousBounds, mapMinZoom - 1, zoomLevel - 1, function(c) {
                //Remove markers at every level
                for(i = c._markers.length - 1; i >= 0; i--){
                    m = c._markers[i];
                    if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                        c._group._featureGroup.removeLayer(m);
                        if (m.clusterShow) m.clusterShow();
                    }
                }
            }, function(c) {
                //Remove child clusters at just the bottom level
                for(i = c._childClusters.length - 1; i >= 0; i--){
                    m = c._childClusters[i];
                    if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                        c._group._featureGroup.removeLayer(m);
                        if (m.clusterShow) m.clusterShow();
                    }
                }
            });
        },
        //Run the given functions recursively to this and child clusters
        // boundsToApplyTo: a L.LatLngBounds representing the bounds of what clusters to recurse in to
        // zoomLevelToStart: zoom level to start running functions (inclusive)
        // zoomLevelToStop: zoom level to stop running functions (inclusive)
        // runAtEveryLevel: function that takes an L.MarkerCluster as an argument that should be applied on every level
        // runAtBottomLevel: function that takes an L.MarkerCluster as an argument that should be applied at only the bottom level
        _recursively: function(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel) {
            var childClusters = this._childClusters, zoom = this._zoom, i, c;
            if (zoomLevelToStart <= zoom) {
                if (runAtEveryLevel) runAtEveryLevel(this);
                if (runAtBottomLevel && zoom === zoomLevelToStop) runAtBottomLevel(this);
            }
            if (zoom < zoomLevelToStart || zoom < zoomLevelToStop) for(i = childClusters.length - 1; i >= 0; i--){
                c = childClusters[i];
                if (c._boundsNeedUpdate) c._recalculateBounds();
                if (boundsToApplyTo.intersects(c._bounds)) c._recursively(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel);
            }
        },
        //Returns true if we are the parent of only one cluster and that cluster is the same as us
        _isSingleParent: function() {
            //Don't need to check this._markers as the rest won't work if there are any
            return this._childClusters.length > 0 && this._childClusters[0]._childCount === this._childCount;
        }
    });
    /*
	* Extends L.Marker to include two extra methods: clusterHide and clusterShow.
	* 
	* They work as setOpacity(0) and setOpacity(1) respectively, but
	* don't overwrite the options.opacity
	* 
	*/ L.Marker.include({
        clusterHide: function() {
            var backup = this.options.opacity;
            this.setOpacity(0);
            this.options.opacity = backup;
            return this;
        },
        clusterShow: function() {
            return this.setOpacity(this.options.opacity);
        }
    });
    L.DistanceGrid = function(cellSize) {
        this._cellSize = cellSize;
        this._sqCellSize = cellSize * cellSize;
        this._grid = {};
        this._objectPoint = {};
    };
    L.DistanceGrid.prototype = {
        addObject: function(obj, point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], stamp = L.Util.stamp(obj);
            this._objectPoint[stamp] = point;
            cell.push(obj);
        },
        updateObject: function(obj, point) {
            this.removeObject(obj);
            this.addObject(obj, point);
        },
        //Returns true if the object was found
        removeObject: function(obj, point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], i, len;
            delete this._objectPoint[L.Util.stamp(obj)];
            for(i = 0, len = cell.length; i < len; i++)if (cell[i] === obj) {
                cell.splice(i, 1);
                if (len === 1) delete row[x];
                return true;
            }
        },
        eachObject: function(fn, context) {
            var i, j, k, len, row, cell, removed, grid = this._grid;
            for(i in grid){
                row = grid[i];
                for(j in row){
                    cell = row[j];
                    for(k = 0, len = cell.length; k < len; k++){
                        removed = fn.call(context, cell[k]);
                        if (removed) {
                            k--;
                            len--;
                        }
                    }
                }
            }
        },
        getNearObject: function(point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), i, j, k, row, cell, len, obj, dist, objectPoint = this._objectPoint, closestDistSq = this._sqCellSize, closest = null;
            for(i = y - 1; i <= y + 1; i++){
                row = this._grid[i];
                if (row) for(j = x - 1; j <= x + 1; j++){
                    cell = row[j];
                    if (cell) for(k = 0, len = cell.length; k < len; k++){
                        obj = cell[k];
                        dist = this._sqDist(objectPoint[L.Util.stamp(obj)], point);
                        if (dist < closestDistSq || dist <= closestDistSq && closest === null) {
                            closestDistSq = dist;
                            closest = obj;
                        }
                    }
                }
            }
            return closest;
        },
        _getCoord: function(x) {
            var coord = Math.floor(x / this._cellSize);
            return isFinite(coord) ? coord : x;
        },
        _sqDist: function(p, p2) {
            var dx = p2.x - p.x, dy = p2.y - p.y;
            return dx * dx + dy * dy;
        }
    };
    /* Copyright (c) 2012 the authors listed at the following URL, and/or
	the authors of referenced articles or incorporated external code:
	http://en.literateprograms.org/Quickhull_(Javascript)?action=history&offset=20120410175256

	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:

	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	Retrieved from: http://en.literateprograms.org/Quickhull_(Javascript)?oldid=18434
	*/ (function() {
        L.QuickHull = {
            /*
			 * @param {Object} cpt a point to be measured from the baseline
			 * @param {Array} bl the baseline, as represented by a two-element
			 *   array of latlng objects.
			 * @returns {Number} an approximate distance measure
			 */ getDistant: function(cpt, bl) {
                var vY = bl[1].lat - bl[0].lat, vX = bl[0].lng - bl[1].lng;
                return vX * (cpt.lat - bl[0].lat) + vY * (cpt.lng - bl[0].lng);
            },
            /*
			 * @param {Array} baseLine a two-element array of latlng objects
			 *   representing the baseline to project from
			 * @param {Array} latLngs an array of latlng objects
			 * @returns {Object} the maximum point and all new points to stay
			 *   in consideration for the hull.
			 */ findMostDistantPointFromBaseLine: function(baseLine, latLngs) {
                var maxD = 0, maxPt = null, newPoints = [], i, pt, d;
                for(i = latLngs.length - 1; i >= 0; i--){
                    pt = latLngs[i];
                    d = this.getDistant(pt, baseLine);
                    if (d > 0) newPoints.push(pt);
                    else continue;
                    if (d > maxD) {
                        maxD = d;
                        maxPt = pt;
                    }
                }
                return {
                    maxPoint: maxPt,
                    newPoints: newPoints
                };
            },
            /*
			 * Given a baseline, compute the convex hull of latLngs as an array
			 * of latLngs.
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */ buildConvexHull: function(baseLine, latLngs) {
                var convexHullBaseLines = [], t = this.findMostDistantPointFromBaseLine(baseLine, latLngs);
                if (t.maxPoint) {
                    convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([
                        baseLine[0],
                        t.maxPoint
                    ], t.newPoints));
                    convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([
                        t.maxPoint,
                        baseLine[1]
                    ], t.newPoints));
                    return convexHullBaseLines;
                } else return [
                    baseLine[0]
                ];
            },
            /*
			 * Given an array of latlngs, compute a convex hull as an array
			 * of latlngs
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */ getConvexHull: function(latLngs) {
                // find first baseline
                var maxLat = false, minLat = false, maxLng = false, minLng = false, maxLatPt = null, minLatPt = null, maxLngPt = null, minLngPt = null, maxPt = null, minPt = null, i;
                for(i = latLngs.length - 1; i >= 0; i--){
                    var pt = latLngs[i];
                    if (maxLat === false || pt.lat > maxLat) {
                        maxLatPt = pt;
                        maxLat = pt.lat;
                    }
                    if (minLat === false || pt.lat < minLat) {
                        minLatPt = pt;
                        minLat = pt.lat;
                    }
                    if (maxLng === false || pt.lng > maxLng) {
                        maxLngPt = pt;
                        maxLng = pt.lng;
                    }
                    if (minLng === false || pt.lng < minLng) {
                        minLngPt = pt;
                        minLng = pt.lng;
                    }
                }
                if (minLat !== maxLat) {
                    minPt = minLatPt;
                    maxPt = maxLatPt;
                } else {
                    minPt = minLngPt;
                    maxPt = maxLngPt;
                }
                var ch = [].concat(this.buildConvexHull([
                    minPt,
                    maxPt
                ], latLngs), this.buildConvexHull([
                    maxPt,
                    minPt
                ], latLngs));
                return ch;
            }
        };
    })();
    L.MarkerCluster.include({
        getConvexHull: function() {
            var childMarkers = this.getAllChildMarkers(), points = [], p, i;
            for(i = childMarkers.length - 1; i >= 0; i--){
                p = childMarkers[i].getLatLng();
                points.push(p);
            }
            return L.QuickHull.getConvexHull(points);
        }
    });
    //This code is 100% based on https://github.com/jawj/OverlappingMarkerSpiderfier-Leaflet
    //Huge thanks to jawj for implementing it first to make my job easy :-)
    L.MarkerCluster.include({
        _2PI: Math.PI * 2,
        _circleFootSeparation: 25,
        _circleStartAngle: 0,
        _spiralFootSeparation: 28,
        _spiralLengthStart: 11,
        _spiralLengthFactor: 5,
        _circleSpiralSwitchover: 9,
        // 0 -> always spiral; Infinity -> always circle
        spiderfy: function() {
            if (this._group._spiderfied === this || this._group._inZoomAnimation) return;
            var childMarkers = this.getAllChildMarkers(null, true), group = this._group, map = group._map, center = map.latLngToLayerPoint(this._latlng), positions;
            this._group._unspiderfy();
            this._group._spiderfied = this;
            //TODO Maybe: childMarkers order by distance to center
            if (this._group.options.spiderfyShapePositions) positions = this._group.options.spiderfyShapePositions(childMarkers.length, center);
            else if (childMarkers.length >= this._circleSpiralSwitchover) positions = this._generatePointsSpiral(childMarkers.length, center);
            else {
                center.y += 10; // Otherwise circles look wrong => hack for standard blue icon, renders differently for other icons.
                positions = this._generatePointsCircle(childMarkers.length, center);
            }
            this._animationSpiderfy(childMarkers, positions);
        },
        unspiderfy: function(zoomDetails) {
            /// <param Name="zoomDetails">Argument from zoomanim if being called in a zoom animation or null otherwise</param>
            if (this._group._inZoomAnimation) return;
            this._animationUnspiderfy(zoomDetails);
            this._group._spiderfied = null;
        },
        _generatePointsCircle: function(count, centerPt) {
            var circumference = this._group.options.spiderfyDistanceMultiplier * this._circleFootSeparation * (2 + count), legLength = circumference / this._2PI, angleStep = this._2PI / count, res = [], i, angle;
            legLength = Math.max(legLength, 35); // Minimum distance to get outside the cluster icon.
            res.length = count;
            for(i = 0; i < count; i++){
                angle = this._circleStartAngle + i * angleStep;
                res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
            }
            return res;
        },
        _generatePointsSpiral: function(count, centerPt) {
            var spiderfyDistanceMultiplier = this._group.options.spiderfyDistanceMultiplier, legLength = spiderfyDistanceMultiplier * this._spiralLengthStart, separation = spiderfyDistanceMultiplier * this._spiralFootSeparation, lengthFactor = spiderfyDistanceMultiplier * this._spiralLengthFactor * this._2PI, angle = 0, res = [], i;
            res.length = count;
            // Higher index, closer position to cluster center.
            for(i = count; i >= 0; i--){
                // Skip the first position, so that we are already farther from center and we avoid
                // being under the default cluster icon (especially important for Circle Markers).
                if (i < count) res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
                angle += separation / legLength + i * 0.0005;
                legLength += lengthFactor / angle;
            }
            return res;
        },
        _noanimationUnspiderfy: function() {
            var group = this._group, map = group._map, fg = group._featureGroup, childMarkers = this.getAllChildMarkers(null, true), m, i;
            group._ignoreMove = true;
            this.setOpacity(1);
            for(i = childMarkers.length - 1; i >= 0; i--){
                m = childMarkers[i];
                fg.removeLayer(m);
                if (m._preSpiderfyLatlng) {
                    m.setLatLng(m._preSpiderfyLatlng);
                    delete m._preSpiderfyLatlng;
                }
                if (m.setZIndexOffset) m.setZIndexOffset(0);
                if (m._spiderLeg) {
                    map.removeLayer(m._spiderLeg);
                    delete m._spiderLeg;
                }
            }
            group.fire('unspiderfied', {
                cluster: this,
                markers: childMarkers
            });
            group._ignoreMove = false;
            group._spiderfied = null;
        }
    });
    //Non Animated versions of everything
    L.MarkerClusterNonAnimated = L.MarkerCluster.extend({
        _animationSpiderfy: function(childMarkers, positions) {
            var group = this._group, map = group._map, fg = group._featureGroup, legOptions = this._group.options.spiderLegPolylineOptions, i, m, leg, newPos;
            group._ignoreMove = true;
            // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
            // The reverse order trick no longer improves performance on modern browsers.
            for(i = 0; i < childMarkers.length; i++){
                newPos = map.layerPointToLatLng(positions[i]);
                m = childMarkers[i];
                // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
                leg = new L.Polyline([
                    this._latlng,
                    newPos
                ], legOptions);
                map.addLayer(leg);
                m._spiderLeg = leg;
                // Now add the marker.
                m._preSpiderfyLatlng = m._latlng;
                m.setLatLng(newPos);
                if (m.setZIndexOffset) m.setZIndexOffset(1000000); //Make these appear on top of EVERYTHING
                fg.addLayer(m);
            }
            this.setOpacity(0.3);
            group._ignoreMove = false;
            group.fire('spiderfied', {
                cluster: this,
                markers: childMarkers
            });
        },
        _animationUnspiderfy: function() {
            this._noanimationUnspiderfy();
        }
    });
    //Animated versions here
    L.MarkerCluster.include({
        _animationSpiderfy: function(childMarkers, positions) {
            var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerLatLng = this._latlng, thisLayerPos = map.latLngToLayerPoint(thisLayerLatLng), svg = L.Path.SVG, legOptions = L.extend({}, this._group.options.spiderLegPolylineOptions), finalLegOpacity = legOptions.opacity, i, m, leg, legPath, legLength, newPos;
            if (finalLegOpacity === undefined) finalLegOpacity = L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity;
            if (svg) {
                // If the initial opacity of the spider leg is not 0 then it appears before the animation starts.
                legOptions.opacity = 0;
                // Add the class for CSS transitions.
                legOptions.className = (legOptions.className || '') + ' leaflet-cluster-spider-leg';
            } else // Make sure we have a defined opacity.
            legOptions.opacity = finalLegOpacity;
            group._ignoreMove = true;
            // Add markers and spider legs to map, hidden at our center point.
            // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
            // The reverse order trick no longer improves performance on modern browsers.
            for(i = 0; i < childMarkers.length; i++){
                m = childMarkers[i];
                newPos = map.layerPointToLatLng(positions[i]);
                // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
                leg = new L.Polyline([
                    thisLayerLatLng,
                    newPos
                ], legOptions);
                map.addLayer(leg);
                m._spiderLeg = leg;
                // Explanations: https://jakearchibald.com/2013/animated-line-drawing-svg/
                // In our case the transition property is declared in the CSS file.
                if (svg) {
                    legPath = leg._path;
                    legLength = legPath.getTotalLength() + 0.1; // Need a small extra length to avoid remaining dot in Firefox.
                    legPath.style.strokeDasharray = legLength; // Just 1 length is enough, it will be duplicated.
                    legPath.style.strokeDashoffset = legLength;
                }
                // If it is a marker, add it now and we'll animate it out
                if (m.setZIndexOffset) m.setZIndexOffset(1000000); // Make normal markers appear on top of EVERYTHING
                if (m.clusterHide) m.clusterHide();
                // Vectors just get immediately added
                fg.addLayer(m);
                if (m._setPos) m._setPos(thisLayerPos);
            }
            group._forceLayout();
            group._animationStart();
            // Reveal markers and spider legs.
            for(i = childMarkers.length - 1; i >= 0; i--){
                newPos = map.layerPointToLatLng(positions[i]);
                m = childMarkers[i];
                //Move marker to new position
                m._preSpiderfyLatlng = m._latlng;
                m.setLatLng(newPos);
                if (m.clusterShow) m.clusterShow();
                // Animate leg (animation is actually delegated to CSS transition).
                if (svg) {
                    leg = m._spiderLeg;
                    legPath = leg._path;
                    legPath.style.strokeDashoffset = 0;
                    //legPath.style.strokeOpacity = finalLegOpacity;
                    leg.setStyle({
                        opacity: finalLegOpacity
                    });
                }
            }
            this.setOpacity(0.3);
            group._ignoreMove = false;
            setTimeout(function() {
                group._animationEnd();
                group.fire('spiderfied', {
                    cluster: me,
                    markers: childMarkers
                });
            }, 200);
        },
        _animationUnspiderfy: function(zoomDetails) {
            var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerPos = zoomDetails ? map._latLngToNewLayerPoint(this._latlng, zoomDetails.zoom, zoomDetails.center) : map.latLngToLayerPoint(this._latlng), childMarkers = this.getAllChildMarkers(null, true), svg = L.Path.SVG, m, i, leg, legPath, legLength, nonAnimatable;
            group._ignoreMove = true;
            group._animationStart();
            //Make us visible and bring the child markers back in
            this.setOpacity(1);
            for(i = childMarkers.length - 1; i >= 0; i--){
                m = childMarkers[i];
                //Marker was added to us after we were spiderfied
                if (!m._preSpiderfyLatlng) continue;
                //Close any popup on the marker first, otherwise setting the location of the marker will make the map scroll
                m.closePopup();
                //Fix up the location to the real one
                m.setLatLng(m._preSpiderfyLatlng);
                delete m._preSpiderfyLatlng;
                //Hack override the location to be our center
                nonAnimatable = true;
                if (m._setPos) {
                    m._setPos(thisLayerPos);
                    nonAnimatable = false;
                }
                if (m.clusterHide) {
                    m.clusterHide();
                    nonAnimatable = false;
                }
                if (nonAnimatable) fg.removeLayer(m);
                // Animate the spider leg back in (animation is actually delegated to CSS transition).
                if (svg) {
                    leg = m._spiderLeg;
                    legPath = leg._path;
                    legLength = legPath.getTotalLength() + 0.1;
                    legPath.style.strokeDashoffset = legLength;
                    leg.setStyle({
                        opacity: 0
                    });
                }
            }
            group._ignoreMove = false;
            setTimeout(function() {
                //If we have only <= one child left then that marker will be shown on the map so don't remove it!
                var stillThereChildCount = 0;
                for(i = childMarkers.length - 1; i >= 0; i--){
                    m = childMarkers[i];
                    if (m._spiderLeg) stillThereChildCount++;
                }
                for(i = childMarkers.length - 1; i >= 0; i--){
                    m = childMarkers[i];
                    if (!m._spiderLeg) continue;
                    if (m.clusterShow) m.clusterShow();
                    if (m.setZIndexOffset) m.setZIndexOffset(0);
                    if (stillThereChildCount > 1) fg.removeLayer(m);
                    map.removeLayer(m._spiderLeg);
                    delete m._spiderLeg;
                }
                group._animationEnd();
                group.fire('unspiderfied', {
                    cluster: me,
                    markers: childMarkers
                });
            }, 200);
        }
    });
    L.MarkerClusterGroup.include({
        //The MarkerCluster currently spiderfied (if any)
        _spiderfied: null,
        unspiderfy: function() {
            this._unspiderfy.apply(this, arguments);
        },
        _spiderfierOnAdd: function() {
            this._map.on('click', this._unspiderfyWrapper, this);
            if (this._map.options.zoomAnimation) this._map.on('zoomstart', this._unspiderfyZoomStart, this);
            //Browsers without zoomAnimation or a big zoom don't fire zoomstart
            this._map.on('zoomend', this._noanimationUnspiderfy, this);
            if (!L.Browser.touch) this._map.getRenderer(this);
        },
        _spiderfierOnRemove: function() {
            this._map.off('click', this._unspiderfyWrapper, this);
            this._map.off('zoomstart', this._unspiderfyZoomStart, this);
            this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
            this._map.off('zoomend', this._noanimationUnspiderfy, this);
            //Ensure that markers are back where they should be
            // Use no animation to avoid a sticky leaflet-cluster-anim class on mapPane
            this._noanimationUnspiderfy();
        },
        //On zoom start we add a zoomanim handler so that we are guaranteed to be last (after markers are animated)
        //This means we can define the animation they do rather than Markers doing an animation to their actual location
        _unspiderfyZoomStart: function() {
            if (!this._map) return;
            this._map.on('zoomanim', this._unspiderfyZoomAnim, this);
        },
        _unspiderfyZoomAnim: function(zoomDetails) {
            //Wait until the first zoomanim after the user has finished touch-zooming before running the animation
            if (L.DomUtil.hasClass(this._map._mapPane, 'leaflet-touching')) return;
            this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
            this._unspiderfy(zoomDetails);
        },
        _unspiderfyWrapper: function() {
            /// <summary>_unspiderfy but passes no arguments</summary>
            this._unspiderfy();
        },
        _unspiderfy: function(zoomDetails) {
            if (this._spiderfied) this._spiderfied.unspiderfy(zoomDetails);
        },
        _noanimationUnspiderfy: function() {
            if (this._spiderfied) this._spiderfied._noanimationUnspiderfy();
        },
        //If the given layer is currently being spiderfied then we unspiderfy it so it isn't on the map anymore etc
        _unspiderfyLayer: function(layer) {
            if (layer._spiderLeg) {
                this._featureGroup.removeLayer(layer);
                if (layer.clusterShow) layer.clusterShow();
                //Position will be fixed up immediately in _animationUnspiderfy
                if (layer.setZIndexOffset) layer.setZIndexOffset(0);
                this._map.removeLayer(layer._spiderLeg);
                delete layer._spiderLeg;
            }
        }
    });
    /**
	 * Adds 1 public method to MCG and 1 to L.Marker to facilitate changing
	 * markers' icon options and refreshing their icon and their parent clusters
	 * accordingly (case where their iconCreateFunction uses data of childMarkers
	 * to make up the cluster icon).
	 */ L.MarkerClusterGroup.include({
        /**
		 * Updates the icon of all clusters which are parents of the given marker(s).
		 * In singleMarkerMode, also updates the given marker(s) icon.
		 * @param layers L.MarkerClusterGroup|L.LayerGroup|Array(L.Marker)|Map(L.Marker)|
		 * L.MarkerCluster|L.Marker (optional) list of markers (or single marker) whose parent
		 * clusters need to be updated. If not provided, retrieves all child markers of this.
		 * @returns {L.MarkerClusterGroup}
		 */ refreshClusters: function(layers) {
            if (!layers) layers = this._topClusterLevel.getAllChildMarkers();
            else if (layers instanceof L.MarkerClusterGroup) layers = layers._topClusterLevel.getAllChildMarkers();
            else if (layers instanceof L.LayerGroup) layers = layers._layers;
            else if (layers instanceof L.MarkerCluster) layers = layers.getAllChildMarkers();
            else if (layers instanceof L.Marker) layers = [
                layers
            ];
             // else: must be an Array(L.Marker)|Map(L.Marker)
            this._flagParentsIconsNeedUpdate(layers);
            this._refreshClustersIcons();
            // In case of singleMarkerMode, also re-draw the markers.
            if (this.options.singleMarkerMode) this._refreshSingleMarkerModeMarkers(layers);
            return this;
        },
        /**
		 * Simply flags all parent clusters of the given markers as having a "dirty" icon.
		 * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
		 * @private
		 */ _flagParentsIconsNeedUpdate: function(layers) {
            var id, parent;
            // Assumes layers is an Array or an Object whose prototype is non-enumerable.
            for(id in layers){
                // Flag parent clusters' icon as "dirty", all the way up.
                // Dumb process that flags multiple times upper parents, but still
                // much more efficient than trying to be smart and make short lists,
                // at least in the case of a hierarchy following a power law:
                // http://jsperf.com/flag-nodes-in-power-hierarchy/2
                parent = layers[id].__parent;
                while(parent){
                    parent._iconNeedsUpdate = true;
                    parent = parent.__parent;
                }
            }
        },
        /**
		 * Re-draws the icon of the supplied markers.
		 * To be used in singleMarkerMode only.
		 * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
		 * @private
		 */ _refreshSingleMarkerModeMarkers: function(layers) {
            var id, layer;
            for(id in layers){
                layer = layers[id];
                // Make sure we do not override markers that do not belong to THIS group.
                if (this.hasLayer(layer)) // Need to re-create the icon first, then re-draw the marker.
                layer.setIcon(this._overrideMarkerIcon(layer));
            }
        }
    });
    L.Marker.include({
        /**
		 * Updates the given options in the marker's icon and refreshes the marker.
		 * @param options map object of icon options.
		 * @param directlyRefreshClusters boolean (optional) true to trigger
		 * MCG.refreshClustersOf() right away with this single marker.
		 * @returns {L.Marker}
		 */ refreshIconOptions: function(options, directlyRefreshClusters) {
            var icon = this.options.icon;
            L.setOptions(icon, options);
            this.setIcon(icon);
            // Shortcut to refresh the associated MCG clusters right away.
            // To be used when refreshing a single marker.
            // Otherwise, better use MCG.refreshClusters() once at the end with
            // the list of modified markers.
            if (directlyRefreshClusters && this.__parent) this.__parent._group.refreshClusters(this);
            return this;
        }
    });
    exports1.MarkerClusterGroup = MarkerClusterGroup;
    exports1.MarkerCluster = MarkerCluster;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $6325c75dd85873c8$exports = {};
var $551ae73cf09ae122$exports = {};

$parcel$export($551ae73cf09ae122$exports, "marker", function () { return $551ae73cf09ae122$export$ffc4d0086f1a4c9; });

var $06d0781cb0ee49c1$exports = {};

$06d0781cb0ee49c1$exports = (parcelRequire("izFpB")).getBundleURL('hXipH') + "../img/marker.b594a3a6.avif";


var $f0713d16f1c3789b$exports = {};

$f0713d16f1c3789b$exports = (parcelRequire("izFpB")).getBundleURL('hXipH') + "../img/marker.cf2a53b0.webp";


var $9367d4701aebb11f$exports = {};

$9367d4701aebb11f$exports = (parcelRequire("izFpB")).getBundleURL('hXipH') + "../img/marker.fba501e5.png";


var $63f04a05e82ebdd8$exports = {};

$63f04a05e82ebdd8$exports = (parcelRequire("izFpB")).getBundleURL('hXipH') + "../img/marker.a1ecd672.avif";


var $19ee671b8425aeaa$exports = {};

$19ee671b8425aeaa$exports = (parcelRequire("izFpB")).getBundleURL('hXipH') + "../img/marker.1c0d9437.webp";


var $8078d042914c9ed8$exports = {};

$8078d042914c9ed8$exports = (parcelRequire("izFpB")).getBundleURL('hXipH') + "../img/marker.67b1ebb5.png";


var $1c8b89d4d30126ac$exports = {};

$1c8b89d4d30126ac$exports = (parcelRequire("izFpB")).getBundleURL('hXipH') + "../img/marker.d042c242.avif";


var $f79da7686005bcdc$exports = {};

$f79da7686005bcdc$exports = (parcelRequire("izFpB")).getBundleURL('hXipH') + "../img/marker.b6ee239b.webp";


var $19809b2eeef3334c$exports = {};

$19809b2eeef3334c$exports = (parcelRequire("izFpB")).getBundleURL('hXipH') + "../img/marker.cd558e3c.png";


function $76ff08df1ec3a54a$export$5d0606a13b21f3f8(popupTemplate, metadata) {
    return popupTemplate.replaceAll("{{title}}", metadata.title).replaceAll("{{country}}", metadata.country).replaceAll("{{period}}", metadata.period).replaceAll("{{alt}}", metadata.alt);
}
const $76ff08df1ec3a54a$var$markerOptions = {};
const $76ff08df1ec3a54a$var$popupOptions = {
    autoPan: true,
    autoPanPadding: [
        16,
        16
    ]
};
const $76ff08df1ec3a54a$var$tooltipOptions = {};
function $76ff08df1ec3a54a$export$46b32044f78fe9b1(popup, metadata) {
    let coordinates = metadata.coordinates;
    let offsetLeftCoordinates = [
        coordinates[0],
        coordinates[1] + 360
    ];
    let offsetRightCoordinates = [
        coordinates[0],
        coordinates[1] - 360
    ];
    return [
        coordinates,
        offsetLeftCoordinates,
        offsetRightCoordinates
    ].map((coordinates)=>{
        return (0, $4b5e7420e94bb43f$exports.marker)(coordinates, {
            ...$76ff08df1ec3a54a$var$markerOptions,
            icon: $76ff08df1ec3a54a$var$createMarkerIcon()
        }).bindPopup($76ff08df1ec3a54a$export$5d0606a13b21f3f8(popup, metadata), $76ff08df1ec3a54a$var$popupOptions).bindTooltip(metadata.tooltip, $76ff08df1ec3a54a$var$tooltipOptions);
    });
}
// if you adjust this, make sure to adjust the imports at the top of the file
// otherwise, the marker will look bad due to low resolution
const $76ff08df1ec3a54a$var$iconSize = 64;
function $76ff08df1ec3a54a$var$createMarkerIcon() {
    let picture = document.createElement("picture");
    let avifSource = document.createElement("source");
    let webpSource = document.createElement("source");
    let pngFallback = document.createElement("img");
    avifSource.srcset = `${0, (/*@__PURE__*/$parcel$interopDefault($06d0781cb0ee49c1$exports))}, ${0, (/*@__PURE__*/$parcel$interopDefault($63f04a05e82ebdd8$exports))} 2x, ${0, (/*@__PURE__*/$parcel$interopDefault($1c8b89d4d30126ac$exports))} 4x`;
    avifSource.type = "image/avif";
    webpSource.srcset = `${0, (/*@__PURE__*/$parcel$interopDefault($f0713d16f1c3789b$exports))}, ${0, (/*@__PURE__*/$parcel$interopDefault($19ee671b8425aeaa$exports))} 2x, ${0, (/*@__PURE__*/$parcel$interopDefault($f79da7686005bcdc$exports))} 4x`;
    webpSource.type = "image/webp";
    pngFallback.srcset = `${0, (/*@__PURE__*/$parcel$interopDefault($9367d4701aebb11f$exports))}, ${0, (/*@__PURE__*/$parcel$interopDefault($8078d042914c9ed8$exports))} 2x, ${0, (/*@__PURE__*/$parcel$interopDefault($19809b2eeef3334c$exports))} 4x`;
    pngFallback.src = (0, (/*@__PURE__*/$parcel$interopDefault($9367d4701aebb11f$exports)));
    pngFallback.width = $76ff08df1ec3a54a$var$iconSize;
    pngFallback.height = $76ff08df1ec3a54a$var$iconSize;
    picture.append(avifSource, webpSource, pngFallback);
    return (0, $4b5e7420e94bb43f$exports.divIcon)({
        attribution: "test",
        iconSize: [
            $76ff08df1ec3a54a$var$iconSize,
            $76ff08df1ec3a54a$var$iconSize
        ],
        iconAnchor: [
            760 / 1519 * $76ff08df1ec3a54a$var$iconSize,
            1354 / 1519 * $76ff08df1ec3a54a$var$iconSize
        ],
        popupAnchor: [
            0,
            -$76ff08df1ec3a54a$var$iconSize / 8 * 7
        ],
        tooltipAnchor: [
            $76ff08df1ec3a54a$var$iconSize / 16 * 5,
            -$76ff08df1ec3a54a$var$iconSize / 2
        ],
        html: picture,
        className: undefined
    });
}


var $e3e298387afa609e$exports = {};
$e3e298387afa609e$exports = JSON.parse("{\"coordinates\":[42.41709979512444,-103.75253581723486],\"tooltip\":\"Agate\",\"title\":\"Agate Fossil Beds National Monument\",\"country\":\"United States\",\"period\":\"Neogene\",\"alt\":\"TODO\"}");


var $3f7d345475b5af54$exports = {};
$3f7d345475b5af54$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.2a368bd1.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.62b60192.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.84bc5fba.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.fa7f8253.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.85de55d5.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.ebcfc278.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.a8ae072c.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.077bc87e.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.ba77ee9c.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.cb1220a7.png 250w, https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.ef11c4f2.png 500w, https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.ba77ee9c.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Agate_Fossil_beds_01b.214492eb.png 2000w\"> </picture>";


function $551ae73cf09ae122$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($3f7d345475b5af54$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($e3e298387afa609e$exports))));
}


var $ca7c5d298d3cf07a$exports = {};

$parcel$export($ca7c5d298d3cf07a$exports, "marker", function () { return $ca7c5d298d3cf07a$export$ffc4d0086f1a4c9; });

var $55697551ca284667$exports = {};
$55697551ca284667$exports = JSON.parse("{\"coordinates\":[44.44782737595892,103.93033135961969],\"tooltip\":\"Djadochta\",\"title\":\"Djadocta Formation\",\"country\":\"Mongolia\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $4672c3953608fcfa$exports = {};
$4672c3953608fcfa$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.a11e78aa.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.dfde4ac3.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.b9c59303.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.6d34be60.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.a341fa00.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.326eec2c.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.feed5014.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.b808b07b.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.3a39004e.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.63079736.png 250w, https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.39915091.png 500w, https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.3a39004e.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Djadochta_formation_01.95975e57.png 2000w\"> </picture>";


function $ca7c5d298d3cf07a$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($4672c3953608fcfa$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($55697551ca284667$exports))));
}


var $7b335cf6c3b4545f$exports = {};

$parcel$export($7b335cf6c3b4545f$exports, "marker", function () { return $7b335cf6c3b4545f$export$ffc4d0086f1a4c9; });

var $89fc94fcab0fff08$exports = {};
$89fc94fcab0fff08$exports = JSON.parse("{\"coordinates\":[-30.049164968711125,27.278132421292298],\"tooltip\":\"Elliot\",\"title\":\"Ellito Formatioon\",\"country\":\"South Africa & Lesotho\",\"period\":\"Jurassic\",\"alt\":\"TODO\"}");


var $ab403663787e37d4$exports = {};
$ab403663787e37d4$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.92cf9934.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.046a05d3.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.6a943fb8.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.de525876.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.2e7bc9de.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.15335951.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.f1ef09d2.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.8dc88401.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.08dad79e.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.5925a654.png 250w, https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.a1e30bb4.png 500w, https://montanoceratops.github.io/Formations/assets/img/Elliot_Formatio_02.08dad79e.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.0fa11609.png 2000w\"> </picture>";


function $7b335cf6c3b4545f$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($ab403663787e37d4$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($89fc94fcab0fff08$exports))));
}


var $a3e56486af516883$exports = {};

$parcel$export($a3e56486af516883$exports, "marker", function () { return $a3e56486af516883$export$ffc4d0086f1a4c9; });

var $bc82e397142be1fb$exports = {};
$bc82e397142be1fb$exports = JSON.parse("{\"coordinates\":[41.80456844918382,15.482990432372304],\"tooltip\":\"Gargano\",\"title\":\"Gargano Island (Mikrotia Fauna)\",\"country\":\"Italy\",\"period\":\"Neogene\",\"alt\":\"TODO\"}");


var $85b9a2d53b735873$exports = {};
$85b9a2d53b735873$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.25aa4be3.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.4a392f9a.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.0b666e7b.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.acfdfd51.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.7304aacb.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.2af70c43.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.f2f26d44.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.27e26f1d.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.4e3cf911.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.2ecc1208.png 250w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.fd33f908.png 500w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.4e3cf911.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.0fa11609.png 2000w\"> </picture>";


function $a3e56486af516883$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($85b9a2d53b735873$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($bc82e397142be1fb$exports))));
}


var $f2f8136e7501d50e$exports = {};

$parcel$export($f2f8136e7501d50e$exports, "marker", function () { return $f2f8136e7501d50e$export$ffc4d0086f1a4c9; });

var $ecf0b1d95ca13e4c$exports = {};
$ecf0b1d95ca13e4c$exports = JSON.parse("{\"coordinates\":[-19.55541876385942,125.32702506945822],\"tooltip\":\"Gogo\",\"title\":\"Gogo Formation\",\"country\":\"Australia\",\"period\":\"Devonian\",\"alt\":\"TODO\"}");


var $2ced38a29222eb83$exports = {};
$2ced38a29222eb83$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.830adbbd.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.8a5b41ee.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.4f758cb6.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.aec9f5ed.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.776b12bd.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.66d618e3.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.8ff02e83.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.1226e976.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.d05b598b.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.2ce69a5e.png 250w, https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.29fc1d8e.png 500w, https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.d05b598b.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Gogo_formation.ff128506.png 2000w\"> </picture>";


function $f2f8136e7501d50e$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($2ced38a29222eb83$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($ecf0b1d95ca13e4c$exports))));
}


var $789463c0e23b4301$exports = {};

$parcel$export($789463c0e23b4301$exports, "marker", function () { return $789463c0e23b4301$export$ffc4d0086f1a4c9; });

var $4ef53a5d21e7bb49$exports = {};
$4ef53a5d21e7bb49$exports = JSON.parse("{\"coordinates\":[47.92731841568056,10.590585771501367],\"tooltip\":\"Hammerschmiede\",\"title\":\"Hammerschmiede Clay Pit\",\"country\":\"Germany\",\"period\":\"Neogene\",\"alt\":\"TODO\"}");


var $44e03cffde07bb51$exports = {};
$44e03cffde07bb51$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.b7b205ba.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.b1908e9e.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.bfeb288f.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.aef696fb.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.e51c8ef4.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.15588104.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.3df6b768.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.96a4048f.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.202bf1e1.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.1dd73a96.png 250w, https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.2769224e.png 500w, https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.202bf1e1.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Hammerschmiede_b.dd87f709.png 2000w\"> </picture>";


function $789463c0e23b4301$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($44e03cffde07bb51$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($4ef53a5d21e7bb49$exports))));
}


var $b4794cb3d05cf694$exports = {};

$parcel$export($b4794cb3d05cf694$exports, "marker", function () { return $b4794cb3d05cf694$export$ffc4d0086f1a4c9; });

var $f926b1bc077ce0bc$exports = {};
$f926b1bc077ce0bc$exports = JSON.parse("{\"coordinates\":[39.90580703887878,-74.85832237393018],\"tooltip\":\"Hornerstown\",\"title\":\"Hornerstown Formation\",\"country\":\"United States\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $4a92b8dd6a160cc1$exports = {};
$4a92b8dd6a160cc1$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.128d3941.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.db90702c.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.6c180373.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.8d59f03a.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.0eeb7864.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.992bf6ab.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.9b995da4.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.a8094cee.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.2ddf926a.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.eed26b11.png 250w, https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.e329aea3.png 500w, https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.2ddf926a.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Hornerstown_formation_01.cffc7a6d.png 2000w\"> </picture>";


function $b4794cb3d05cf694$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($4a92b8dd6a160cc1$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($f926b1bc077ce0bc$exports))));
}


var $b30ff45628b51db8$exports = {};

$parcel$export($b30ff45628b51db8$exports, "marker", function () { return $b30ff45628b51db8$export$ffc4d0086f1a4c9; });

var $5f0c942eb61884ef$exports = {};
$5f0c942eb61884ef$exports = JSON.parse("{\"coordinates\":[43.43539345541092,112.15701558512575],\"tooltip\":\"Irdin\",\"title\":\"Irdin Manha Formation\",\"country\":\"China\",\"period\":\"Paleogene\",\"alt\":\"TODO\"}");


var $6dea7cfb678301e6$exports = {};
$6dea7cfb678301e6$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.05bfb005.avif 250w, https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.368c3e7e.avif 500w, https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.14115579.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.01b36026.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.44590001.webp 250w, https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.bb75fe94.webp 500w, https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.433874d3.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.17b35bbf.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.214903c9.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.c035481f.png 250w, https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.8d1c1b62.png 500w, https://montanoceratops.github.io/Formations/assets/img/irdin_manha_formation_01.214903c9.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.0fa11609.png 2000w\"> </picture>";


function $b30ff45628b51db8$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($6dea7cfb678301e6$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($5f0c942eb61884ef$exports))));
}


var $9fd2106fc0eca13f$exports = {};

$parcel$export($9fd2106fc0eca13f$exports, "marker", function () { return $9fd2106fc0eca13f$export$ffc4d0086f1a4c9; });

var $4f869b23e6f6578a$exports = {};
$4f869b23e6f6578a$exports = JSON.parse("{\"coordinates\":[-30.072871,-67.935122],\"tooltip\":\"Ischigualasto\",\"title\":\"Ischigualasto Formation\",\"country\":\"Argentina\",\"period\":\"Triassic\",\"alt\":\"TODO\"}");


var $4ebb8ce9edea17ef$exports = {};
$4ebb8ce9edea17ef$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.2456f746.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.62f270b5.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.ccb22290.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.bae88197.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.081a62d1.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.c314e52f.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.7db768f8.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.8e5900d8.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.3543d72e.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.bf55734a.png 250w, https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.43422761.png 500w, https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.3543d72e.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Ischigualasto.a9e75792.png 2000w\"> </picture>";


function $9fd2106fc0eca13f$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($4ebb8ce9edea17ef$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($4f869b23e6f6578a$exports))));
}


var $f8173caf796d52e9$exports = {};

$parcel$export($f8173caf796d52e9$exports, "marker", function () { return $f8173caf796d52e9$export$ffc4d0086f1a4c9; });

var $493e0492876e9cca$exports = {};
$493e0492876e9cca$exports = JSON.parse("{\"coordinates\":[30.63594369292629,104.89501790713285],\"tooltip\":\"Jialingjiang\",\"title\":\"Jialingjiang Formation\",\"country\":\"China\",\"period\":\"Triassic\",\"alt\":\"TODO\"}");


var $002259d22b6dc8ea$exports = {};
$002259d22b6dc8ea$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.d82a6854.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.0f3c6ddd.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.d706b65b.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.0c75dcd7.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.deb1b3bc.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.be85255b.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.68a9fc83.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.cdd75a8d.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.b5b2ef08.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.d4516710.png 250w, https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.2db37eb6.png 500w, https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.b5b2ef08.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Jialingjiang_Formation.dbd498ba.png 2000w\"> </picture>";


function $f8173caf796d52e9$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($002259d22b6dc8ea$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($493e0492876e9cca$exports))));
}


var $8fd1bfffffa621c1$exports = {};

$parcel$export($8fd1bfffffa621c1$exports, "marker", function () { return $8fd1bfffffa621c1$export$ffc4d0086f1a4c9; });

var $6d3dbe9c56c917ce$exports = {};
$6d3dbe9c56c917ce$exports = JSON.parse("{\"coordinates\":[45.68521959138306,-64.45202801148571],\"tooltip\":\"Joggins\",\"title\":\"Joggins Formation\",\"country\":\"Canada\",\"period\":\"Carboniferous\",\"alt\":\"TODO\"}");


var $bf716a7b1ab17101$exports = {};
$bf716a7b1ab17101$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.32da46a4.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.29a83ace.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.a8188233.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.bb53b5e7.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.b86d5b89.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.4e29b56b.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.6e01b071.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.e2f19722.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.2856361a.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.db292f46.png 250w, https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.a9e766fe.png 500w, https://montanoceratops.github.io/Formations/assets/img/Joggins_Formation_01b.2856361a.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Gargano_01b.0fa11609.png 2000w\"> </picture>";


function $8fd1bfffffa621c1$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($bf716a7b1ab17101$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($6d3dbe9c56c917ce$exports))));
}


var $67b7cd4a40ad2809$exports = {};

$parcel$export($67b7cd4a40ad2809$exports, "marker", function () { return $67b7cd4a40ad2809$export$ffc4d0086f1a4c9; });

var $6129b0d5f21280cb$exports = {};
$6129b0d5f21280cb$exports = JSON.parse("{\"coordinates\":[47.735,-109.646111],\"tooltip\":\"Judith River\",\"title\":\"Judith River Formation\",\"country\":\"United States\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $b76cd5e40c159811$exports = {};
$b76cd5e40c159811$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Judith_River.4f78f278.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Judith_River.ba6fc33e.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Judith_River.fe9a0006.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Judith_River.b77b765a.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Judith_River.c32cc4b0.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Judith_River.99dae702.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Judith_River.4575579b.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Judith_River.ea0c931f.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Judith_River.b900e733.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Judith_River.5a5fb7dd.png 250w, https://montanoceratops.github.io/Formations/assets/img/Judith_River.8a0db008.png 500w, https://montanoceratops.github.io/Formations/assets/img/Judith_River.b900e733.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Judith_River.8cdb8504.png 2000w\"> </picture>";


function $67b7cd4a40ad2809$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($b76cd5e40c159811$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($6129b0d5f21280cb$exports))));
}


var $c1a289a79e8af45c$exports = {};

$parcel$export($c1a289a79e8af45c$exports, "marker", function () { return $c1a289a79e8af45c$export$ffc4d0086f1a4c9; });

var $136a640304594187$exports = {};
$136a640304594187$exports = JSON.parse("{\"coordinates\":[25.9500002,103.85],\"tooltip\":\"Kuanti\",\"title\":\"Kuanti Formation\",\"country\":\"China\",\"period\":\"Silurian\",\"alt\":\"TODO\"}");


var $24474da9e85b3cdb$exports = {};
$24474da9e85b3cdb$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.dbd06260.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.8f058e51.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.4eefc16b.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.2e8e96c5.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.e2adac55.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.7bf71fdc.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.400ed4f0.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.5341f79c.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.7a6f4d97.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.06930e08.png 250w, https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.86a6afa8.png 500w, https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.7a6f4d97.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Kuanti_01b.40a11bfb.png 2000w\"> </picture>";


function $c1a289a79e8af45c$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($24474da9e85b3cdb$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($136a640304594187$exports))));
}


var $9f6d1400c175ce76$exports = {};

$parcel$export($9f6d1400c175ce76$exports, "marker", function () { return $9f6d1400c175ce76$export$ffc4d0086f1a4c9; });

var $f51b31d23f2f8841$exports = {};
$f51b31d23f2f8841$exports = JSON.parse("{\"coordinates\":[43.42382432953133,-103.48338094822556],\"tooltip\":\"Mammoth\",\"title\":\"The Mammoth Site\",\"country\":\"United States\",\"period\":\"Quaternary\",\"alt\":\"TODO\"}");


var $66338daf2f0380fe$exports = {};
$66338daf2f0380fe$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.42e4969f.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.18113871.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.3692bc1f.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.55f388c2.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.047953dd.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.53e49039.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.086b9568.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.e21debea.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.9c89b185.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.60fb1a8d.png 250w, https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.70295183.png 500w, https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.9c89b185.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Mammoth_Site_01.b97cc2d1.png 2000w\"> </picture>";


function $9f6d1400c175ce76$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($66338daf2f0380fe$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($f51b31d23f2f8841$exports))));
}


var $7f9b57a779c9f459$exports = {};

$parcel$export($7f9b57a779c9f459$exports, "marker", function () { return $7f9b57a779c9f459$export$ffc4d0086f1a4c9; });

var $f6440c32bdde81ef$exports = {};
$f6440c32bdde81ef$exports = JSON.parse("{\"coordinates\":[45.60038521250078,11.222187644407711],\"tooltip\":\"Bolca\",\"title\":\"Pesciara (Monte Bolca)\",\"country\":\"Italy\",\"period\":\"Paleogene\",\"alt\":\"TODO\"}");


var $545d49721339b056$exports = {};
$545d49721339b056$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.06928825.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.be23ec6d.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.11cbab11.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.98dbd1c6.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.bf4e6600.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.aeec9f70.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.9168cd04.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.6f0dee1e.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.1e370a87.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.47f97fc7.png 250w, https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.87da5272.png 500w, https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.1e370a87.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Monte_Bolca_01.c32395ae.png 2000w\"> </picture>";


function $7f9b57a779c9f459$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($545d49721339b056$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($f6440c32bdde81ef$exports))));
}


var $fc4f527e1e39e76e$exports = {};

$parcel$export($fc4f527e1e39e76e$exports, "marker", function () { return $fc4f527e1e39e76e$export$ffc4d0086f1a4c9; });

var $fd524e2ab5644b93$exports = {};
$fd524e2ab5644b93$exports = JSON.parse("{\"coordinates\":[62.55,-127.75],\"tooltip\":\"Moth\",\"title\":\"Man on the Hill Locality (MOTH)\",\"country\":\"Canada\",\"period\":\"Devonian\",\"alt\":\"TODO\"}");


var $4c0f45d06ab1ab75$exports = {};
$4c0f45d06ab1ab75$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.3fc33aff.avif 250w, https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.e9e27789.avif 500w, https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.33a1f063.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.02f74139.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.bd405b29.webp 250w, https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.b2bf1573.webp 500w, https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.364763e7.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.45979b56.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.ed14829e.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.d07bcdc0.png 250w, https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.37661166.png 500w, https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.ed14829e.png 1000w, https://montanoceratops.github.io/Formations/assets/img/MOTH_locality_01b.58dc6175.png 2000w\"> </picture>";


function $fc4f527e1e39e76e$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($4c0f45d06ab1ab75$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($fd524e2ab5644b93$exports))));
}


var $734b3e987c5e2bc0$exports = {};

$parcel$export($734b3e987c5e2bc0$exports, "marker", function () { return $734b3e987c5e2bc0$export$ffc4d0086f1a4c9; });

var $fe314d32f166215f$exports = {};
$fe314d32f166215f$exports = JSON.parse("{\"coordinates\":[54.909951349334534,52.71835728712716],\"tooltip\":\"Ocher\",\"title\":\"Ocher Faunal Assemblage Zone\",\"country\":\"Russia\",\"period\":\"Permian\",\"alt\":\"TODO\"}");


var $ae67aa1c33408b60$exports = {};
$ae67aa1c33408b60$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.8276380f.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.93858f39.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.2c59156b.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.ad22d375.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.0846e5b0.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.a05821f6.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.e999be8d.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.fb6f10a3.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.1d83c51c.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.dade2eaf.png 250w, https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.87e61964.png 500w, https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.1d83c51c.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Ocher_Assamblage_01.b6e28fce.png 2000w\"> </picture>";


function $734b3e987c5e2bc0$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($ae67aa1c33408b60$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($fe314d32f166215f$exports))));
}


var $3880c444ace20af8$exports = {};

$parcel$export($3880c444ace20af8$exports, "marker", function () { return $3880c444ace20af8$export$ffc4d0086f1a4c9; });

var $9dced307586c0b95$exports = {};
$9dced307586c0b95$exports = JSON.parse("{\"coordinates\":[55.60247570088774,-3.9005029778093103],\"tooltip\":\"Patrick Burn\",\"title\":\"Patrick Burn Formation\",\"country\":\"Scotland (UK)\",\"period\":\"Silurian\",\"alt\":\"TODO\"}");


var $b48d3c5a9c9d6d09$exports = {};
$b48d3c5a9c9d6d09$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.93d6a89f.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.0e2f94ff.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.ce6be306.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.a740e600.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.7afb985f.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.cb294334.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.d58e05a0.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.806315f3.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.00d4af51.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.d78d5992.png 250w, https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.96a9bcb2.png 500w, https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.00d4af51.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Patrick_Burn_formation_01.19921d92.png 2000w\"> </picture>";


function $3880c444ace20af8$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($b48d3c5a9c9d6d09$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($9dced307586c0b95$exports))));
}


var $57af23b5ac33cb3f$exports = {};

$parcel$export($57af23b5ac33cb3f$exports, "marker", function () { return $57af23b5ac33cb3f$export$ffc4d0086f1a4c9; });

var $bd7c8874135f7e6a$exports = {};
$bd7c8874135f7e6a$exports = JSON.parse("{\"coordinates\":[57.32148692092076,-2.8456429889866968],\"tooltip\":\"Rhynie Chert\",\"title\":\"Rhynie Chert\",\"country\":\"UK\",\"period\":\"Devonian\",\"alt\":\"TODO\"}");


var $b1f3708c945ed520$exports = {};
$b1f3708c945ed520$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.812ddf72.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.4a62ee86.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.995fee08.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.040e69ae.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.43e6c4d4.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.c8aa8fd6.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.9d366dbd.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.dc2aa9c5.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.e35faaf4.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.1a770c4f.png 250w, https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.80061bce.png 500w, https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.e35faaf4.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Rhynie_Chert.c7500e7e.png 2000w\"> </picture>";


function $57af23b5ac33cb3f$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($b1f3708c945ed520$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($bd7c8874135f7e6a$exports))));
}


var $335490c930f01b5e$exports = {};

$parcel$export($335490c930f01b5e$exports, "marker", function () { return $335490c930f01b5e$export$ffc4d0086f1a4c9; });

var $c25b4f6af730c350$exports = {};
$c25b4f6af730c350$exports = JSON.parse("{\"coordinates\":[-32.677829209565346,151.7892546042954],\"tooltip\":\"Seaham\",\"title\":\"Seaham Quarry\",\"country\":\"Australia\",\"period\":\"Carboniferous\",\"alt\":\"TODO\"}");


var $734ccec0bcf6d738$exports = {};
$734ccec0bcf6d738$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.38a59f36.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.725940fb.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.98047e16.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.076d8041.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.e21e350b.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.d39e5804.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.8164508d.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.ee1af9d4.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.3598c542.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.8b31048f.png 250w, https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.4b4abef2.png 500w, https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.3598c542.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Seaham_formation.e7e07db4.png 2000w\"> </picture>";


function $335490c930f01b5e$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($734ccec0bcf6d738$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($c25b4f6af730c350$exports))));
}


var $3d45c869629979a0$exports = {};

$parcel$export($3d45c869629979a0$exports, "marker", function () { return $3d45c869629979a0$export$ffc4d0086f1a4c9; });

var $6733d3cbff61635b$exports = {};
$6733d3cbff61635b$exports = JSON.parse("{\"coordinates\":[82.8323702198384,-42.449729358624325],\"tooltip\":\"Sirius Passet\",\"title\":\"Sirius Passet\",\"country\":\"Greenland (Denmark)\",\"period\":\"Cambrian\",\"alt\":\"TODO\"}");


var $8bacf6d6acb5faf8$exports = {};
$8bacf6d6acb5faf8$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.e177e970.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.69f1a7bf.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.15a72588.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.7fd19a20.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.c61686cf.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.d0aa58d1.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.e1481e66.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.c58e88b9.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.226a2fea.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.388961ab.png 250w, https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.ac5eaeff.png 500w, https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.226a2fea.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Sirius_Passet.f351eef5.png 2000w\"> </picture>";


function $3d45c869629979a0$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($8bacf6d6acb5faf8$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($6733d3cbff61635b$exports))));
}


var $9bd783dda143a210$exports = {};

$parcel$export($9bd783dda143a210$exports, "marker", function () { return $9bd783dda143a210$export$ffc4d0086f1a4c9; });

var $60abcd2f1d52217e$exports = {};
$60abcd2f1d52217e$exports = JSON.parse('{"coordinates":[48.898945036161024,11.002373806097921],"tooltip":"Solnhofen","title":"Altm\xfchltal Formation (Solnhofen Limestone)","country":"Germany","period":"Jurassic","alt":"TODO"}');


var $5cadf7879366a546$exports = {};
$5cadf7879366a546$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.8fec2171.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.cb11b656.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.4108ff4f.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.3a36cc59.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.3994654a.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.304440c1.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.29f8f004.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.d4b43208.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.ae914e31.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.91cb535f.png 250w, https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.86d2b18f.png 500w, https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.ae914e31.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Solnhofen_01.7b3a6aef.png 2000w\"> </picture>";


function $9bd783dda143a210$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($5cadf7879366a546$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($60abcd2f1d52217e$exports))));
}


var $3f9f84827c89dd7d$exports = {};

$parcel$export($3f9f84827c89dd7d$exports, "marker", function () { return $3f9f84827c89dd7d$export$ffc4d0086f1a4c9; });

var $1bbbf868c7f034db$exports = {};
$1bbbf868c7f034db$exports = JSON.parse("{\"coordinates\":[-4.601558255865271,-81.26703339531525],\"tooltip\":\"Talara\",\"title\":\"Talara Tar Seeps\",\"country\":\"Peru\",\"period\":\"Quaternary\",\"alt\":\"TODO\"}");


var $85c53eaac0767d97$exports = {};
$85c53eaac0767d97$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.4ac651ba.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.cac5ed3e.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.a63343e9.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.d2b53527.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.2d9b10bb.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.b6b384f5.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.4b30eea4.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.a906b950.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.bb463991.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.ca8ed729.png 250w, https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.f9f974bd.png 500w, https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.bb463991.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Talara_Tar_Seeps_06.4d42c08d.png 2000w\"> </picture>";


function $3f9f84827c89dd7d$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($85c53eaac0767d97$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($1bbbf868c7f034db$exports))));
}


var $52529b8ec5b84b3f$exports = {};

$parcel$export($52529b8ec5b84b3f$exports, "marker", function () { return $52529b8ec5b84b3f$export$ffc4d0086f1a4c9; });

var $ec7fb50e8bc8d6a2$exports = {};
$ec7fb50e8bc8d6a2$exports = JSON.parse("{\"coordinates\":[29.28607123338938,30.127281436428206],\"tooltip\":\"Wadi al Hitan\",\"title\":\"Wadi al Hitan (Temple Member)\",\"country\":\"Egypt\",\"period\":\"Paleogene\"}");


var $fcb525766d0eaea9$exports = {};
$fcb525766d0eaea9$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.7f507714.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.fb4dab1d.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.dab1ebe9.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.e01795ac.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.fc437fde.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.ea91e470.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.2d54fa3d.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.418348be.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.775ce006.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.1ceec059.png 250w, https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.ef9ea8ce.png 500w, https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.775ce006.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Wadi_al_Hitan_01.eb36679b.png 2000w\"> </picture>";


function $52529b8ec5b84b3f$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($fcb525766d0eaea9$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($ec7fb50e8bc8d6a2$exports))));
}


var $bb291615fed8ace5$exports = {};

$parcel$export($bb291615fed8ace5$exports, "marker", function () { return $bb291615fed8ace5$export$ffc4d0086f1a4c9; });

var $2a9c033974cf0103$exports = {};
$2a9c033974cf0103$exports = JSON.parse("{\"coordinates\":[33.59616532529229,-98.62554352709518],\"tooltip\":\"Archer City\",\"title\":\"Archer City Formation\",\"country\":\"United States\",\"period\":\"Permian\",\"alt\":\"TODO\"}");


var $4f720f9c4be530fc$exports = {};
$4f720f9c4be530fc$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/ArcherCity.52bef8fe.avif 250w, https://montanoceratops.github.io/Formations/assets/img/ArcherCity.dba77c07.avif 500w, https://montanoceratops.github.io/Formations/assets/img/ArcherCity.6b94cc49.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/ArcherCity.eab20a68.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/ArcherCity.2daa8c61.webp 250w, https://montanoceratops.github.io/Formations/assets/img/ArcherCity.98a0a467.webp 500w, https://montanoceratops.github.io/Formations/assets/img/ArcherCity.b4774797.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/ArcherCity.dbbeb0d5.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/ArcherCity.55c7f1bd.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/ArcherCity.c05857d8.png 250w, https://montanoceratops.github.io/Formations/assets/img/ArcherCity.142851e8.png 500w, https://montanoceratops.github.io/Formations/assets/img/ArcherCity.55c7f1bd.png 1000w, https://montanoceratops.github.io/Formations/assets/img/ArcherCity.b0b7f23f.png 2000w\"> </picture>";


function $bb291615fed8ace5$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($4f720f9c4be530fc$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($2a9c033974cf0103$exports))));
}


var $a647b9b33f8924f9$exports = {};

$parcel$export($a647b9b33f8924f9$exports, "marker", function () { return $a647b9b33f8924f9$export$ffc4d0086f1a4c9; });

var $8fa96b592b50de1d$exports = {};
$8fa96b592b50de1d$exports = JSON.parse("{\"coordinates\":[28.862668964316043,28.368058662925122],\"tooltip\":\"Bahariya\",\"title\":\"Bahariya Formation\",\"country\":\"Egypt\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $0b860dc1ab86da14$exports = {};
$0b860dc1ab86da14$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.e745975d.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.38b349cb.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.519b2f4e.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.47a3b425.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.4c8596e3.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.71bce768.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.8635874c.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.8a80235a.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.98d4a3d4.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.3d34aa71.png 250w, https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.427e56fe.png 500w, https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.98d4a3d4.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Bahariya_formation_01.9b0c603b.png 2000w\"> </picture>";


function $a647b9b33f8924f9$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($0b860dc1ab86da14$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($8fa96b592b50de1d$exports))));
}


var $dbe33d8db3b3a220$exports = {};

$parcel$export($dbe33d8db3b3a220$exports, "marker", function () { return $dbe33d8db3b3a220$export$ffc4d0086f1a4c9; });

var $c69884763cf47fb8$exports = {};
$c69884763cf47fb8$exports = JSON.parse("{\"coordinates\":[55.98526602415578,-4.276740929709632],\"tooltip\":\"Ballagan\",\"title\":\"Ballagan\",\"country\":\"Scotland, England (UK)\",\"period\":\"Carboniferous\",\"alt\":\"TODO\"}");


var $8bc03d4a3ab5847c$exports = {};
$8bc03d4a3ab5847c$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.cfb46951.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.9e2ef90b.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.596c65f4.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.3ca35208.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.d94fc1b7.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.426ca300.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.4a51bfc0.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.cd8863e4.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.ca1a906d.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.9c8afcda.png 250w, https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.95355722.png 500w, https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.ca1a906d.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Ballagan%20formation.0b599147.png 2000w\"> </picture>";


function $dbe33d8db3b3a220$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($8bc03d4a3ab5847c$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($c69884763cf47fb8$exports))));
}


var $2c7f7d7235251256$exports = {};

$parcel$export($2c7f7d7235251256$exports, "marker", function () { return $2c7f7d7235251256$export$ffc4d0086f1a4c9; });

var $6697ca6ed0289f2d$exports = {};
$6697ca6ed0289f2d$exports = JSON.parse("{\"coordinates\":[-44.870619345864405,169.81340594624066],\"tooltip\":\"St. Bathans\",\"title\":\"St. Bathans Fauna\",\"country\":\"New Zealand\",\"period\":\"Neogene\",\"alt\":\"TODO\"}");


var $3139f9c01458f610$exports = {};
$3139f9c01458f610$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.0e763547.avif 250w, https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.f75ecede.avif 500w, https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.b35f3bbe.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.05764656.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.40d3c4ef.webp 250w, https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.dcaebcdc.webp 500w, https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.491dfe69.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.7b92f71d.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.ffec2614.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.5625396d.png 250w, https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.d809a3ec.png 500w, https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.ffec2614.png 1000w, https://montanoceratops.github.io/Formations/assets/img/St_Bathans_Fauna.f2c5813a.png 2000w\"> </picture>";


function $2c7f7d7235251256$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($3139f9c01458f610$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($6697ca6ed0289f2d$exports))));
}


var $db6388a42059b63a$exports = {};

$parcel$export($db6388a42059b63a$exports, "marker", function () { return $db6388a42059b63a$export$ffc4d0086f1a4c9; });

var $40380d8dfb17e851$exports = {};
$40380d8dfb17e851$exports = JSON.parse("{\"coordinates\":[45.888794637449394,8.889514225976285],\"tooltip\":\"Besano\",\"title\":\"Besano Formation\",\"country\":\"Italy\",\"period\":\"Triassic\",\"alt\":\"TODO\"}");


var $89f833874d8f97fc$exports = {};
$89f833874d8f97fc$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.2a4b1eb6.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.c72c17ef.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.88afc411.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.f549a67b.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.c95e9b88.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.a5f734b9.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.c7020de1.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.988f7c2c.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.5fab62d6.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.fb7e0ae8.png 250w, https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.25c2a31a.png 500w, https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.5fab62d6.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Besano_Formatio_beta.d8f224bb.png 2000w\"> </picture>";


function $db6388a42059b63a$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($89f833874d8f97fc$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($40380d8dfb17e851$exports))));
}


var $7707c856ee02adab$exports = {};

$parcel$export($7707c856ee02adab$exports, "marker", function () { return $7707c856ee02adab$export$ffc4d0086f1a4c9; });

var $0e5555b769980f55$exports = {};
$0e5555b769980f55$exports = JSON.parse("{\"coordinates\":[34.063772000377824,-118.35631399475255],\"tooltip\":\"La Brea\",\"title\":\"La Brea Tar Pits\",\"country\":\"United States\",\"period\":\"Quaternary\",\"alt\":\"TODO\"}");


var $fa86b0ebcea647a5$exports = {};
$fa86b0ebcea647a5$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.038dfd81.avif 250w, https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.d34d1c14.avif 500w, https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.5093870c.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.21d81fa1.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.fbd6d4e1.webp 250w, https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.386d2868.webp 500w, https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.c6bc659d.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.2a170019.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.d2ed33cd.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.c91648e7.png 250w, https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.d53dff75.png 500w, https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.d2ed33cd.png 1000w, https://montanoceratops.github.io/Formations/assets/img/LaBrea_1.ed7c7c6f.png 2000w\"> </picture>";


function $7707c856ee02adab$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($fa86b0ebcea647a5$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($0e5555b769980f55$exports))));
}


var $19dbfe2edde848d1$exports = {};

$parcel$export($19dbfe2edde848d1$exports, "marker", function () { return $19dbfe2edde848d1$export$ffc4d0086f1a4c9; });

var $727c06cc53c0a88c$exports = {};
$727c06cc53c0a88c$exports = JSON.parse("{\"coordinates\":[50.01998375755653,10.668270609021704],\"tooltip\":\"Bromacker Quarry\",\"title\":\"Tambach Formation (Bromacker)\",\"country\":\"Germany\",\"period\":\"Permian\",\"alt\":\"TODO\"}");


var $c877793d3839c9ed$exports = {};
$c877793d3839c9ed$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bromacker.e49fd163.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Bromacker.6b80e327.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Bromacker.f0118df7.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Bromacker.e42882c1.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bromacker.ae4e7b26.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Bromacker.5a8d3a28.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Bromacker.00a45173.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Bromacker.1fe6d485.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Bromacker.c523729f.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bromacker.75b79516.png 250w, https://montanoceratops.github.io/Formations/assets/img/Bromacker.0ce9ce90.png 500w, https://montanoceratops.github.io/Formations/assets/img/Bromacker.c523729f.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Bromacker.603fb494.png 2000w\"> </picture>";


function $19dbfe2edde848d1$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($c877793d3839c9ed$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($727c06cc53c0a88c$exports))));
}


var $e25f31563f76b994$exports = {};

$parcel$export($e25f31563f76b994$exports, "marker", function () { return $e25f31563f76b994$export$ffc4d0086f1a4c9; });

var $3eec751deb34d6be$exports = {};
$3eec751deb34d6be$exports = JSON.parse("{\"coordinates\":[29.082009163316727,69.16344391234625],\"tooltip\":\"Bugti Hills\",\"title\":\"Bugti Hills\",\"country\":\"Pakistan\",\"period\":\"Paleogene\",\"alt\":\"TODO\"}");


var $9af1a2b55c01b7d9$exports = {};
$9af1a2b55c01b7d9$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.5d853a89.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.b3d1c867.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.4b2ac151.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.3f1acc83.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.eaa62d03.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.fac21f76.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.30440305.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.a7ff8ff3.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.1ce73032.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.a29fbcbf.png 250w, https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.081d23c0.png 500w, https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.1ce73032.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Bugti_hills.e52a63aa.png 2000w\"> </picture>";


function $e25f31563f76b994$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($9af1a2b55c01b7d9$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($3eec751deb34d6be$exports))));
}


var $b8b801ef7f5d834b$exports = {};

$parcel$export($b8b801ef7f5d834b$exports, "marker", function () { return $b8b801ef7f5d834b$export$ffc4d0086f1a4c9; });

var $f57280dada2c5fba$exports = {};
$f57280dada2c5fba$exports = JSON.parse("{\"coordinates\":[51.4382932977928,-116.47236584137684],\"tooltip\":\"Burgess\",\"title\":\"Burgess Shale (Walcott Quarry)\",\"country\":\"Canada\",\"period\":\"Cambrian\"}");


var $377eaf985fceafff$exports = {};
$377eaf985fceafff$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.24b113f3.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.ebb59b8d.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.b71047e0.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.9fb8d4c3.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.1bd4c9e2.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.e4e5184f.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.1a400ab5.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.dbc4a816.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.e92f2858.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.222d4cad.png 250w, https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.5057fa20.png 500w, https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.e92f2858.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Burgess_Shale_b.2df4e9d8.png 2000w\"> </picture>";


function $b8b801ef7f5d834b$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($377eaf985fceafff$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($f57280dada2c5fba$exports))));
}


var $fbdef30fd12f4543$exports = {};

$parcel$export($fbdef30fd12f4543$exports, "marker", function () { return $fbdef30fd12f4543$export$ffc4d0086f1a4c9; });

var $9ad76a46a6108dcf$exports = {};
$9ad76a46a6108dcf$exports = JSON.parse('{"coordinates":[43.894914606183875,5.145001863157773],"tooltip":"Cabri\xe8res","title":"Cabri\xe8res Biota","country":"France","period":"Ordovician"}');


var $d6e6b36196f350f6$exports = {};
$d6e6b36196f350f6$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cabrieres.ad6ce181.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Cabrieres.d28bff60.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Cabrieres.d665e2be.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Cabrieres.7bc97cf1.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cabrieres.46fa24df.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Cabrieres.e38f3d2b.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Cabrieres.433446b2.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Cabrieres.ab4ef87d.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Cabrieres.4713781c.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cabrieres.7a93f235.png 250w, https://montanoceratops.github.io/Formations/assets/img/Cabrieres.dae2c2ca.png 500w, https://montanoceratops.github.io/Formations/assets/img/Cabrieres.4713781c.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Cabrieres.72045f7e.png 2000w\"> </picture>";


function $fbdef30fd12f4543$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($d6e6b36196f350f6$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($9ad76a46a6108dcf$exports))));
}


var $2a8b9c475a44e5b2$exports = {};

$parcel$export($2a8b9c475a44e5b2$exports, "marker", function () { return $2a8b9c475a44e5b2$export$ffc4d0086f1a4c9; });

var $5ed7d66baec65660$exports = {};
$5ed7d66baec65660$exports = JSON.parse("{\"coordinates\":[-39.39920845707707,-69.18997510878265],\"tooltip\":\"Candeleros\",\"title\":\"Candeleros Formation\",\"country\":\"Argentina\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $2fd340793be05e90$exports = {};
$2fd340793be05e90$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Candeleros.25bc9f19.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Candeleros.1bc371fe.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Candeleros.66b0c843.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Candeleros.53c83e6e.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Candeleros.5df22a7d.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Candeleros.603a3e42.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Candeleros.098f5515.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Candeleros.498c7bf9.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Candeleros.b793ae70.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Candeleros.b51c296d.png 250w, https://montanoceratops.github.io/Formations/assets/img/Candeleros.6a79f057.png 500w, https://montanoceratops.github.io/Formations/assets/img/Candeleros.b793ae70.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Candeleros.96dabce6.png 2000w\"> </picture>";


function $2a8b9c475a44e5b2$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($2fd340793be05e90$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($5ed7d66baec65660$exports))));
}


var $8ff36a3d410c5a8d$exports = {};

$parcel$export($8ff36a3d410c5a8d$exports, "marker", function () { return $8ff36a3d410c5a8d$export$ffc4d0086f1a4c9; });

var $c2c4ef811c997080$exports = {};
$c2c4ef811c997080$exports = JSON.parse('{"coordinates":[-29.841732,-67.764815],"tooltip":"Cha\xf1ares","title":"Cha\xf1ares Formation","country":"Argentina","period":"Triassic","alt":"TODO"}');


var $bcdf7d25020662d9$exports = {};
$bcdf7d25020662d9$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.5cac3b16.avif 250w, https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.b7615e8b.avif 500w, https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.3b62d17c.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.7a85c7d9.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.bfbac417.webp 250w, https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.0ef4473d.webp 500w, https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.8d43023b.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.9d6c3503.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.66681e64.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.b7b3ee3e.png 250w, https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.f406043a.png 500w, https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.66681e64.png 1000w, https://montanoceratops.github.io/Formations/assets/img/chanares%20formation.336f7a71.png 2000w\"> </picture>";


function $8ff36a3d410c5a8d$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($bcdf7d25020662d9$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($c2c4ef811c997080$exports))));
}


var $2704c3925d7347fc$exports = {};

$parcel$export($2704c3925d7347fc$exports, "marker", function () { return $2704c3925d7347fc$export$ffc4d0086f1a4c9; });

var $3d68456cee970493$exports = {};
$3d68456cee970493$exports = JSON.parse("{\"coordinates\":[50.831182824322724,12.94285222123031],\"tooltip\":\"Chemnitz Petrified Forest\",\"title\":\"Leukersdorf Formation (Chemnitz Petrified Forest)\",\"country\":\"Germany\",\"period\":\"Permian\",\"alt\":\"TODO\"}");


var $2cca7d367d082c74$exports = {};
$2cca7d367d082c74$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Chemnitz.698554a2.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Chemnitz.f39e31b6.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Chemnitz.05cba09f.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Chemnitz.cc97dbb0.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Chemnitz.6112ec21.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Chemnitz.5243ca59.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Chemnitz.920e4527.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Chemnitz.1c43a6c2.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Chemnitz.27ccc5cc.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Chemnitz.93e8c13d.png 250w, https://montanoceratops.github.io/Formations/assets/img/Chemnitz.22557802.png 500w, https://montanoceratops.github.io/Formations/assets/img/Chemnitz.27ccc5cc.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Chemnitz.1d0d263b.png 2000w\"> </picture>";


function $2704c3925d7347fc$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($2cca7d367d082c74$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($3d68456cee970493$exports))));
}


var $67cf8eb27925fbb0$exports = {};

$parcel$export($67cf8eb27925fbb0$exports, "marker", function () { return $67cf8eb27925fbb0$export$ffc4d0086f1a4c9; });

var $5a5f63201cde59eb$exports = {};
$5a5f63201cde59eb$exports = JSON.parse("{\"coordinates\":[39.40359901613482,-83.59843529165065],\"tooltip\":\"Cleveland Shale\",\"title\":\"Cleveland Shale\",\"country\":\"United States\",\"period\":\"Devonian\",\"alt\":\"TODO\"}");


var $0c92703c05c684df$exports = {};
$0c92703c05c684df$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.e3abbc84.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.b2690b61.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.3cea9339.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.1d68ee8a.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.de6f5e4f.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.093f9d07.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.13cdd65b.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.aa0f6db7.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.5098d6b7.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.34d261c0.png 250w, https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.4057bea5.png 500w, https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.5098d6b7.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Cleveland_Shale_01.a44d40a1.png 2000w\"> </picture>";


function $67cf8eb27925fbb0$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($0c92703c05c684df$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($5a5f63201cde59eb$exports))));
}


var $1d3b02c042c39e18$exports = {};

$parcel$export($1d3b02c042c39e18$exports, "marker", function () { return $1d3b02c042c39e18$export$ffc4d0086f1a4c9; });

var $276998b1e87f09ce$exports = {};
$276998b1e87f09ce$exports = JSON.parse('{"coordinates":[49.97350392228259,6.052610171828547],"tooltip":"Consthum Lagerst\xe4tte","title":"Consthum Lagerst\xe4tte","country":"Luxembourg","period":"Devonian","alt":"TODO"}');


var $57ef895871970e27$exports = {};
$57ef895871970e27$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.558831ed.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.4b72952c.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.39eaf966.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.94d4248f.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.ebb129b6.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.01c7a696.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.ec62962c.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.4e9f7956.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.90fdcb84.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.05f4931c.png 250w, https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.8056b7da.png 500w, https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.90fdcb84.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Consthum_Quarry.d4e018df.png 2000w\"> </picture>";


function $1d3b02c042c39e18$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($57ef895871970e27$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($276998b1e87f09ce$exports))));
}


var $e827f24006b3f62b$exports = {};

$parcel$export($e827f24006b3f62b$exports, "marker", function () { return $e827f24006b3f62b$export$ffc4d0086f1a4c9; });

var $3b2506919c1657ca$exports = {};
$3b2506919c1657ca$exports = JSON.parse("{\"coordinates\":[-7.239643285949413,-39.41152046994259],\"tooltip\":\"Crato\",\"title\":\"Crato Formation\",\"country\":\"Brazil\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $605116b20a2feddd$exports = {};
$605116b20a2feddd$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Crato_1.6ece631c.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Crato_1.ef9f7c61.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Crato_1.830b47d9.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Crato_1.edfbf2ba.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Crato_1.1dd59220.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Crato_1.1472219d.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Crato_1.311c6a92.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Crato_1.398b50f1.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Crato_1.116bef2c.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Crato_1.614555a5.png 250w, https://montanoceratops.github.io/Formations/assets/img/Crato_1.fd126535.png 500w, https://montanoceratops.github.io/Formations/assets/img/Crato_1.116bef2c.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Crato_1.69fce5a7.png 2000w\"> </picture>";


function $e827f24006b3f62b$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($605116b20a2feddd$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($3b2506919c1657ca$exports))));
}


var $c225be3320034cff$exports = {};

$parcel$export($c225be3320034cff$exports, "marker", function () { return $c225be3320034cff$export$ffc4d0086f1a4c9; });

var $548c159b385c2efd$exports = {};
$548c159b385c2efd$exports = JSON.parse("{\"coordinates\":[38.8620170838191,-104.58994647270583],\"tooltip\":\"Corral Bluffs\",\"title\":\"Denver Formation (Corral Bluffs)\",\"country\":\"United States\",\"period\":\"Paleogene\",\"alt\":\"TODO\"}");


var $f7e7b6d45f8ac8fd$exports = {};
$f7e7b6d45f8ac8fd$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.951bc913.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.beab9b80.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.a34a2af5.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.85482b34.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.8190017d.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.0d9dd65f.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.43e25c0d.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.c5b6ca4a.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.66ac70bc.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.2af5a939.png 250w, https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.35e5066d.png 500w, https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.66ac70bc.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Corral_bluffs.ce06d5c2.png 2000w\"> </picture>";


function $c225be3320034cff$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($f7e7b6d45f8ac8fd$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($548c159b385c2efd$exports))));
}


var $6b86d8bbb1603e81$exports = {};

$parcel$export($6b86d8bbb1603e81$exports, "marker", function () { return $6b86d8bbb1603e81$export$ffc4d0086f1a4c9; });

var $7d055d4cfeb657e0$exports = {};
$7d055d4cfeb657e0$exports = JSON.parse("{\"coordinates\":[50.753815598246405,-111.47594943687538],\"tooltip\":\"Dinosaur Park\",\"title\":\"Dinosaur Park Formation\",\"country\":\"Canada\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $4cd1e07ecb247987$exports = {};
$4cd1e07ecb247987$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.29a37606.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.4437249a.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.3361f9c3.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.58e1fb56.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.d10dc005.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.ecbcd0ed.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.29a4e2d0.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.8839b674.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.2a6716c3.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.1a147f91.png 250w, https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.9e65dd66.png 500w, https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.2a6716c3.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Dinosaur_Park.7793d673.png 2000w\"> </picture>";


function $6b86d8bbb1603e81$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($4cd1e07ecb247987$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($7d055d4cfeb657e0$exports))));
}


var $96a1d60cae079797$exports = {};

$parcel$export($96a1d60cae079797$exports, "marker", function () { return $96a1d60cae079797$export$ffc4d0086f1a4c9; });

var $7bd4b07d094d6c53$exports = {};
$7bd4b07d094d6c53$exports = JSON.parse("{\"coordinates\":[31.932758634829796,35.23915226561854],\"tooltip\":\"Ein Yabrud\",\"title\":\"Ein Yabrud Quarry\",\"country\":\"Palestine\",\"period\":\"Cretaceous\"}");


var $661588472552f945$exports = {};
$661588472552f945$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.d902139e.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.136dba77.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.575d65cc.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.ebede1b0.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.c055c28e.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.7dd0795e.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.3a491cd4.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.4b86e788.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.2f16fd5b.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.36b5f929.png 250w, https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.d97f0260.png 500w, https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.2f16fd5b.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Ein_Yabrud_01.b25a6c52.png 2000w\"> </picture>";


function $96a1d60cae079797$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($661588472552f945$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($7bd4b07d094d6c53$exports))));
}


var $21b6c8014d463744$exports = {};

$parcel$export($21b6c8014d463744$exports, "marker", function () { return $21b6c8014d463744$export$ffc4d0086f1a4c9; });

var $ba236be5ce353ce0$exports = {};
$ba236be5ce353ce0$exports = JSON.parse("{\"coordinates\":[38.64507542926481,-97.1857868389542],\"tooltip\":\"Elmo\",\"title\":\"Wellington Formation (Elmo Fossil Site)\",\"country\":\"United States\",\"period\":\"Permian\"}");


var $4a319d3a79df3311$exports = {};
$4a319d3a79df3311$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Elmo_01.39e115e3.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Elmo_01.3db18bca.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Elmo_01.a8d22df7.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Elmo_01.859685eb.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Elmo_01.faa80997.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Elmo_01.3f128618.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Elmo_01.1ffa7d2b.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Elmo_01.6c315d64.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Elmo_01.91b26926.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Elmo_01.2ebb3d66.png 250w, https://montanoceratops.github.io/Formations/assets/img/Elmo_01.57aed099.png 500w, https://montanoceratops.github.io/Formations/assets/img/Elmo_01.91b26926.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Elmo_01.280731f1.png 2000w\"> </picture>";


function $21b6c8014d463744$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($4a319d3a79df3311$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($ba236be5ce353ce0$exports))));
}


var $abdc17920cf7eccf$exports = {};

$parcel$export($abdc17920cf7eccf$exports, "marker", function () { return $abdc17920cf7eccf$export$ffc4d0086f1a4c9; });

var $5ad9fbbe61dd34d3$exports = {};
$5ad9fbbe61dd34d3$exports = JSON.parse("{\"coordinates\":[-35.59573449710789,137.52176124100282],\"tooltip\":\"Emu Bay\",\"title\":\"Emu Bay Shale\",\"country\":\"Australia\",\"period\":\"Cambrian\",\"alt\":\"TODO\"}");


var $ef5f24c294c84b7f$exports = {};
$ef5f24c294c84b7f$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.ce2d5922.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.6c8f45fd.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.1543a14a.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.b5f4222b.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.07cb14ff.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.6a7e757b.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.6815ceaf.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.71bf0592.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.3f07c8d9.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.0b232aff.png 250w, https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.d944adb3.png 500w, https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.3f07c8d9.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Emu_bay_Shale.76c70c1a.png 2000w\"> </picture>";


function $abdc17920cf7eccf$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($ef5f24c294c84b7f$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($5ad9fbbe61dd34d3$exports))));
}


var $bf97ab8f001ba275$exports = {};

$parcel$export($bf97ab8f001ba275$exports, "marker", function () { return $bf97ab8f001ba275$export$ffc4d0086f1a4c9; });

var $e26753b202e3cee4$exports = {};
$e26753b202e3cee4$exports = JSON.parse("{\"coordinates\":[37.4396394036586,110.62931240832916],\"tooltip\":\"Ermaying\",\"title\":\"Ermaying Formation\",\"country\":\"China\",\"period\":\"Triassic\",\"alt\":\"TODO\"}");


var $31f1c0ea62e2a71b$exports = {};
$31f1c0ea62e2a71b$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.1520ba50.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.2785337e.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.fc20c31a.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.ca872586.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.63636b02.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.5db4c9b8.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.d53022ca.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.96ff80cc.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.a4e4d1dd.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.5fa2a3a8.png 250w, https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.cf5113ff.png 500w, https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.a4e4d1dd.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Ermaying_Formation_01.0248b78c.png 2000w\"> </picture>";


function $bf97ab8f001ba275$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($31f1c0ea62e2a71b$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($e26753b202e3cee4$exports))));
}


var $8d242c4c1ab82436$exports = {};

$parcel$export($8d242c4c1ab82436$exports, "marker", function () { return $8d242c4c1ab82436$export$ffc4d0086f1a4c9; });

var $e8669f6ed70abbac$exports = {};
$e8669f6ed70abbac$exports = JSON.parse("{\"coordinates\":[48.10839731627661,-66.35637811506855],\"tooltip\":\"Miguasha\",\"title\":\"Escuminac Formation\",\"country\":\"Canada\",\"period\":\"Devonian\"}");


var $e2fcd9c6dc68d480$exports = {};
$e2fcd9c6dc68d480$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.a98fd573.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.e2e11b94.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.57305f2a.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.6cc4e407.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.c7d1f776.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.65e6665f.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.df55b5cd.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.241a7351.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.5f3ff3c8.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.8766435e.png 250w, https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.70188f4c.png 500w, https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.5f3ff3c8.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Escuminac_01.dc937d0a.png 2000w\"> </picture>";


function $8d242c4c1ab82436$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($e2fcd9c6dc68d480$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($e8669f6ed70abbac$exports))));
}


var $33b56a8158f582a1$exports = {};

$parcel$export($33b56a8158f582a1$exports, "marker", function () { return $33b56a8158f582a1$export$ffc4d0086f1a4c9; });

var $595d6e962d498d57$exports = {};
$595d6e962d498d57$exports = JSON.parse("{\"coordinates\":[30.611704826572094,-5.711298273821711],\"tooltip\":\"Fezouata\",\"title\":\"Fezouata Formation\",\"country\":\"Morroco\",\"period\":\"Ordovician\",\"alt\":\"TODO\"}");


var $87285cb3c98f97b1$exports = {};
$87285cb3c98f97b1$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Fezouata.941f888c.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Fezouata.700df8d7.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Fezouata.12de0b6d.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Fezouata.5ef143e1.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Fezouata.a61c2ac1.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Fezouata.cab7e110.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Fezouata.635da728.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Fezouata.3757c568.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Fezouata.dfc778c5.png\"> </picture>";


function $33b56a8158f582a1$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($87285cb3c98f97b1$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($595d6e962d498d57$exports))));
}


var $fc007abdb8ec7ad7$exports = {};

$parcel$export($fc007abdb8ec7ad7$exports, "marker", function () { return $fc007abdb8ec7ad7$export$ffc4d0086f1a4c9; });

var $1e37262dcc7fffb2$exports = {};
$1e37262dcc7fffb2$exports = JSON.parse("{\"coordinates\":[-8.568127638834753,120.48974418122503],\"tooltip\":\"Flores\",\"title\":\"Pleistocene Flores\",\"country\":\"Indonesia\",\"period\":\"Quaternary\",\"alt\":\"TODO\"}");


var $b83b8486b181e1a0$exports = {};
$b83b8486b181e1a0$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Flores.d1d199f8.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Flores.129462ee.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Flores.33232b87.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Flores.b2af7ca2.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Flores.aa8fc8d3.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Flores.f1edadaf.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Flores.6780cd94.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Flores.41107fa2.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Flores.33813946.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Flores.98b67cdc.png 250w, https://montanoceratops.github.io/Formations/assets/img/Flores.20ecc7a7.png 500w, https://montanoceratops.github.io/Formations/assets/img/Flores.33813946.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Flores.2d5278d5.png 2000w\"> </picture>";


function $fc007abdb8ec7ad7$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($b83b8486b181e1a0$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($1e37262dcc7fffb2$exports))));
}


var $15df04bf128a8f1c$exports = {};

$parcel$export($15df04bf128a8f1c$exports, "marker", function () { return $15df04bf128a8f1c$export$ffc4d0086f1a4c9; });

var $c6b14aa2ab7a61be$exports = {};
$c6b14aa2ab7a61be$exports = JSON.parse("{\"coordinates\":[3.9400434929205943,36.20134406162626],\"tooltip\":\"Koobi Fora\",\"title\":\"Koobi Fora\",\"country\":\"Kenya\",\"period\":\"Quaternary\"}");


var $38a5e5ba97643a72$exports = {};
$38a5e5ba97643a72$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.6942ff45.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.78a0baea.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.779f14b0.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.b389b8c4.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.f44e20f4.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.b7caa9dd.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.3365e34f.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.477eeb38.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.8a6b041c.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.7325c70d.png 250w, https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.8c3c1b2c.png 500w, https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.8a6b041c.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Koobi_Fora_01.65f01d17.png 2000w\"> </picture>";


function $15df04bf128a8f1c$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($38a5e5ba97643a72$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($c6b14aa2ab7a61be$exports))));
}


var $26b9dab1b8844459$exports = {};

$parcel$export($26b9dab1b8844459$exports, "marker", function () { return $26b9dab1b8844459$export$ffc4d0086f1a4c9; });

var $a9aa5029282b9269$exports = {};
$a9aa5029282b9269$exports = JSON.parse("{\"coordinates\":[24.882216494589144,109.70312701807029],\"tooltip\":\"Gigantopithecus Fauna\",\"title\":\"Gigantopithecus Fauna\",\"country\":\"China\",\"period\":\"Neogene\",\"alt\":\"TODO\"}");


var $4ddc8ef4545a61a2$exports = {};
$4ddc8ef4545a61a2$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.0c205094.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.62e2e748.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.ad339dbf.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.d387c821.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.2bb54c49.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.31381389.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.ba19bffe.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.f76ae15c.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.f092b414.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.ba6a08bb.png 250w, https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.fbde27fa.png 500w, https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.f092b414.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Giganothopithecus_Fauna.594e5a9d.png 2000w\"> </picture>";


function $26b9dab1b8844459$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($4ddc8ef4545a61a2$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($a9aa5029282b9269$exports))));
}


var $5a6e561fc4132102$exports = {};

$parcel$export($5a6e561fc4132102$exports, "marker", function () { return $5a6e561fc4132102$export$ffc4d0086f1a4c9; });

var $82f1bf4f811a776e$exports = {};
$82f1bf4f811a776e$exports = JSON.parse("{\"coordinates\":[41.844528309653526,-110.74357070627038],\"tooltip\":\"Green River\",\"title\":\"Green River Formation (Fossil Lake Member)\",\"country\":\"United States\",\"period\":\"Paleogene\",\"alt\":\"TODO\"}");


var $d714009b69373e90$exports = {};
$d714009b69373e90$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.16076dd4.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.291b239b.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.369c15b7.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.bd2ef29b.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.285174da.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.cc88de27.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.29847d7c.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.a05aa363.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.7c4a2224.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.6bf8b15c.png 250w, https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.aaea4659.png 500w, https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.7c4a2224.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Fossil_Butte.c250b917.png 2000w\"> </picture>";


function $5a6e561fc4132102$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($d714009b69373e90$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($82f1bf4f811a776e$exports))));
}


var $62bd20ed78051864$exports = {};

$parcel$export($62bd20ed78051864$exports, "marker", function () { return $62bd20ed78051864$export$ffc4d0086f1a4c9; });

var $14866b642318ff60$exports = {};
$14866b642318ff60$exports = JSON.parse('{"coordinates":[39.59513408745693,-9.000824134849353],"tooltip":"Guimarota","title":"Alcoba\xe7a Formation (Guimarota)","country":"Portugal","period":"Jurassic","alt":"TODO"}');


var $22a5c4a652af8564$exports = {};
$22a5c4a652af8564$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.e81248d1.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.e7e20274.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.7f156727.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.2a4a43e9.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.05c12e01.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.d5b2896e.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.2c042233.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.3dace783.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.18e9865e.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.e6ce809f.png 250w, https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.7c4def02.png 500w, https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.18e9865e.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Guimarota%20formation.6a2cbb4e.png 2000w\"> </picture>";


function $62bd20ed78051864$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($22a5c4a652af8564$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($14866b642318ff60$exports))));
}


var $b95a22ad3d00d796$exports = {};

$parcel$export($b95a22ad3d00d796$exports, "marker", function () { return $b95a22ad3d00d796$export$ffc4d0086f1a4c9; });

var $1cfbc5a7714b695e$exports = {};
$1cfbc5a7714b695e$exports = JSON.parse("{\"coordinates\":[46.9865471,-108.973861],\"tooltip\":\"Bear Gulch\",\"title\":\"Bear Gulch Limestone\",\"country\":\"United States\",\"period\":\"Carboniferous\",\"alt\":\"TODO\"}");


var $c27c9ab364a3ee51$exports = {};
$c27c9ab364a3ee51$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.7332e5ad.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.56066456.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.1f1f869a.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.56087a9d.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.585f716e.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.eeacb384.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.786ecdf3.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.098026a5.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.bc9934e1.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.fcdfeaca.png 250w, https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.3590cafe.png 500w, https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.bc9934e1.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Bear_Gulch.77162e2a.png 2000w\"> </picture>";


function $b95a22ad3d00d796$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($c27c9ab364a3ee51$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($1cfbc5a7714b695e$exports))));
}


var $98ba77e52c38e95d$exports = {};

$parcel$export($98ba77e52c38e95d$exports, "marker", function () { return $98ba77e52c38e95d$export$ffc4d0086f1a4c9; });

var $607ffd2c686973d3$exports = {};
$607ffd2c686973d3$exports = JSON.parse("{\"coordinates\":[-84.14373805169592,169.52049078601476],\"tooltip\":\"Hanson\",\"title\":\"Hanson Formation\",\"country\":\"Antarctica\",\"period\":\"Jurassic\",\"alt\":\"TODO\"}");


var $6fcb4015c2b4ed77$exports = {};
$6fcb4015c2b4ed77$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.cdf62a6b.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.264d4111.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.141f35de.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.d7ad7d71.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.623b68bb.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.7e181536.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.a3c226bc.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.cefd6f9d.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.901ba7c8.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.a407948b.png 250w, https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.4f433f63.png 500w, https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.901ba7c8.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Hanson%20formation.fe5442fd.png 2000w\"> </picture>";


function $98ba77e52c38e95d$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($6fcb4015c2b4ed77$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($607ffd2c686973d3$exports))));
}


var $dd7fa668ec75222b$exports = {};

$parcel$export($dd7fa668ec75222b$exports, "marker", function () { return $dd7fa668ec75222b$export$ffc4d0086f1a4c9; });

var $3db5578e34805e78$exports = {};
$3db5578e34805e78$exports = JSON.parse("{\"coordinates\":[47.369579315870396,-106.9289533522583],\"tooltip\":\"Hell Creek\",\"title\":\"Hell Creek Formation\",\"country\":\"United States\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $d1697beb5fab2502$exports = {};
$d1697beb5fab2502$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.19ffd5be.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.c761e70c.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.943e4cfc.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.39a487db.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.22de7f6f.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.5d9d33b6.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.28c3e6b3.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.1e3f434b.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.f8d24d38.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.23dcaed8.png 250w, https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.d83e6c15.png 500w, https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.f8d24d38.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Hell_Creek_01.437786ed.png 2000w\"> </picture>";


function $dd7fa668ec75222b$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($d1697beb5fab2502$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($3db5578e34805e78$exports))));
}


var $2dbdbc39ec9303c9$exports = {};

$parcel$export($2dbdbc39ec9303c9$exports, "marker", function () { return $2dbdbc39ec9303c9$export$ffc4d0086f1a4c9; });

var $33fdfcaf9e8f5c3a$exports = {};
$33fdfcaf9e8f5c3a$exports = JSON.parse("{\"coordinates\":[-44.792389308498144,168.39006276825592],\"tooltip\":\"Holocene New Zealand\",\"title\":\"Holocene New Zealand\",\"country\":\"New Zealand\",\"period\":\"Quaternary\",\"alt\":\"TODO\"}");


var $6c593dbc22074e64$exports = {};
$6c593dbc22074e64$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.86e4ad09.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.e1319fc7.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.651b0bae.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.6e6e46ca.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.af1bab05.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.3cb37b24.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.a09043d0.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.cc0ce9d2.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.80347e9b.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.e0d13d88.png 250w, https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.3bbdeba3.png 500w, https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.80347e9b.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Holocene_New_Zealand_01.b70cd07e.png 2000w\"> </picture>";


function $2dbdbc39ec9303c9$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($6c593dbc22074e64$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($33fdfcaf9e8f5c3a$exports))));
}


var $e631ea827537ee40$exports = {};

$parcel$export($e631ea827537ee40$exports, "marker", function () { return $e631ea827537ee40$export$ffc4d0086f1a4c9; });

var $5e7128d9080aaa68$exports = {};
$5e7128d9080aaa68$exports = JSON.parse('{"coordinates":[50.056930666422716,7.436062626984949],"tooltip":"Hunsr\xfcck Slate","title":"Hunsr\xfcck Slate","country":"Germany","period":"Devonian","alt":"TODO"}');


var $de58f8b36c4ea532$exports = {};
$de58f8b36c4ea532$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.ee3c3d43.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.25ad1d83.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.03522a5d.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.bf2c1e34.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.1f18f965.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.4c1d242a.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.6e1b67a6.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.a3b7dc1c.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.83853af2.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.37d266c3.png 250w, https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.62c45eec.png 500w, https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.83853af2.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Hunsruck_slate1.1e89be8e.png 2000w\"> </picture>";


function $e631ea827537ee40$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($de58f8b36c4ea532$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($5e7128d9080aaa68$exports))));
}


var $d71b7dc773904fe4$exports = {};

$parcel$export($d71b7dc773904fe4$exports, "marker", function () { return $d71b7dc773904fe4$export$ffc4d0086f1a4c9; });

var $aa9cde2757806ac0$exports = {};
$aa9cde2757806ac0$exports = JSON.parse("{\"coordinates\":[29.79790602833107,29.04546079527472],\"tooltip\":\"Jebel Qatrani\",\"title\":\"Jebel Qatrani\",\"country\":\"Egypt\",\"period\":\"Paleogene\",\"alt\":\"TODO\"}");


var $7d4ae61c1f96ef09$exports = {};
$7d4ae61c1f96ef09$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.28ffec0b.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.bbd5edfc.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.b4c00b44.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.6a87deef.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.3875a8b4.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.dc13520b.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.768a7dca.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.83f7e58c.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.5a529c4c.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.7c50c82f.png 250w, https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.4554ee2c.png 500w, https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.5a529c4c.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Jebel_Qatrani.26c4ff52.png 2000w\"> </picture>";


function $d71b7dc773904fe4$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($7d4ae61c1f96ef09$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($aa9cde2757806ac0$exports))));
}


var $d7f44b55327ddab8$exports = {};

$parcel$export($d7f44b55327ddab8$exports, "marker", function () { return $d7f44b55327ddab8$export$ffc4d0086f1a4c9; });

var $76f3e2afbd4df596$exports = {};
$76f3e2afbd4df596$exports = JSON.parse("{\"coordinates\":[50.613162087338594,-2.134961684703171],\"tooltip\":\"Kimmeridge Clay\",\"title\":\"Kimmeridge Clay\",\"country\":\"England (UK)\",\"period\":\"Jurassic\",\"alt\":\"TODO\"}");


var $42ffd4e9e70714c1$exports = {};
$42ffd4e9e70714c1$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.bac388b0.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.921bb01a.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.2f9995c0.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.547d8ee1.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.0dd0510d.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.d8d6e88a.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.f2ae700c.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.7d92e0ef.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.5f308bb8.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.a3a5669f.png 250w, https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.0201a6b0.png 500w, https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.5f308bb8.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Kimmeridge%20Clay.2e0c6ef1.png 2000w\"> </picture>";


function $d7f44b55327ddab8$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($42ffd4e9e70714c1$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($76f3e2afbd4df596$exports))));
}


var $f29222efa675e5ac$exports = {};

$parcel$export($f29222efa675e5ac$exports, "marker", function () { return $f29222efa675e5ac$export$ffc4d0086f1a4c9; });

var $456f1bd5b48df8e8$exports = {};
$456f1bd5b48df8e8$exports = JSON.parse("{\"coordinates\":[33.70436767889714,72.16648842880363],\"tooltip\":\"Kuldana\",\"title\":\"Kuldana Formation\",\"country\":\"Pakistan\",\"period\":\"Paleogene\",\"alt\":\"TODO\"}");


var $1ef3a52314fe4c41$exports = {};
$1ef3a52314fe4c41$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.115d6f97.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.ce51d522.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.56b87b42.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.5d1821d4.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.059f6c13.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.6309852c.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.de52847b.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.fc35a1a6.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.93757cd6.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.5b23fb78.png 250w, https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.359592fd.png 500w, https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.93757cd6.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Kuldana_formation_01.4641609c.png 2000w\"> </picture>";


function $f29222efa675e5ac$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($1ef3a52314fe4c41$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($456f1bd5b48df8e8$exports))));
}


var $ab847d4be0844b1d$exports = {};

$parcel$export($ab847d4be0844b1d$exports, "marker", function () { return $ab847d4be0844b1d$export$ffc4d0086f1a4c9; });

var $a9d6b51266bdd789$exports = {};
$a9d6b51266bdd789$exports = JSON.parse('{"coordinates":[40.06255627092858,-1.91682524694383],"tooltip":"Las Hoyas","title":"La Hu\xe9rguina Formation (Las Hoyas)","country":"Spain","period":"Cretaceous","alt":"TODO"}');


var $43428f75164f0c87$exports = {};
$43428f75164f0c87$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.c560e92d.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.55e94e67.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.06ef35f6.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.6c74b53a.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.62ada985.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.d8c90908.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.bc8832be.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.af774caa.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.7aece5e9.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.3d0a5a82.png 250w, https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.491b9090.png 500w, https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.7aece5e9.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Las_Hoyas.8d2e3857.png 2000w\"> </picture>";


function $ab847d4be0844b1d$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($43428f75164f0c87$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($a9d6b51266bdd789$exports))));
}


var $c72cf730f90d21de$exports = {};

$parcel$export($c72cf730f90d21de$exports, "marker", function () { return $c72cf730f90d21de$export$ffc4d0086f1a4c9; });

var $503ecd70d9e53a33$exports = {};
$503ecd70d9e53a33$exports = JSON.parse("{\"coordinates\":[-19.859708348935214,44.502000607375834],\"tooltip\":\"Holocene Madagascar\",\"title\":\"Holocene Madagascar\",\"country\":\"Madagascar\",\"period\":\"Quaternary\",\"alt\":\"TODO\"}");


var $582c77a9e5c3b6d0$exports = {};
$582c77a9e5c3b6d0$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.2f197fe4.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.68734b3b.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.8eda616c.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.63aada0b.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.403c44e2.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.ad4e20fe.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.861123df.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.1a27c671.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.42790132.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.e55b7bdd.png 250w, https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.107721d7.png 500w, https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.42790132.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Madagascar_piece.d523944e.png 2000w\"> </picture>";


function $c72cf730f90d21de$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($582c77a9e5c3b6d0$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($503ecd70d9e53a33$exports))));
}


var $e1dd34c0eec5a9d8$exports = {};

$parcel$export($e1dd34c0eec5a9d8$exports, "marker", function () { return $e1dd34c0eec5a9d8$export$ffc4d0086f1a4c9; });

var $146c8c5b3cab72dc$exports = {};
$146c8c5b3cab72dc$exports = JSON.parse("{\"coordinates\":[40.09320539099858,70.18271298503566],\"tooltip\":\"Madygen\",\"title\":\"Madygen Formation\",\"country\":\"Kyrgyztan, Taijikistan, Uzbekistan\",\"period\":\"Triassic\",\"alt\":\"TODO\"}");


var $cc537b701d01408d$exports = {};
$cc537b701d01408d$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.2276e135.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.4b503e58.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.42183ce6.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.1e2f9306.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.3a9a3625.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.0625fe37.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.b444727b.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.631d779c.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.879eb7db.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.a623b660.png 250w, https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.6a456dba.png 500w, https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.879eb7db.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Madygen_Formation.3a84860d.png 2000w\"> </picture>";


function $e1dd34c0eec5a9d8$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($cc537b701d01408d$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($146c8c5b3cab72dc$exports))));
}


var $cb2c7d22bab26300$exports = {};

$parcel$export($cb2c7d22bab26300$exports, "marker", function () { return $cb2c7d22bab26300$export$ffc4d0086f1a4c9; });

var $0c2df984f7b02eac$exports = {};
$0c2df984f7b02eac$exports = JSON.parse("{\"coordinates\":[-15.8756979887564,46.63235597907419],\"tooltip\":\"Maevarano\",\"title\":\"Maevarano Formation\",\"country\":\"Madagascar\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $dcd6ad3cf3336c43$exports = {};
$dcd6ad3cf3336c43$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Maevarano.d6bf305f.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Maevarano.81c52790.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Maevarano.875a2e9a.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Maevarano.04708ede.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Maevarano.f703800d.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Maevarano.b633c628.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Maevarano.5ef3178b.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Maevarano.fce9c01c.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Maevarano.ddf35e30.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Maevarano.77d1ad21.png 250w, https://montanoceratops.github.io/Formations/assets/img/Maevarano.2a559ac3.png 500w, https://montanoceratops.github.io/Formations/assets/img/Maevarano.ddf35e30.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Maevarano.1728da1b.png 2000w\"> </picture>";


function $cb2c7d22bab26300$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($dcd6ad3cf3336c43$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($0c2df984f7b02eac$exports))));
}


var $ec1e78702cae3526$exports = {};

$parcel$export($ec1e78702cae3526$exports, "marker", function () { return $ec1e78702cae3526$export$ffc4d0086f1a4c9; });

var $959a5c8343d748d8$exports = {};
$959a5c8343d748d8$exports = JSON.parse("{\"coordinates\":[41.32621819098438,-88.37050801641138],\"tooltip\":\"Mazon Creek\",\"title\":\"Mazon Creek Fossil Beds\",\"country\":\"United States\",\"period\":\"Carboniferous\",\"alt\":\"TODO\"}");


var $433dc3b9c18988bf$exports = {};
$433dc3b9c18988bf$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/MazonCreek.bd8de089.avif 250w, https://montanoceratops.github.io/Formations/assets/img/MazonCreek.39eafbae.avif 500w, https://montanoceratops.github.io/Formations/assets/img/MazonCreek.0345c275.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/MazonCreek.8f92b66e.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/MazonCreek.0529a016.webp 250w, https://montanoceratops.github.io/Formations/assets/img/MazonCreek.682b0a14.webp 500w, https://montanoceratops.github.io/Formations/assets/img/MazonCreek.0ccca7ce.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/MazonCreek.e72d2c29.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/MazonCreek.e6ece5b5.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/MazonCreek.7374d837.png 250w, https://montanoceratops.github.io/Formations/assets/img/MazonCreek.78c939e4.png 500w, https://montanoceratops.github.io/Formations/assets/img/MazonCreek.e6ece5b5.png 1000w, https://montanoceratops.github.io/Formations/assets/img/MazonCreek.97689c83.png 2000w\"> </picture>";


function $ec1e78702cae3526$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($433dc3b9c18988bf$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($959a5c8343d748d8$exports))));
}


var $7b9e8e884de32ea0$exports = {};

$parcel$export($7b9e8e884de32ea0$exports, "marker", function () { return $7b9e8e884de32ea0$export$ffc4d0086f1a4c9; });

var $86b3e0e2567b6029$exports = {};
$86b3e0e2567b6029$exports = JSON.parse("{\"coordinates\":[38.55266999551583,-108.40353117984913],\"tooltip\":\"Morrison\",\"title\":\"Morrison Formation\",\"country\":\"United States\",\"period\":\"Jurassic\",\"alt\":\"TODO\"}");


var $5a8b81ea6ead6816$exports = {};
$5a8b81ea6ead6816$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.f079a1b1.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.69fa9927.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.40e00ed3.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.47cc2bee.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.bb1d9e4b.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.88de6fbc.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.b68d1b2a.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.de6d6897.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.2cd8addc.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.28dfa679.png 250w, https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.9a64c4d5.png 500w, https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.2cd8addc.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Morrison_Formation.ce00b7f0.png 2000w\"> </picture>";


function $7b9e8e884de32ea0$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($5a8b81ea6ead6816$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($86b3e0e2567b6029$exports))));
}


var $df2ae991cb4c6f8e$exports = {};

$parcel$export($df2ae991cb4c6f8e$exports, "marker", function () { return $df2ae991cb4c6f8e$export$ffc4d0086f1a4c9; });

var $2ed870a6172e88a5$exports = {};
$2ed870a6172e88a5$exports = JSON.parse("{\"coordinates\":[-37.06131197300091,140.809288541042],\"tooltip\":\"Naracoorte\",\"title\":\"Naracoorte Caves National Park\",\"country\":\"Australaia\",\"period\":\"Quaternary\"}");


var $58161ee66294621e$exports = {};
$58161ee66294621e$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.99c7a228.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.bc97c9a6.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.1f8818c7.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.dc62229f.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.6f980fa9.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.44003fea.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.389d1b72.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.de2e5587.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.010cab09.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.7b68030d.png 250w, https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.61bfa23a.png 500w, https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.010cab09.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Naracoorte_01.21ee2de8.png 2000w\"> </picture>";


function $df2ae991cb4c6f8e$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($58161ee66294621e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($2ed870a6172e88a5$exports))));
}


var $141117b696d747e7$exports = {};

$parcel$export($141117b696d747e7$exports, "marker", function () { return $141117b696d747e7$export$ffc4d0086f1a4c9; });

var $00ec72e7c658c9ba$exports = {};
$00ec72e7c658c9ba$exports = JSON.parse("{\"coordinates\":[0.9072391011698926,35.80157423848382],\"tooltip\":\"Ngorora\",\"title\":\"Ngorora Formation\",\"country\":\"Kenya\",\"period\":\"Neogene\",\"alt\":\"TODO\"}");


var $24c51de255601d9a$exports = {};
$24c51de255601d9a$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.a6dbff07.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.6b4a01e8.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.8d2b1efa.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.05582db4.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.bc93206f.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.3c0fd791.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.8ef23b05.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.2043083f.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.e6a86e7d.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.db762c3c.png 250w, https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.836a4f61.png 500w, https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.e6a86e7d.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Ngorora_formation_01.76f9bd57.png 2000w\"> </picture>";


function $141117b696d747e7$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($24c51de255601d9a$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($00ec72e7c658c9ba$exports))));
}


var $9af30cb1f8c1efa4$exports = {};

$parcel$export($9af30cb1f8c1efa4$exports, "marker", function () { return $9af30cb1f8c1efa4$export$ffc4d0086f1a4c9; });

var $756149e234dbaddb$exports = {};
$756149e234dbaddb$exports = JSON.parse("{\"coordinates\":[42.734637171880735,-98.04254362333498],\"tooltip\":\"Niobrara\",\"title\":\"Niobrara Formation\",\"country\":\"United States\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $e9b2f409ad54e653$exports = {};
$e9b2f409ad54e653$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Niobrara.de12d4db.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Niobrara.11eaa8d2.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Niobrara.e6b4961d.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Niobrara.534f9e61.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Niobrara.f8984e35.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Niobrara.0334d294.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Niobrara.522cf227.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Niobrara.44a6a593.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Niobrara.46cdc617.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Niobrara.932543d5.png 250w, https://montanoceratops.github.io/Formations/assets/img/Niobrara.5189b94e.png 500w, https://montanoceratops.github.io/Formations/assets/img/Niobrara.46cdc617.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Niobrara.1449851a.png 2000w\"> </picture>";


function $9af30cb1f8c1efa4$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($e9b2f409ad54e653$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($756149e234dbaddb$exports))));
}


var $5581e7bed4242734$exports = {};

$parcel$export($5581e7bed4242734$exports, "marker", function () { return $5581e7bed4242734$export$ffc4d0086f1a4c9; });

var $50aeeabc6ba68810$exports = {};
$50aeeabc6ba68810$exports = JSON.parse("{\"coordinates\":[5.500846925158513,-73.49568160097971],\"tooltip\":\"Paja\",\"title\":\"Paja Formation\",\"country\":\"Colombia\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $97094c9b926bb713$exports = {};
$97094c9b926bb713$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Paja_formation.04dd08b3.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Paja_formation.eaaf6918.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Paja_formation.38d7b366.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Paja_formation.0b3855e3.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Paja_formation.e9a9b83b.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Paja_formation.9934e245.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Paja_formation.8f582cce.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Paja_formation.9282ee8b.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Paja_formation.f5067786.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Paja_formation.3294b5c0.png 250w, https://montanoceratops.github.io/Formations/assets/img/Paja_formation.9cb2b984.png 500w, https://montanoceratops.github.io/Formations/assets/img/Paja_formation.f5067786.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Paja_formation.fb3f5bdf.png 2000w\"> </picture>";


function $5581e7bed4242734$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($97094c9b926bb713$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($50aeeabc6ba68810$exports))));
}


var $89ddc0d3bdcbcbde$exports = {};

$parcel$export($89ddc0d3bdcbcbde$exports, "marker", function () { return $89ddc0d3bdcbcbde$export$ffc4d0086f1a4c9; });

var $eedf4835815062bd$exports = {};
$eedf4835815062bd$exports = JSON.parse("{\"coordinates\":[48.19739388234848,14.215816566499768],\"tooltip\":\"Austrian Paratethys\",\"title\":\"Austrian Paratethys\",\"country\":\"Austria\",\"period\":\"Neogene\",\"alt\":\"TODO\"}");


var $3e36eff52a6d5013$exports = {};
$3e36eff52a6d5013$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Paratethys.7820c9af.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Paratethys.d0a8e774.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Paratethys.c9a81415.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Paratethys.5ad74021.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Paratethys.a7574870.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Paratethys.c5e4859a.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Paratethys.f8f0c66a.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Paratethys.33512fa7.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Paratethys.09dfd86c.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Paratethys.8f431bf0.png 250w, https://montanoceratops.github.io/Formations/assets/img/Paratethys.51529efa.png 500w, https://montanoceratops.github.io/Formations/assets/img/Paratethys.09dfd86c.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Paratethys.a95a74d1.png 2000w\"> </picture>";


function $89ddc0d3bdcbcbde$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($3e36eff52a6d5013$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($eedf4835815062bd$exports))));
}


var $ebe40e689f9eda1c$exports = {};

$parcel$export($ebe40e689f9eda1c$exports, "marker", function () { return $ebe40e689f9eda1c$export$ffc4d0086f1a4c9; });

var $b0af66d55ca8ad1b$exports = {};
$b0af66d55ca8ad1b$exports = JSON.parse("{\"coordinates\":[-7.429970554254552,-75.01857668419385],\"tooltip\":\"Pebas\",\"title\":\"Pebas Formation\",\"country\":\"Brazil, Colombia, Ecuador, Peru\",\"period\":\"Neogene\",\"alt\":\"TODO\"}");


var $84489df6d6b9c181$exports = {};
$84489df6d6b9c181$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.87c72ca9.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.dcc9ac4c.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.1304d7f2.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.e7bbe6ee.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.245ff255.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.00256bc6.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.81678bd7.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.e41aaa76.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.0f327935.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.6c288840.png 250w, https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.a02c97ea.png 500w, https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.0f327935.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Pebas_Formatio.3d777358.png 2000w\"> </picture>";


function $ebe40e689f9eda1c$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($84489df6d6b9c181$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($b0af66d55ca8ad1b$exports))));
}


var $7c80a3ab31e4838d$exports = {};

$parcel$export($7c80a3ab31e4838d$exports, "marker", function () { return $7c80a3ab31e4838d$export$ffc4d0086f1a4c9; });

var $d52d28db7578a1e4$exports = {};
$d52d28db7578a1e4$exports = JSON.parse("{\"coordinates\":[44.3548524714939,-100.39038870478389],\"tooltip\":\"Pierre Shale\",\"title\":\"Pierre Shale\",\"country\":\"United States\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $67c2a8be0119b1c7$exports = {};
$67c2a8be0119b1c7$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.23e85f96.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.a3a2a926.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.fdb22ae8.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.3eb7ea5e.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.c81bc6c9.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.ed8c9256.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.4bbdb11f.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.75a52309.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.58b05543.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.b682304d.png 250w, https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.0e0d2342.png 500w, https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.58b05543.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Pierre_Shale_1.0ae0c298.png 2000w\"> </picture>";


function $7c80a3ab31e4838d$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($67c2a8be0119b1c7$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($d52d28db7578a1e4$exports))));
}


var $d5b9b8a0610f594d$exports = {};

$parcel$export($d5b9b8a0610f594d$exports, "marker", function () { return $d5b9b8a0610f594d$export$ffc4d0086f1a4c9; });

var $3859611f2d28a035$exports = {};
$3859611f2d28a035$exports = JSON.parse("{\"coordinates\":[-13.797257278029576,-76.08747925604533],\"tooltip\":\"Pisco\",\"title\":\"Pisco Formation\",\"country\":\"Peru\",\"period\":\"Neogene\"}");


var $f3278a89e7244061$exports = {};
$f3278a89e7244061$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pisco_01.b3fd270b.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Pisco_01.9e36c05f.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Pisco_01.c500d991.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Pisco_01.4a6a482d.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pisco_01.a1581071.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Pisco_01.8ffd2ab0.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Pisco_01.2e98601a.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Pisco_01.759343c1.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Pisco_01.a0b16a79.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pisco_01.aabf2b11.png 250w, https://montanoceratops.github.io/Formations/assets/img/Pisco_01.1389cf56.png 500w, https://montanoceratops.github.io/Formations/assets/img/Pisco_01.a0b16a79.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Pisco_01.6637f1bb.png 2000w\"> </picture>";


function $d5b9b8a0610f594d$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($f3278a89e7244061$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($3859611f2d28a035$exports))));
}


var $677dfc80eb4fa94c$exports = {};

$parcel$export($677dfc80eb4fa94c$exports, "marker", function () { return $677dfc80eb4fa94c$export$ffc4d0086f1a4c9; });

var $34c552baa6d35b7a$exports = {};
$34c552baa6d35b7a$exports = JSON.parse("{\"coordinates\":[20.722467743936676,-77.3070171286546],\"tooltip\":\"Pleistocene Cuba\",\"title\":\"Pleistocene Cuba\",\"country\":\"Cuba\",\"period\":\"Quaternary\",\"image\":{\"file\":\"artworks/Cuba_Pleistocen.png\",\"size\":\"500px\"}}");


var $3df677c32c0dacb8$exports = {};
$3df677c32c0dacb8$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.4e729ce2.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.798654c2.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.0826f226.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.0af771f2.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.84b38c13.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.d903029c.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.cb5338bb.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.9b8d4f8e.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.b90ea9b2.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.a437092d.png 250w, https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.09b639d6.png 500w, https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.b90ea9b2.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Cuba_Pleistocen.874c3255.png 2000w\"> </picture>";


function $677dfc80eb4fa94c$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($3df677c32c0dacb8$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($34c552baa6d35b7a$exports))));
}


var $3921427e46298871$exports = {};

$parcel$export($3921427e46298871$exports, "marker", function () { return $3921427e46298871$export$ffc4d0086f1a4c9; });

var $b57d0f700c2ba3b0$exports = {};
$b57d0f700c2ba3b0$exports = JSON.parse("{\"coordinates\":[25.7586931157053,-100.85123415791676],\"tooltip\":\"Cerro del Pueblo\",\"title\":\"Cerro del Pueblo Formation\",\"country\":\"Mexico\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $f53e79fca1d37dd2$exports = {};
$f53e79fca1d37dd2$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.edd0e314.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.fa4a50cd.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.2d0e1629.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.d5810bc6.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.d0a81f11.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.fc684f54.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.debd77c4.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.1cc801dc.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.aba25346.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.85082593.png 250w, https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.e9419bc7.png 500w, https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.aba25346.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Cerro_del_pueblo_c.055c6568.png 2000w\"> </picture>";


function $3921427e46298871$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($f53e79fca1d37dd2$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($b57d0f700c2ba3b0$exports))));
}


var $bda95ae5142ac87b$exports = {};

$parcel$export($bda95ae5142ac87b$exports, "marker", function () { return $bda95ae5142ac87b$export$ffc4d0086f1a4c9; });

var $35c680bb8327c33f$exports = {};
$35c680bb8327c33f$exports = JSON.parse("{\"coordinates\":[49.521838860157914,7.4402019682614196],\"tooltip\":\"Remigiusberg\",\"title\":\"Remigiusberg Formation\",\"country\":\"Germany\",\"period\":\"Permian\",\"alt\":\"TODO\"}");


var $5bba8f7d4cfd6e0d$exports = {};
$5bba8f7d4cfd6e0d$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.cb3128e0.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.1e0a8007.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.abeeb722.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.b57411d3.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.b80bcd82.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.58df0d60.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.6a447196.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.ce57e3f7.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.1f140d02.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.dcdf9162.png 250w, https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.764ea4e4.png 500w, https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.1f140d02.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Remigiusberg.40b2164b.png 2000w\"> </picture>";


function $bda95ae5142ac87b$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($5bba8f7d4cfd6e0d$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($35c680bb8327c33f$exports))));
}


var $5a1ffdd9314dd84b$exports = {};

$parcel$export($5a1ffdd9314dd84b$exports, "marker", function () { return $5a1ffdd9314dd84b$export$ffc4d0086f1a4c9; });

var $ec99b47a645d96ef$exports = {};
$ec99b47a645d96ef$exports = JSON.parse("{\"coordinates\":[-28.400789117865003,-49.482179617137234],\"tooltip\":\"Rio do Rasto\",\"title\":\"Rio do Rasto Formation\",\"country\":\"Brazil\",\"period\":\"Permian\",\"alt\":\"TODO\"}");


var $51e28ef51eeea9c8$exports = {};
$51e28ef51eeea9c8$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.6ff04a99.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.02ddb25f.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.f0fa59ec.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.56c0ae7b.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.b445e376.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.052e7c25.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.5bab64fb.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.68108442.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.6506d7ef.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.9c1fbe1a.png 250w, https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.e4c87aab.png 500w, https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.6506d7ef.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Rio_do_Rasto_Formation.d97de1fe.png 2000w\"> </picture>";


function $5a1ffdd9314dd84b$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($51e28ef51eeea9c8$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($ec99b47a645d96ef$exports))));
}


var $be9323c068e21e97$exports = {};

$parcel$export($be9323c068e21e97$exports, "marker", function () { return $be9323c068e21e97$export$ffc4d0086f1a4c9; });

var $44ab5ec320f9af9e$exports = {};
$44ab5ec320f9af9e$exports = JSON.parse("{\"coordinates\":[-19.02884061749854,138.73982886329912],\"tooltip\":\"Riversleigh\",\"title\":\"Riversleigh (Faunal Zone C)\",\"country\":\"Australia\",\"period\":\"Paleogene-Neogene\",\"alt\":\"TODO\"}");


var $bcfc28433c5de7fa$exports = {};
$bcfc28433c5de7fa$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Riversleigh.d801624d.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Riversleigh.249a208f.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Riversleigh.d49beaaf.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Riversleigh.151bed42.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Riversleigh.3e49102c.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Riversleigh.1dd2e2a7.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Riversleigh.ed031cb2.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Riversleigh.a4b395c0.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Riversleigh.ec0a7d99.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Riversleigh.3e32dc37.png 250w, https://montanoceratops.github.io/Formations/assets/img/Riversleigh.68194f7f.png 500w, https://montanoceratops.github.io/Formations/assets/img/Riversleigh.ec0a7d99.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Riversleigh.bee950b1.png 2000w\"> </picture>";


function $be9323c068e21e97$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($bcfc28433c5de7fa$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($44ab5ec320f9af9e$exports))));
}


var $36a55de917e7778e$exports = {};

$parcel$export($36a55de917e7778e$exports, "marker", function () { return $36a55de917e7778e$export$ffc4d0086f1a4c9; });

var $4b33fef4598c3a5f$exports = {};
$4b33fef4598c3a5f$exports = JSON.parse("{\"coordinates\":[34.099741332678136,35.701002567643485],\"tooltip\":\"Sannine\",\"title\":\"Sannine Formation\",\"country\":\"Lebanon\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $7add3e5701af7907$exports = {};
$7add3e5701af7907$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.77e1ff63.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.eac203dd.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.dae8e20f.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.4c9af0f7.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.f1e24f7e.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.9deaf633.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.8573a75d.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.3fe7ed13.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.8d008b30.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.aca93555.png 250w, https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.ec6b17be.png 500w, https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.8d008b30.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Libanon_Mural3.320e39ac.png 2000w\"> </picture>";


function $36a55de917e7778e$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($7add3e5701af7907$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($4b33fef4598c3a5f$exports))));
}


var $f5af30637a91179b$exports = {};

$parcel$export($f5af30637a91179b$exports, "marker", function () { return $f5af30637a91179b$export$ffc4d0086f1a4c9; });

var $3a2bf9d14d7c8f62$exports = {};
$3a2bf9d14d7c8f62$exports = JSON.parse("{\"coordinates\":[36.555985212596966,118.69119349644467],\"tooltip\":\"Shanwang\",\"title\":\"Shanwang Formation\",\"country\":\"China\",\"period\":\"Neogene\",\"alt\":\"TODO\"}");


var $1f0b92ca5324a08f$exports = {};
$1f0b92ca5324a08f$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Shanwang.3884097a.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Shanwang.5d414ee3.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Shanwang.08822ae5.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Shanwang.d0482205.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Shanwang.4010c8fd.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Shanwang.3c42b659.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Shanwang.57226c45.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Shanwang.07c0bd2d.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Shanwang.6932f647.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Shanwang.49200edd.png 250w, https://montanoceratops.github.io/Formations/assets/img/Shanwang.e0492653.png 500w, https://montanoceratops.github.io/Formations/assets/img/Shanwang.6932f647.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Shanwang.b9abdc18.png 2000w\"> </picture>";


function $f5af30637a91179b$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($1f0b92ca5324a08f$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($3a2bf9d14d7c8f62$exports))));
}


var $f1ed6420b7474c32$exports = {};

$parcel$export($f1ed6420b7474c32$exports, "marker", function () { return $f1ed6420b7474c32$export$ffc4d0086f1a4c9; });

var $781ab8a089caf39e$exports = {};
$781ab8a089caf39e$exports = JSON.parse("{\"coordinates\":[37.789598896238004,13.171182106188837],\"tooltip\":\"Sicily\",\"title\":\"Pleistocene Sicily\",\"country\":\"Italy\",\"period\":\"Quaternary\"}");


var $b726fc15cac25638$exports = {};
$b726fc15cac25638$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.ca843091.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.68c4fb4e.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.d85f8871.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.7da963b3.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.8b4b857d.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.981db6e5.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.83622a64.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.90d722af.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.f677199e.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.5632d331.png 250w, https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.67a87be5.png 500w, https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.f677199e.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Pleistocene_Sicily.b05574cd.png 2000w\"> </picture>";


function $f1ed6420b7474c32$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($b726fc15cac25638$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($781ab8a089caf39e$exports))));
}


var $7ed61183a123ddc8$exports = {};

$parcel$export($7ed61183a123ddc8$exports, "marker", function () { return $7ed61183a123ddc8$export$ffc4d0086f1a4c9; });

var $3b36b3e4e7486383$exports = {};
$3b36b3e4e7486383$exports = JSON.parse("{\"coordinates\":[-33.002552753963904,18.999821383633076],\"tooltip\":\"Soom Shale\",\"title\":\"Cederberg Formation (Soom Shale)\",\"country\":\"South Africa\",\"period\":\"Ordovician\",\"alt\":\"TODO\"}");


var $b41a5550b9ea84a9$exports = {};
$b41a5550b9ea84a9$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.84ae17ca.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.b9e042b2.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.48fc0c99.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.0ac1d464.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.fb992787.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.afea8227.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.bbe428cd.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.2f8123bd.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.79aeb269.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.9ca72732.png 250w, https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.8f3784a9.png 500w, https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.79aeb269.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Soom_Shale.2b07e019.png 2000w\"> </picture>";


function $7ed61183a123ddc8$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($b41a5550b9ea84a9$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($3b36b3e4e7486383$exports))));
}


var $79fb42b5d4793c6b$exports = {};

$parcel$export($79fb42b5d4793c6b$exports, "marker", function () { return $79fb42b5d4793c6b$export$ffc4d0086f1a4c9; });

var $2d2efd03551b916b$exports = {};
$2d2efd03551b916b$exports = JSON.parse("{\"coordinates\":[54.513999192328555,-120.74640695942995],\"tooltip\":\"Sulphur Mountain\",\"title\":\"Sulphur Mountain Formation\",\"country\":\"Canada\",\"period\":\"Triassic\"}");


var $5208b4eb6edcd1cc$exports = {};
$5208b4eb6edcd1cc$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.1680a4fd.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.53665a81.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.077fa3bd.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.1837e79c.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.ee0efb4e.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.04830731.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.02b7f708.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.16fbfdb3.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.44f04fd0.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.8afb68fc.png 250w, https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.a713683d.png 500w, https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.44f04fd0.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Sulphur_Mountain_b.ab9a9785.png 2000w\"> </picture>";


function $79fb42b5d4793c6b$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($5208b4eb6edcd1cc$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($2d2efd03551b916b$exports))));
}


var $fb1f569ee2cf73d2$exports = {};

$parcel$export($fb1f569ee2cf73d2$exports, "marker", function () { return $fb1f569ee2cf73d2$export$ffc4d0086f1a4c9; });

var $29ac642476cd04e4$exports = {};
$29ac642476cd04e4$exports = JSON.parse("{\"coordinates\":[-30.361823619343575,22.508286130808585],\"tooltip\":\"Tapinocephalus Assemblage Zone\",\"title\":\"Tapinocephalus Assemblage Zone\",\"country\":\"South Africa\",\"period\":\"Permian\",\"alt\":\"TODO\"}");


var $5f4ebd098476ad94$exports = {};
$5f4ebd098476ad94$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.a66126aa.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.5e6015b2.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.297ee745.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.f436640d.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.58ded1f7.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.897d880f.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.38e55091.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.d650b3bb.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.e54539b5.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.0be932fd.png 250w, https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.ea0a6129.png 500w, https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.e54539b5.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Tapinocephalus_Ass2.016e526d.png 2000w\"> </picture>";


function $fb1f569ee2cf73d2$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($5f4ebd098476ad94$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($29ac642476cd04e4$exports))));
}


var $a815b0a1afc76dd1$exports = {};

$parcel$export($a815b0a1afc76dd1$exports, "marker", function () { return $a815b0a1afc76dd1$export$ffc4d0086f1a4c9; });

var $538592468ba63087$exports = {};
$538592468ba63087$exports = JSON.parse("{\"coordinates\":[23.933455300493094,81.3862506415166],\"tooltip\":\"Tiki\",\"title\":\"Tiki Formation\",\"country\":\"India\",\"period\":\"Triassic\",\"alt\":\"TODO\"}");


var $9d3b75c32678f6a5$exports = {};
$9d3b75c32678f6a5$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.b438a86b.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.a6cef7c7.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.7be24ce0.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.41d69a71.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.57e9ae44.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.189ccd3e.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.47e4d124.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.bf38fc07.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.10e80ae6.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.57a7fe7c.png 250w, https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.3292c3f3.png 500w, https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.10e80ae6.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Tiki_formation_01.62b61328.png 2000w\"> </picture>";


function $a815b0a1afc76dd1$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($9d3b75c32678f6a5$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($538592468ba63087$exports))));
}


var $93c0cc87bfe54dfd$exports = {};

$parcel$export($93c0cc87bfe54dfd$exports, "marker", function () { return $93c0cc87bfe54dfd$export$ffc4d0086f1a4c9; });

var $2b744e33465cb338$exports = {};
$2b744e33465cb338$exports = JSON.parse("{\"coordinates\":[-22.167666684254414,140.84164209245336],\"tooltip\":\"Toolebuc\",\"title\":\"Toolebuc Formation\",\"country\":\"Australia\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $6c7c4bd1802dfdef$exports = {};
$6c7c4bd1802dfdef$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.f7ec1a51.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.9f7293d2.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.caa725d8.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.df136d31.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.f7125d81.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.efb66834.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.e273e611.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.9aad1000.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.6034e1a7.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.bef38c4f.png 250w, https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.44e53077.png 500w, https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.6034e1a7.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Toolebuc_formation.d6ddf313.png 2000w\"> </picture>";


function $93c0cc87bfe54dfd$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($6c7c4bd1802dfdef$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($2b744e33465cb338$exports))));
}


var $2f18d7bf5077ae33$exports = {};

$parcel$export($2f18d7bf5077ae33$exports, "marker", function () { return $2f18d7bf5077ae33$export$ffc4d0086f1a4c9; });

var $a6c594568ecfad4f$exports = {};
$a6c594568ecfad4f$exports = JSON.parse("{\"coordinates\":[-22.373979732696156,143.03721390682017],\"tooltip\":\"Winton\",\"title\":\"Winton Formation\",\"country\":\"Australia\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $5f35856d646c04dc$exports = {};
$5f35856d646c04dc$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.d98033da.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.276da833.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.6de2c767.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.efa085c2.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.2116cdcb.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.963ea02f.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.bd9db068.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.262767d7.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.d5331015.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.c68e2a49.png 250w, https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.6207f308.png 500w, https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.d5331015.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Winton%20formation.e089e101.png 2000w\"> </picture>";


function $2f18d7bf5077ae33$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($5f35856d646c04dc$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($a6c594568ecfad4f$exports))));
}


var $2878f38dee71caad$exports = {};

$parcel$export($2878f38dee71caad$exports, "marker", function () { return $2878f38dee71caad$export$ffc4d0086f1a4c9; });

var $3604b84182232b00$exports = {};
$3604b84182232b00$exports = JSON.parse("{\"coordinates\":[39.80461883451309,-84.91026576197362],\"tooltip\":\"Whitewater\",\"title\":\"Whitewater Formation (Cincinnati Arch)\",\"country\":\"United States\",\"period\":\"Ordovician\",\"alt\":\"TODO\"}");


var $2da48d928090d4c5$exports = {};
$2da48d928090d4c5$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.e8d2229c.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.f892ae5b.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.8bcdae73.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.000963e9.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.8adaff7c.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.ef27343a.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.c891bea5.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.6438f612.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.43a70fc5.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.81e158f5.png 250w, https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.69d08823.png 500w, https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.43a70fc5.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Whitewater_Formation_01.f6be099d.png 2000w\"> </picture>";


function $2878f38dee71caad$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($2da48d928090d4c5$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($3604b84182232b00$exports))));
}


var $d7ca67fc91f325dd$exports = {};

$parcel$export($d7ca67fc91f325dd$exports, "marker", function () { return $d7ca67fc91f325dd$export$ffc4d0086f1a4c9; });

var $4eddad9744f193bb$exports = {};
$4eddad9744f193bb$exports = JSON.parse("{\"coordinates\":[41.539556369939056,121.2435756042538],\"tooltip\":\"Yixian\",\"title\":\"Yixian Formation\",\"country\":\"China\",\"period\":\"Cretaceous\",\"alt\":\"TODO\"}");


var $9f8ddc77832cd151$exports = {};
$9f8ddc77832cd151$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.93c097dd.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.e71fa9cc.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.2595b959.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.82232485.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.0ae2a36b.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.ccead9ae.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.6940b39d.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.22e638de.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.1fc4f0c9.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.20068d64.png 250w, https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.e96896ca.png 500w, https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.1fc4f0c9.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Yixian_formation.38368557.png 2000w\"> </picture>";


function $d7ca67fc91f325dd$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($9f8ddc77832cd151$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($4eddad9744f193bb$exports))));
}


var $afce11db24263d29$exports = {};

$parcel$export($afce11db24263d29$exports, "marker", function () { return $afce11db24263d29$export$ffc4d0086f1a4c9; });

var $688e8adc548ae5f0$exports = {};
$688e8adc548ae5f0$exports = JSON.parse("{\"coordinates\":[52.2353170879862,7.960040042919843],\"tooltip\":\"Kupferschiefer\",\"title\":\"Kupferschiefer\",\"country\":\"Germany\",\"period\":\"Permian\"}");


var $49376ef24ae02858$exports = {};
$49376ef24ae02858$exports = "<h2>{{title}}</h2><p> Country: {{country}} <br> Period: {{period}} </p><picture> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.0312215e.avif 250w, https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.46772d0d.avif 500w, https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.750b3cf8.avif 1000w, https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.825cb75d.avif 2000w\" type=\"image/avif\"> <source srcset=\"https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.ad4b4c1e.webp 250w, https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.0448adf0.webp 500w, https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.6ad1bdce.webp 1000w, https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.1d919304.webp 2000w\" type=\"image/webp\"> <img class=\"popupimg\" alt=\"{{alt}}\" src=\"https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.e9d3af77.png\" srcset=\"https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.0b7a6b72.png 250w, https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.05ce0aad.png 500w, https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.e9d3af77.png 1000w, https://montanoceratops.github.io/Formations/assets/img/Zechstein_v2.422a4c4d.png 2000w\"> </picture>";


function $afce11db24263d29$export$ffc4d0086f1a4c9() {
    return (0, $76ff08df1ec3a54a$export$46b32044f78fe9b1)((0, (/*@__PURE__*/$parcel$interopDefault($49376ef24ae02858$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($688e8adc548ae5f0$exports))));
}


$6325c75dd85873c8$exports = {
    "Agate": $551ae73cf09ae122$exports,
    "Djadochta": $ca7c5d298d3cf07a$exports,
    "Elliot": $7b335cf6c3b4545f$exports,
    "Gargano": $a3e56486af516883$exports,
    "Gogo": $f2f8136e7501d50e$exports,
    "Hammerschmiede": $789463c0e23b4301$exports,
    "Hornerstown": $b4794cb3d05cf694$exports,
    "Irdin": $b30ff45628b51db8$exports,
    "Ischigualasto": $9fd2106fc0eca13f$exports,
    "Jialingjiang": $f8173caf796d52e9$exports,
    "Joggins": $8fd1bfffffa621c1$exports,
    "Judith": $67b7cd4a40ad2809$exports,
    "Kuanti": $c1a289a79e8af45c$exports,
    "Mammoth": $9f6d1400c175ce76$exports,
    "Monte": $7f9b57a779c9f459$exports,
    "Moth": $fc4f527e1e39e76e$exports,
    "Ocher": $734b3e987c5e2bc0$exports,
    "Patrick": $3880c444ace20af8$exports,
    "Rhynie": $57af23b5ac33cb3f$exports,
    "Seaham": $335490c930f01b5e$exports,
    "Sirius": $3d45c869629979a0$exports,
    "Solnhofen": $9bd783dda143a210$exports,
    "Talara": $3f9f84827c89dd7d$exports,
    "Wadi_al_Hitan": $52529b8ec5b84b3f$exports,
    "archer": $bb291615fed8ace5$exports,
    "bahariya": $a647b9b33f8924f9$exports,
    "ballagan": $dbe33d8db3b3a220$exports,
    "bathans": $2c7f7d7235251256$exports,
    "besano": $db6388a42059b63a$exports,
    "brea": $7707c856ee02adab$exports,
    "bromacker": $19dbfe2edde848d1$exports,
    "bugti": $e25f31563f76b994$exports,
    "burgess": $b8b801ef7f5d834b$exports,
    "cabrieres": $fbdef30fd12f4543$exports,
    "candeleros": $2a8b9c475a44e5b2$exports,
    "chanares": $8ff36a3d410c5a8d$exports,
    "chemnitz": $2704c3925d7347fc$exports,
    "cleveland": $67cf8eb27925fbb0$exports,
    "consthum": $1d3b02c042c39e18$exports,
    "crato": $e827f24006b3f62b$exports,
    "denver": $c225be3320034cff$exports,
    "dino_park": $6b86d8bbb1603e81$exports,
    "ein_yabrud": $96a1d60cae079797$exports,
    "elmo": $21b6c8014d463744$exports,
    "emu": $abdc17920cf7eccf$exports,
    "ermaying": $bf97ab8f001ba275$exports,
    "escuminac": $8d242c4c1ab82436$exports,
    "fezouata": $33b56a8158f582a1$exports,
    "flores": $fc007abdb8ec7ad7$exports,
    "fora": $15df04bf128a8f1c$exports,
    "gigantopithecus": $26b9dab1b8844459$exports,
    "green-river": $5a6e561fc4132102$exports,
    "guimarota": $62bd20ed78051864$exports,
    "gulch": $b95a22ad3d00d796$exports,
    "hanson": $98ba77e52c38e95d$exports,
    "hell-creek": $dd7fa668ec75222b$exports,
    "holocene_nz": $2dbdbc39ec9303c9$exports,
    "hunsr\xfcck": $e631ea827537ee40$exports,
    "jebel": $d71b7dc773904fe4$exports,
    "kimmeridge": $d7f44b55327ddab8$exports,
    "kuldana": $f29222efa675e5ac$exports,
    "las_hoyas": $ab847d4be0844b1d$exports,
    "madagascar": $c72cf730f90d21de$exports,
    "madygen": $e1dd34c0eec5a9d8$exports,
    "maevarano": $cb2c7d22bab26300$exports,
    "mazon": $ec1e78702cae3526$exports,
    "morrison": $7b9e8e884de32ea0$exports,
    "naracoorte": $df2ae991cb4c6f8e$exports,
    "ngorora": $141117b696d747e7$exports,
    "niobrara": $9af30cb1f8c1efa4$exports,
    "paja": $5581e7bed4242734$exports,
    "paratethys": $89ddc0d3bdcbcbde$exports,
    "pebas": $ebe40e689f9eda1c$exports,
    "pierre": $7c80a3ab31e4838d$exports,
    "pisco": $d5b9b8a0610f594d$exports,
    "pleistocene": $677dfc80eb4fa94c$exports,
    "pueblo": $3921427e46298871$exports,
    "remigiusberg": $bda95ae5142ac87b$exports,
    "rio-do-rasto": $5a1ffdd9314dd84b$exports,
    "riversleigh": $be9323c068e21e97$exports,
    "sannine": $36a55de917e7778e$exports,
    "shanwang": $f5af30637a91179b$exports,
    "sicily": $f1ed6420b7474c32$exports,
    "soom": $7ed61183a123ddc8$exports,
    "sulphur": $79fb42b5d4793c6b$exports,
    "tapinocephalus": $fb1f569ee2cf73d2$exports,
    "tiki": $a815b0a1afc76dd1$exports,
    "toolebuc": $93c0cc87bfe54dfd$exports,
    "winton": $2f18d7bf5077ae33$exports,
    "whitewater": $2878f38dee71caad$exports,
    "yixian": $d7ca67fc91f325dd$exports,
    "zechstein": $afce11db24263d29$exports
};


const $fa6676a59dbdaebe$var$options = {
    attributionControl: true,
    zoomControl: true,
    zoomSnap: 0.25,
    zoomDelta: 0.5,
    minZoom: 2,
    wheelPxPerZoomLevel: 120,
    worldCopyJump: true,
    fadeAnimation: true,
    markerZoomAnimation: true,
    zoomAnimation: true,
    zoomAnimationThreshold: 6
};
const $fa6676a59dbdaebe$var$formationsMap = (0, $4b5e7420e94bb43f$exports.map)("map", $fa6676a59dbdaebe$var$options).setView([
    0,
    0
], 2);
// maybe consider https://openfreemap.org/?
(0, $4b5e7420e94bb43f$exports.tileLayer)("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: "<a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors"
}).addTo($fa6676a59dbdaebe$var$formationsMap);
// add all markers
let $fa6676a59dbdaebe$var$markerGroup = (0, $4b5e7420e94bb43f$exports.markerClusterGroup)({
    animate: true,
    animateAddingMarkers: true,
    spiderfyDistanceMultiplier: 4,
    spiderLegPolylineOptions: {
        weight: 4,
        color: "#3388ff",
        opacity: 1,
        fillOpacity: 0.4,
        smoothFactor: 0,
        lineCap: "round",
        lineJoin: "round",
        noClip: true
    },
    polygonOptions: {
        weight: 4,
        color: "#3388ff",
        opacity: 1,
        fillOpacity: 0.4,
        smoothFactor: 0,
        lineCap: "round",
        lineJoin: "round",
        noClip: true
    }
});
Object.values($6325c75dd85873c8$exports).flatMap((work)=>work["marker"]()) // magic
.forEach((marker)=>{
    $fa6676a59dbdaebe$var$markerGroup.addLayer(marker);
});
$fa6676a59dbdaebe$var$formationsMap.addLayer($fa6676a59dbdaebe$var$markerGroup);
// misplaced popup workaround
document.querySelector(".leaflet-popup-pane").addEventListener("load", (event)=>{
    let tagName = event.target.tagName;
    // @ts-ignore
    let popup = $fa6676a59dbdaebe$var$formationsMap._popup; // Currently open popup, if any.
    if ((tagName === "IMG" || tagName === "PICTURE" || tagName === "SOURCE") && popup && !popup["_updated"]) {
        popup["_updated"] = true; // prevent infinite loop
        popup.update();
        setTimeout(()=>{
            popup["_updated"] = undefined;
        }, 1000);
    }
}, true); // Capture the load event, because it does not bubble.

})();
//# sourceMappingURL=index.98467fd8.js.map
